(function () {
    'use strict';

    angular.module('tyallsApp', [
        'ngStorage',
        'ui.router',
        'bsLoadingOverlay',
        'bsLoadingOverlaySpinJs',
        'ui.bootstrap',
        'ngAnimate',
        'ngFileUpload',
        'ngResource',
        'ngMessages',
        'ngCacheBuster',
        'ui.select',
        'ngSanitize',
        'smart-table',
        'ngCookies',
        'angular-cache',
    ])
        .run(run);

    run.$inject = ['$sce',
        '$transitions',
        'stateHandler',
        'bsLoadingOverlayService',
        '$anchorScroll',
        '$http',
        'CacheFactory'
    ];

    function run($sce, $transitions, stateHandler, bsLoadingOverlayService, $anchorScroll, $http, CacheFactory) {
        stateHandler.initialize();

        var cache = CacheFactory('appCache', {
            maxAge: 15 * 60 * 1000, // Items added to this cache expire after 5 minutes
            cacheFlushInterval: 30 * 60 * 1000, // This cache will clear itself every hour
            deleteOnExpire: 'aggressive', // Items will be deleted from this cache when they expire
            storageMode: 'localStorage',
            onExpire: function (key, value) {
                $http.get(key).success(function (data) {
                    cache.put(key, data);
                });
            }
        });

        $http.defaults.cache = cache

        bsLoadingOverlayService.setGlobalConfig({
            templateUrl: 'app/loading-overlay-template.html',
        });

        $anchorScroll.yOffset = 50; // scroll by 50 extra pixels

        $transitions.onStart({}, function (trans) {
            var bsLoadingOverlayService = trans.injector().get('bsLoadingOverlayService');
            bsLoadingOverlayService.start();
            trans.promise.finally(function () {
                bsLoadingOverlayService.stop();
            });
        });

    }
})();


(function() {

  'use strict';

  angular
    .module('tyallsApp')
    .factory('WorkflowInstanceService', WorkflowInstanceService);

  WorkflowInstanceService.$inject = [ '$http' ];

  function WorkflowInstanceService( $http ) {

    var service = {
      getWorkflowInstanceByPropertyAndDueDate: getWorkflowInstanceByPropertyAndDueDate,
      getWorkflowInstanceByProperty: getWorkflowInstanceByProperty,
    };

    return service;

    function getWorkflowInstanceByPropertyAndDueDate( propertyId, dueDate) {
      var url = '/api/properties/' + propertyId + '/workflow-instances/?due-date=' + moment(dueDate).format('YYYY-MM-DD');
      return $http
          .get(url, {cache: false});
    }
    
    function getWorkflowInstanceByProperty( propertyId) {
      var url = '/api/properties/' + propertyId + '/workflow-instances';
      return $http
          .get(url, {cache: false});
    }
  }
})();

(function() {
  'use strict';

  WorkflowDefinitionService.$inject = ['$http', 'Upload', 'getHeaderFilename', '$window', '$document'];

  function WorkflowDefinitionService($http, Upload, getHeaderFilename, $window, $document) {
    var service = {
      query: query,
      save: save,
      createWfd: createWfd,
      getAllWfds: getAllWfds,
      getUploadStream: getUploadStream,
    };

    return service;

    function query() {
      return $http.get('/api/workflow-definitions');
    }

    function getAllWfds() {
      return $http.get('/api/workflow-definitions');
    }

    function getUploadStream(wfdId) {
      // This is used for the BPMN
      return $http.get('/api/workflow-definitions/' + wfdId, {
        responseType:'arraybuffer',
        transformResponse: function(data, headers) {
          return {
            data: data,
            filename: getHeaderFilename(headers)
          };
        }
      })
        .success(function(result) {

          if ($window.navigator.msSaveOrOpenBlob) {
            $window.navigator.msSaveOrOpenBlob(new Blob([result.data]), result.filename);
          }
          else {
            var url = URL.createObjectURL(new Blob([result.data]));
            var a = $document[0].createElement('a');
            a.href = url;
            a.download = result.filename;
            a.target = '_blank';
            a.click();
          }
        })
        .error(function(error) {
          $log.error(error.data);
        });
    }

    function createWfd(wfd) {
      return save(wfd.propertyId, wfd.wfdFile, wfd.dailyState);
    }


    function save(propertyId, file, dailyState) {

      var fields = {
        'propertyId': propertyId,
        'dailyState': dailyState,
        'stitch': false,
      };

      return Upload.upload({
        url: '/api/workflow-definitions',
        fields: fields,
        file: file
      }).progress(function(evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        // $log.info('progress: ', progressPercentage + '% ' + evt.config.file.name);
      }).success(function(data, status, headers, config) {
        // $log.info('file ' + config.file.name + 'uploaded. Response: ' + data);
      });

    }
  }

  angular
    .module('tyallsApp')
    .factory('WorkflowDefinitionService', WorkflowDefinitionService);

})();

(function() {

  'use strict';

  WfiState.$inject = [];

  function WfiState() {

    var _selectedProperty = null;
    var _profile = null;

    var service = {
      getSelectedProperty: getSelectedProperty,
      getProfile: getProfile,
      setSelectedProperty: setSelectedProperty,
      setProfile: setProfile,
    };

    return service;

    function getSelectedProperty() {
      return _selectedProperty;
    }

    function setSelectedProperty(selectedProperty) {
      return _selectedProperty = selectedProperty;
    }

    function getProfile() {
      return _profile;
    }

    function setProfile(profile) {
      return _profile = profile;
    }
  }

  angular
    .module('tyallsApp')
    .factory('WfiState', WfiState);

})();

(function() {
    'uses strict';

    angular
        .module('tyallsApp')
        .factory('Util', Util);

    Util.$inject = [];

    function Util() {

        var service = {
            createDateFromDateTimeArray: createDateFromDateTimeArray
        };

        return service;
       
        /* example data
         * [ 2017, 6, 17, 16, 52, 6, 648000000 ]
         *
         * this was 17 June 2017 at 16:52:06
         */
        function createDateFromDateTimeArray(array) {
            // create a date from a LocalDateTime
            var date = new Date(
                array[0],
                array[1]-1,
                array[2],
                array[3],
                array[4],
                array[5]
            );
            return date;
        }
    }
})();

(function() {
    'uses strict';

    angular
        .module('tyallsApp')
        .factory('PDFJSAnnotate', PdfjsAnnotateFactory);

    PdfjsAnnotateFactory.$inject = ['$window'];

    function PdfjsAnnotateFactory($window) {
        return $window.PDFAnnotate;
    }
})();

(function() {
    'uses strict';

    angular
        .module('tyallsApp')
        .factory('PDFJS', PdfjsFactory);

    PdfjsFactory.$inject = ['$window'];

    function PdfjsFactory($window) {
        return $window.PDFJS;
    }
})();

(function() {

    'use strict';

    angular
        .module('tyallsApp')
        .factory('moment', MomentFactory);

    MomentFactory.$inject = ['$window'];

    function MomentFactory($window) {
        return $window.moment; 
    }
})();

(function() {
  'use strict';

  UserGroupService.$inject = ['$http'];

  function UserGroupService($http) {
    var service = {
      query: query,
      createUserGroup: createUserGroup,
      getWithPropertyId: getWithPropertyId,
    };

    return service;

    function query() {
      // GET /admin/user-groups
      return $http.get('/admin/user-groups');
    }

    function getWithPropertyId(propertyId) {
      return $http.get('/api/properties/' + propertyId + '/user-groups');
    }

    function createUserGroup(userGroup) {
      return $http.post('/admin/user-groups/', userGroup);
    }
  }

  angular
    .module('tyallsApp')
    .factory('UserGroupService', UserGroupService);

})();

(function() {
  'use strict';

  UserService.$inject = ['$http'];
  function UserService($http) {
    var service = {
      get: get,
      query: query,
      disableUser: disableUser, 
      enableUser: enableUser, 
      createUser: createUser, 
      addUserToProperty: addUserToProperty, 
      removeUserFromProperty: removeUserFromProperty, 
      updateUser: updateUser,
      addUserToUserGroup: addUserToUserGroup, 
      removeUserFromUserGroup: removeUserFromUserGroup, 
      listByUserAndProperty: listByUserAndProperty,
      addUserToPropertyProfile: addUserToPropertyProfile, 
      removeUserFromPropertyProfile: removeUserFromPropertyProfile, 
      getWithPropertyId: getWithPropertyId,
      getAuditorsWithPropertyId: getAuditorsWithPropertyId,
      getWithAppAdminPropertyId: getWithAppAdminPropertyId,
    };

    return service;

    function enrich(response, propertyId) {
      // fix up the membership field from the propertyProfiles
      var newResponse = angular.copy(response);
      if (response.data) {

        // loop over users
        angular.forEach(response.data, function (user, index) {
          newResponse.data[index].propertyProfiles = [];
          newResponse.data[index].userGroups = [];
          newResponse.data[index].memberships = [];
          angular.forEach(user.userGroups, function (userGroup) {
            if (propertyId && userGroup.property === propertyId) {
              newResponse.data[index].userGroups.push(angular.copy(userGroup));
            }
          });
          // loop over propertyProfiles
          angular.forEach(user.propertyProfiles, function (propertyProfile) {

            if (propertyId && propertyProfile.propertyId === propertyId) {

              if (propertyProfile.profileName === 'USER') {

                newResponse.data[index].memberships.push(angular.copy(propertyProfile));
              }
              newResponse.data[index].propertyProfiles.push(angular.copy(propertyProfile));
            }
          });
        });
      }
      return newResponse;
    }

    function getWithPropertyId(propertyId) {
      return $http.get('/api/users?propertyId=' + propertyId, {cache: true})
          .then(function (response) {

            var enrichedResponse = enrich(response, propertyId);
            return Promise.resolve(enrichedResponse);
          })
          ;
    }
    
    function getAuditorsWithPropertyId(propertyId) {
      return $http.get('/api/users?propertyId=' + propertyId + "&filter=auditor", {cache: true})
          .then(function (response) {
            var enrichedResponse = enrich(response, propertyId);
            return Promise.resolve(enrichedResponse);
          })
          ;
    }

    function getWithAppAdminPropertyId(propertyId) {
      return $http.get('/admin/users?propertyId=' + propertyId, {cache: true})
          .then(function (response) {

            var enrichedResponse = enrich(response, propertyId);
            return Promise.resolve(enrichedResponse);
          })
          ;
    }
    
    function listByUserAndProperty(propertyId) {
      return $http.get('/api/users?propertyId=' + propertyId, {cache: true});
    }

    function removeUserFromUserGroup(userId, userGroupId) {
      // DELETE /admin/users/userId/user-groups/userGroupId
      return $http.delete('/api/users/' + userId + '/user-groups/' + userGroupId);
    }

    function removeUserFromPropertyProfile(userId, propertyProfileId) {
      // DELETE /admin/users/userId/property-profiles/propertyProfileId
      return $http.delete('/api/users/' + userId + '/property-profiles/' + propertyProfileId);
    }

    function get(id) {
      // GET /api/users/id
      return $http.get('/api/users/' + id, {cache: true});
    }

    function query() {
      // GET /admin/users
      return $http.get('/admin/users', {cache: true});
    }

    function createUser(user) {
      return $http.post('/api/users/', user);
    }
    
    function addUserToProperty(user, property) {
      return $http.put('/api/users/' + user.id + '/properties/' + property.id);
    }
    
    function removeUserFromProperty(user, property) {
      return $http.delete('/api/users/' + user.id + '/properties/' + property.id);
    }

    function updateUser(user) {
      return $http.put('/admin/users/', user);
    }

    function disableUser(user) {
      return $http.put('/admin/users/' + user.id + '/disable');
    }

    function enableUser(user) {
      return $http.put('/admin/users/' + user.id + '/enable');
    }

    function addUserToUserGroup(userId, userGroupId) {
      return $http.put('/api/users/' + userId + '/user-groups/' + userGroupId);
    }

    function addUserToPropertyProfile(userId, propertyProfileId) {
      return $http.put('/api/users/' + userId + '/property-profiles/' + propertyProfileId);
    }
  }

  angular
    .module('tyallsApp')
    .factory('UserService', UserService);

})();

(function() {

  'use strict';

  UploadFileService.$inject = ['$http', '$sce', 'Upload', 'getHeaderFilename', '$log', '$document', 'moment', '$window'];

  function UploadFileService($http, $sce, Upload, getHeaderFilename, $log, $document, moment, $window) {
    var service = {
      addUploadFile: addUploadFile,
      getUploadFile: getUploadFile,
      getUploadStream: getUploadStream,
      handleUpload: handleUpload,
      handleSupportingUpload: handleSupportingUpload,
      deleteSupportingFile: deleteSupportingFile
    };

    return service;

    function getUploadFile(propertyId, uploadFileId) {
      // GET /api/properties/{propertyId}/files/{uploadFileId}
      return $http.get('/api/properties/' + propertyId + '/files/' + uploadFileId, {responseType:'arraybuffer'})
        .then(function onSuccess(response) {
          var file = new Blob([(response.data)], {type: 'application/pdf'});
          var fileURL = URL.createObjectURL(file);
          return $sce.trustAsResourceUrl(fileURL);
          // return file;
        });
    }

    function getUploadStream(propertyId, supportingFileId) {
      // GET /api/properties/{propertyId}/supporting-files/{supportingFileId}
      // This is different from getUploadFile by virtue of not-restricted-to-pdf
      // This is used for the supporting files
      return $http.get('/api/properties/' + propertyId + '/supporting-files/' + supportingFileId, {
        responseType:'arraybuffer',
        transformResponse: function(data, headers) {
          return {
            data: data,
            filename: getHeaderFilename(headers)
          };
        }
      })
        .success(function(result) {

          if ($window.navigator.msSaveOrOpenBlob) {
            $window.navigator.msSaveOrOpenBlob(new Blob([result.data]), result.filename);
          }
          else {
            var url = URL.createObjectURL(new Blob([result.data]));
            var a = $document[0].createElement('a');
            a.href = url;
            a.download = result.filename;
            a.target = '_blank';
            a.click();
          }
        })
        .error(function(error) {
          $log.error(error.data);
        });
    }

    function addUploadFile(file, propertyId, documentRecordId) {
      var url = '/api/properties/' + propertyId + '/document-records/' + documentRecordId;
      var fields = {};
      return handleUploadHelper(file, url, fields);
    }


    function handleUpload(propertyId, workflowId, dueDate, file) {
      // POST /api/files
      var url = '/api/properties/' + propertyId + '/files';
      var fields = { 
        'workflowId': workflowId,
        'dueDate': moment(dueDate).format('YYYY-MM-DD')
      };
      return handleUploadHelper(file, url, fields);
    }

    function handleSupportingUpload(propertyId, documentRecordId, file) {
      // POST /api/properties/{propertyId}/supporting-files
      var url = '/api/properties/' + propertyId + '/supporting-files';
      var fields = { 
        'documentRecordId': documentRecordId 
      };
      return handleUploadHelper(file, url, fields);
    }

    function handleUploadHelper(file, url, fields) {
      return Upload.upload({
        url: url, 
        fields: fields,
        file: file
      }).progress(function(evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        $log.info('progress: ', progressPercentage + '% ' + evt.config.file.name);
      }).success(function(data, status, headers, config) {
        $log.info('file ' + config.file.name + 'uploaded. Response: ' + data);
      });
    }

    function deleteSupportingFile(id) {
      $http.delete('/api/supporting-files' + id)
        .success(function(result) {
        })
        .error(function(error) {
        });
    }
  }

  angular 
    .module('tyallsApp')
    .factory('UploadFileService', UploadFileService);
})();

(function () {

  'use strict';

  TaskDTOService.$inject = ['$http', '$q', 'Util', 'moment'];

  function TaskDTOService($http, $q, Util) {
    var service = {
      getTaskDTO: getTaskDTO,
      completeTask: completeTask,
      getCandidateTasksForGroup: getCandidateTasksForGroup,
      claim: claim
    };

    return service;

    function claim(propertyId, taskId) {
      // PUT /api/properties/{propertyId}/tasks/{taskId}/claim  
      return $http.put('/api/properties/' + propertyId + '/tasks/' + taskId + '/claim');
    }

    function getTaskDTO(propertyId, taskId) {
      // GET /api/properties/{propertyId}/tasks/{taskId}  
      return $http.get('/api/properties/' + propertyId + '/tasks/' + taskId, {cache: false}).then(function (resp) {
            // process the response to parse the dates
            resp.data.dueDate = moment.parseZone(resp.data.dueDate);

            return $q.when(resp);
          }
      );
    }

    function completeTask(propertyId, taskId) {
      // PUT /api/properties/{propertyId}/tasks/{taskId}/complete  
      return $http.put('/api/properties/' + propertyId + '/tasks/' + taskId + '/complete');
    }

    function getCandidateTasksForGroup(groupId) {
      // GET /api/groups/{id}/tasks
      // return $q.when(data);
      return $http.get('/api/groups/' + groupId + '/tasks', {cache: false}).then(function (resp) {
        angular.forEach(resp.data, function (task) {
          task.dueDate = moment.parseZone(task.dueDate);
          task.dueDateString = task.dueDate.format('YYYY-MM-DD')
        });
        return $q.when(resp);

      });
    }

  }

  angular
      .module('tyallsApp')
      .factory('TaskDTOService', TaskDTOService);

})();

(function() {

  'use strict';

  ProcessDefinitionDTOService.$inject = ['$http'];

  function ProcessDefinitionDTOService($http) {
    var service = {
      getAllProcessDefinitionDTO: getAllProcessDefinitionDTO,
      getAllDailyProcessDefinitionDTO: getAllDailyProcessDefinitionDTO,
      getAllNonDailyProcessDefinitionDTO: getAllNonDailyProcessDefinitionDTO,
      getAllProcessDefinitionDTOByDueDate: getAllProcessDefinitionDTOByDueDate,
    };

    return service;

    function getAllProcessDefinitionDTO(propertyId) {
      // GET /api/process-definitions/property/{propertyId}
      return $http.get('/api/process-definitions/property/' + propertyId, {cache: true});
    }
    
    function getAllDailyProcessDefinitionDTO(propertyId) {
      // GET /api/process-definitions/property/{propertyId}
      return $http.get('/api/process-definitions/property/' + propertyId + "?daily-state=DAILY", {cache: true});
    }
    
    function getAllNonDailyProcessDefinitionDTO(propertyId) {
      // GET /api/process-definitions/property/{propertyId}
      return $http.get('/api/process-definitions/property/' + propertyId + "?daily-state=NONDAILY", {cache: true});
    }
    
    function getAllProcessDefinitionDTOByDueDate(propertyId, dueDate) {
      // GET /api/process-definitions/property/{propertyId}
      return $http.get('/api/process-definitions/property/' + propertyId
          + '?due-date=' + moment(dueDate).format('DD-MM-YYYY'), {cache: true}
      );
    }
  }

  angular
    .module('tyallsApp')
    .factory('ProcessDefinitionDTOService', ProcessDefinitionDTOService);
})();


(function () {
    'use strict';

    DailySummaryService.$inject = ['$http', '$filter', '$log'];


    function DailySummaryService($http, $filter, $log) {
        var service = {
            getDailySummary: getDailySummary,

            getDailyTasks: getDailyTasks,
            getDailyTasksReporter: getDailyTasksReporter,
            getDailySummaryForProperty: getDailySummaryForProperty,
            getDailySummaryDetailForProperty: getDailySummaryDetailForProperty,
            getTaskForMention: getTaskForMention,
        };

        return service;

        function getDailySummaryForProperty(propertyId, start, end) {
            // GET /api/properties/{propertyId}/wfi-summary?start={yyyy-mm-dd}&end={yyyy-mm-dd}
            return $http.get('/api/properties/' + propertyId + '/wfi-summary?start=' + start + '&end=' + end, {cache: false}).then(function onSuccess(resp) {
                return processResponse(resp);
            });
        }

        function getDailySummaryDetailForProperty(propertyId, start, end) {
            // GET /api/properties/{propertyId}/wfi-summary-detail?start={yyyy-mm-dd}&end={yyyy-mm-dd}
            return $http.get('/api/properties/' + propertyId + '/wfi-summary-detail?start=' + start + '&end=' + end, {cache: false}).then(function onSuccess(resp) {
                return processResponse(resp);
            }, function onFailure(error) {
                $log.error("Unable to get Daily Summary for " + propertyId);
                $log.error(error);
                return {};
            });
        }

        function getDailySummary(userId, propertyId, start, end) {
            // GET /api/properties/{propertyId}/user-wfi-summary?start={yyyy-mm-dd}&end={yyyy-mm-dd}
            return $http.get('/api/properties/' + propertyId + '/user-wfi-summary?start=' + start + '&end=' + end, {cache: false}).then(function onSuccess(resp) {
                return processResponse(resp);
            }, function onFailure(error) {
                $log.error('oops');
                $log.error(error);
            });
        }

        function getTaskForMention(propertyId, taskId) {
            // GET /api/properties/{propertyId}/user-wfi-summary?id={taskId}
            return $http.get('/api/properties/' + propertyId + '/user-wfi-detail?id=' + taskId, {cache: false}).then(function onSuccess(resp) {
                return resp;
            }, function onFailure(error) {
                $log.error('oops');
                $log.error(error);
            });
        }

        function getDailyTasks(userId, propertyId, date) {
            // GET /api/properties/{propertyId}/user-wfi-detail?date={yyyy-mm-dd}
            return $http.get('/api/properties/' + propertyId + '/user-wfi-detail?date=' + date, {cache: false}).then(function onSuccess(resp) {
                // format dates
                angular.forEach(resp.data, function (task) {

                    task.dueDate = moment().parseZone(task.dueDate);
                });
                return resp;
            }, function onFailure(error) {
                $log.error('oops');
                $log.error(error);
            });
        }

        function getDailyTasksReporter(propertyId, date) {
            // GET /api/properties/{propertyId}/user-wfi-detail?date={yyyy-mm-dd}
            // return $http.get('/api/properties/' + propertyId + '/task-detail?date=' + date).then( function onSuccess(resp) {
            return $http.get('/api/properties/' + propertyId + '/user-wfi-detail?date=' + date + '&reporter=true', {cache: false}).then(function onSuccess(resp) {
                // format dates
                angular.forEach(resp.data, function (task) {
                    task.dueDate = moment().parseZone(task.dueDate);
                });
                return resp;
            }, function onFailure(error) {
                $log.error('oops');
                $log.error(error);
            });
        }

        function processResponse(resp) {
            // process the data to have the correct lookups
            var processedData = {};

            angular.forEach(resp.data, function (value) {
                var modifiedResult = {};

                if (angular.isDefined(typeof value)) {
                    modifiedResult.taskCount = value.taskCount;
                    modifiedResult.wiCount = 0;
                    var wiCompleted = {};
                    var wiNonCompleted = {};
                    var wiOverdue = {};

                    //The below is some magic to get the right time zone data

                    var dueDate = moment.parseZone(value.dueDate);
                    var nowAtProperty = moment().utcOffset(dueDate.utcOffset());
                    var daysTillDue = dueDate.diff(nowAtProperty, 'days');

                    if (value.summaryStatus === 'OUTSTANDING') {


                        if (daysTillDue >= -5) {
                            modifiedResult.summary = 'fa-cogs text-warning';
                        } else {
                            modifiedResult.summary = 'fa-exclamation-triangle text-danger';

                        }
                    }
                    if (value.summaryStatus === 'COMPLETE') {
                        modifiedResult.summary = 'fa-check text-success';
                    }

                    // add original data to modifiedResult
                    modifiedResult.data = value;

                    modifiedResult.data.dueDate = moment.parseZone(value.dueDate);
                    // process the dates to be java Date types
                    angular.forEach(modifiedResult.data.tasks, function (task) {
                        // store keys as unique processInstances; values as whether all task in processInstance are complete
                        var taskDueDate = moment.parseZone(task.dueDate);
                        var daysTillTaskDue = taskDueDate.diff(nowAtProperty, 'days');
                        if (task.completed === true) {
                            wiCompleted[task.processInstanceId] = (wiCompleted[task.processInstanceId] || 0) + 1;
                        } else {
                            if (daysTillTaskDue >= -5) {
                                wiNonCompleted[task.processInstanceId] = (wiNonCompleted[task.processInstanceId] || 0) + 1;

                            } else {
                                wiOverdue[task.processInstanceId] = (wiOverdue[task.processInstanceId] || 0) + 1;

                            }
                        }

                        task.dueDate = taskDueDate;
                    });

                    // summarise the 3 hashes
                    var wiSummary = {};
                    angular.forEach(wiCompleted, function (value, key) {
                        wiSummary[key] = 'COMPLETED';
                    });
                    angular.forEach(wiNonCompleted, function (value, key) {
                        wiSummary[key] = 'NONCOMPLETED';
                    });
                    angular.forEach(wiOverdue, function (value, key) {
                        wiSummary[key] = 'OVERDUE';
                    });

                    modifiedResult.wiCount = Object.keys(wiSummary).length;
                    modifiedResult.wiCompletedCount = countForValue(Object.values(wiSummary), 'COMPLETED');
                    modifiedResult.wiNonCompletedCount = countForValue(Object.values(wiSummary), 'NONCOMPLETED');
                    modifiedResult.wiOverdueCount = countForValue(Object.values(wiSummary), 'OVERDUE');
                }
                var dateString = $filter('date')(modifiedResult.data.dueDate.format('yyyy-MM-DD'), 'yyyy-MM-dd');
                console.log(dateString)
                this[dateString] = modifiedResult;
            }, processedData);

            return processedData;
        }

        function countForValue(arry, value) {
            var result = 0;
            for (var x = 0; x < arry.length; x++) {
                if (arry[x] === value) {
                    result++;
                }
            }
            return result;

        }
    }

    angular
        .module('tyallsApp')
        .factory('DailySummaryService', DailySummaryService);

})();

(function() {
  'use strict';

  ScheduleService.$inject = ['$http'];

  function ScheduleService($http) {
    var service = {
      createSchedule: createSchedule, 
    };

    return service;

    function enrich(response) {
      // fix up the membership field from the propertyProfiles
      var newResponse = angular.copy(response);
      if (response.data) {

        // loop over users
        angular.forEach(response.data, function(user, index) {
          newResponse.data[index].memberships = [];
          // loop over propertyProfiles
          angular.forEach(user.propertyProfiles, function(propertyProfile) {
            if (propertyProfile.profileName === 'USER') {
              newResponse.data[index].memberships.push(angular.copy(propertyProfile));
            } 
          });
        })
      }
      return newResponse;
    }

    function getWithPropertyId(propertyId) {
      return $http.get('/api/users?propertyId=' + propertyId)
        .then( function(response) {

          var enrichedResponse = enrich(response);
          return Promise.resolve(enrichedResponse); 
        })
      ;
    }
    
    function getAuditorsWithPropertyId(propertyId) {
      return $http.get('/api/users?propertyId=' + propertyId + "&filter=auditor")
        .then( function(response) {
          return Promise.resolve(response.data); 
        })
      ;
    }

    function getWithAppAdminPropertyId(propertyId) {
      return $http.get('/admin/users?propertyId=' + propertyId)
        .then( function(response) {

          var enrichedResponse = enrich(response);
          return Promise.resolve(enrichedResponse); 
        })
      ;
    }
    
    function listByUserAndProperty(propertyId) {
      return $http.get('/api/users?propertyId=' + propertyId);
    }

    function removeUserFromUserGroup(userId, userGroupId) {
      // DELETE /admin/users/userId/user-groups/userGroupId
      return $http.delete('/api/users/' + userId + '/user-groups/' + userGroupId);
    }

    function removeUserFromPropertyProfile(userId, propertyProfileId) {
      // DELETE /admin/users/userId/property-profiles/propertyProfileId
      return $http.delete('/api/users/' + userId + '/property-profiles/' + propertyProfileId);
    }

    function get(id) {
      // GET /api/users/id
      return $http.get('/api/users/' + id);
    }

    function query() {
      // GET /admin/users
      return $http.get('/admin/users');
    }

    function createSchedule(schedule) {
      return $http.post('/admin/schedules', schedule);
    }

    function updateUser(user) {
      return $http.put('/admin/users/', user);
    }

    function disableUser(user) {
      return $http.put('/admin/users/' + user.id + '/disable');
    }

    function enableUser(user) {
      return $http.put('/admin/users/' + user.id + '/enable');
    }

    function addUserToUserGroup(userId, userGroupId) {
      return $http.put('/api/users/' + userId + '/user-groups/' + userGroupId);
    }

    function addUserToPropertyProfile(userId, propertyProfileId) {
      return $http.put('/api/users/' + userId + '/property-profiles/' + propertyProfileId);
    }
  }

  angular
    .module('tyallsApp')
    .factory('ScheduleService', ScheduleService);

})();

(function() {
  'use strict';

  PropertyProfileService.$inject = ['$http'];
  function PropertyProfileService($http) {
    var service = {
      getAllPropertyProfilesForAdmin: getAllPropertyProfilesForAdmin,
      query: query,
      getWithPropertyId: getWithPropertyId,
    };

    return service;

    function getWithPropertyId(propertyId) {
      return $http.get('/api/properties/' + propertyId + '/profiles');
    }

    function getAllPropertyProfilesForAdmin() {
      // GET /admin/property-profiles
      return $http.get('/admin/property-profiles');
    }

    function query() {
      return getAllPropertyProfilesForAdmin();
    }
  }

  angular
    .module('tyallsApp')
    .factory('PropertyProfileService', PropertyProfileService);
})();

(function() {
  'use strict';

  PropertyService.$inject = ['$http'];
  function PropertyService($http) {
    var service = {
      getAllPropertiesForUser: getAllPropertiesForUser,
      getAllPropertiesForPropAdmin: getAllPropertiesForPropAdmin,
      getAllPropertiesForAdmin: getAllPropertiesForAdmin,
    };

    return service;

    function getAllPropertiesForUser() {
      // GET /api/properties
      return $http.get('/api/properties', {cache: true});
    }
    
    function getAllPropertiesForPropAdmin() {
      return $http.get('/api/properties?filter=PROP_ADMIN', {cache: true});
    }

    function getAllPropertiesForAdmin() {
      // GET /admin/properties
      return $http.get('/admin/properties', {cache: true});
    }
  }

  angular
    .module('tyallsApp')
    .factory('PropertyService', PropertyService);

})();

(function() {
  'use strict';

  ProfileService.$inject = ['$http'];

  function ProfileService($http) {
    var service = {
      getAllProfilesForUser: getAllProfilesForUser,
      getAllProfilesForAdmin: getAllProfilesForAdmin,
    };

    return service;

    function getAllProfilesForUser() {
      // GET /api/properties
      return $http.get('/api/profiles');
    }

    function getAllProfilesForAdmin() {
      // GET /admin/properties
      return $http.get('/admin/profiles');
    }
  }

  angular
    .module('tyallsApp')
    .factory('ProfileService', ProfileService);
})();

(function() {
  'use strict';

  MentionService.$inject = ['$http'];

  function MentionService($http) {
    var service = {
      query: query,
      markMentionAsRead: markMentionAsRead,
    };

    return service;

    function markMentionAsRead(propertyId, mentionId) {
      return $http
        .put('/api/properties/' + propertyId + '/mentions/' + mentionId + '/read');
    }

    function query(page, limit, showUnreadOnly) {
      return $http.get('/api/mentions?page=' + page + '&limit=' + limit + '&unreadonly=' + showUnreadOnly);
    }
  }

  angular
    .module('tyallsApp')
    .factory('MentionService', MentionService);

})();

(function() {
  'use strict';

  InviteService.$inject = ['$http'];

  function InviteService($http) {
    var service = {
      query: query,
      acceptInvite: acceptInvite,
      getWithPropertyId: getWithPropertyId,
    };

    return service;

    function query() {
      return $http.get('/api/invites');
    }

    function getWithPropertyId(propertyId) {
      return $http.get('/api/properties/' + propertyId + '/invites');
    }

    function acceptInvite(invite) {
      return $http.post('api/properties/invite-user/finish', invite.inviteKey);         
    }
  }

  angular
    .module('tyallsApp')
    .factory('InviteService', InviteService);

})();

(function() {
  'use strict';

  ImageService.$inject = ['$http'];
  function ImageService($http) {
    var service = {
      getImage: getImage,
    };

    return service;

    function getImage(processInstanceId) {
      // GET /admin/profiles
      return $http.get('api/wfd/' + processInstanceId + '/image');
    }
  }

  angular
    .module('tyallsApp')
    .factory('ImageService', ImageService);

})();

(function() {
  'use strict';

  CommentService.$inject = ['$http'];
  
  function CommentService($http) {
    var service = {
      saveComment: saveComment,
    };

    return service;

    function saveComment(propertyId, comment) {
      // POST /api/properties/{propertyId}/comments
      return $http.post('/api/properties/' + propertyId + '/comments', comment);
    }
  }

  angular
    .module('tyallsApp')
    .factory('CommentService', CommentService);

})();

(function() {
  'use strict';

  UserInviteService.$inject = ['$resource'];

  function UserInviteService($resource) {
    var service = $resource('api/properties/invite-user', {}, {});

    return service;
  }

  angular
    .module('tyallsApp')
    .factory('UserInviteService', UserInviteService);
})();

(function() {
  'use strict';

  PrincipalService.$inject = ['$q', 'AccountService', '$filter'];

  function PrincipalService ($q, AccountService, $filter) {
    var _identity,
      _authenticated = false;

    var service = {
      authenticate: authenticate,
      hasAnyAuthority: hasAnyAuthority,
      hasAuthority: hasAuthority,
      isAdmin: isAdmin,
      identity: identity,
      isAuthenticated: isAuthenticated,
      isIdentityResolved: isIdentityResolved,
      hasUsername: hasUsername
    };

    return service;

    function authenticate (identity) {
      _identity = identity;
      _authenticated = identity !== null;
    }

    function hasAnyAuthority (authorities) {
      if (!_authenticated || !_identity || !_identity.authorities) {
        return false;
      }

      for (var i = 0; i < authorities.length; i++) {
        if (_identity.authorities.indexOf(authorities[i]) !== -1) {
          return true;
        }
      }

      return false;
    }

    function hasUsername (username) {
      if (!_authenticated) {
        return $q.when(false);
      }

      return this.identity().then(function(_id) {
        return _id.username && _id.username === username;
      }, function(){
        return false;
      });
    }


    function hasAuthority (authority) {
      if (!_authenticated) {
        return $q.when(false);
      }

      return this.identity().then(function(_id) {
        return _id.propertyProfiles && $filter('filter')(_id.propertyProfiles, {profileName: authority}, true)[0];
      }, function(){
        return false;
      });
    }

    function isAdmin () {
      if (!_authenticated) {
        return $q.when(false);
      }

      return this.identity().then(function(_id) {
        return _id.admin;
      }, function(){
        return false;
      });
    }

    function identity (force) {
      var deferred = $q.defer();

      if (force === true) {
        _identity = undefined;
      }

      // check and see if we have retrieved the identity data from the server.
      // if we have, reuse it by immediately resolving
      if (angular.isDefined(_identity)) {
        deferred.resolve(_identity);

        return deferred.promise;
      }

      // retrieve the identity data from the server, update the identity object, and then resolve.
      AccountService.get().$promise
        .then(getAccountThen)
        .catch(getAccountCatch);

      return deferred.promise;

      function getAccountThen (account) {
        _identity = account.data;
        _authenticated = true;
        deferred.resolve(_identity);
      }

      function getAccountCatch () {
        _identity = null;
        _authenticated = false;
        deferred.resolve(_identity);
      }
    }

    function isAuthenticated () {
      return _authenticated;
    }

    function isIdentityResolved () {
      return angular.isDefined(_identity);
    }
  }

  angular
    .module('tyallsApp')
    .factory('PrincipalService', PrincipalService);

})();

(function() {
  'use strict';

  PasswordResetInitService.$inject = ['$resource'];

  function PasswordResetInitService($resource) {
    var service = $resource('api/account/reset-password/init', {}, {});

    return service;
  }

  angular
    .module('tyallsApp')
    .factory('PasswordResetInitService', PasswordResetInitService);

})();

(function() {
  'use strict';

  PasswordResetFinishService.$inject = ['$resource'];

  function PasswordResetFinishService($resource) {
    var service = $resource('api/account/reset-password/finish', {}, {});

    return service;
  }

  angular
    .module('tyallsApp')
    .factory('PasswordResetFinishService', PasswordResetFinishService);

})();

(function() {
  'use strict';

  isAssignee.$inject = ['PrincipalService'];

  function isAssignee(PrincipalService) {
    var directive = {
      restrict: 'A',
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, element, attrs) {

      attrs.$observe('isAssignee', function(newAssignee) {
        if (angular.isDefined(newAssignee)) {
          var assignee = newAssignee.replace(/\s+/g, '');

          if (assignee.length > 0) {
            defineVisibility(true, assignee);

            scope.$watch(function() {
              return PrincipalService.isAuthenticated();
            }, function() {
              defineVisibility(true, assignee);
            });
          }
        }
      });

      var setVisible = function () {
        element.removeClass('disabled');
      };
      var setHidden = function () {
        element.addClass('disabled');
      };
      var defineVisibility = function (reset, assignee) {

        if (reset) {
          setVisible();
        }

        // get the username from the principal
        PrincipalService.hasUsername(assignee)
          .then(function (result) {
            if (result) {
              setVisible();
            } else {
              setHidden();
            }
          });
      };

    }
  }

  angular
    .module('tyallsApp')
    .directive('isAssignee', isAssignee);

})();

(function() {
  'use strict';

  isAdmin.$inject = ['PrincipalService'];

  function isAdmin(PrincipalService) {
    var directive = {
      restrict: 'A',
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, element, attrs) {

      var setVisible = function () {
        element.removeClass('hidden');
      },
        setHidden = function () {
          element.addClass('hidden');
        },
        defineVisibility = function (reset) {

          if (reset) {
            setVisible();
          }

          // PrincipalService.isAdmin(authority)
          PrincipalService.isAdmin()
            .then(function (result) {
              if (result) {
                setVisible();
              } else {
                setHidden();
              }
            });
        };

      defineVisibility(true);

      scope.$watch(function() {
        return PrincipalService.isAuthenticated();
      }, function() {
        defineVisibility(true);
      });
    }
  }
  
  angular
    .module('tyallsApp')
    .directive('isAdmin', isAdmin);

})();

(function() {
  'use strict';

  hasAuthority.$inject = ['PrincipalService'];

  function hasAuthority(PrincipalService) {
    var directive = {
      restrict: 'A',
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, element, attrs) {
      var authority = attrs.hasAuthority.replace(/\s+/g, '');

      var setVisible = function () {
        element.removeClass('hidden');
      },
        setHidden = function () {
          element.addClass('hidden');
        },
        defineVisibility = function (reset) {

          if (reset) {
            setVisible();
          }

          PrincipalService.hasAuthority(authority)
            .then(function (result) {
              if (result) {
                setVisible();
              } else {
                setHidden();
              }
            });
        };

      if (authority.length > 0) {
        defineVisibility(true);

        scope.$watch(function() {
          return PrincipalService.isAuthenticated();
        }, function() {
          defineVisibility(true);
          // TODO: this is here to force menu icons to refresh
          feather.replace();
        });
      }
    }
  }

  angular
    .module('tyallsApp')
    .directive('hasAuthority', hasAuthority);

})();

(function() {
  'use strict';

  AuthServerProvider.$inject = ['$http', '$localStorage' ];

  function AuthServerProvider ($http, $localStorage ) {
    var service = {
      getToken: getToken,
      hasValidToken: hasValidToken,
      login: login,
      logout: logout
    };

    return service;

    function getToken () {
      var token = $localStorage.authenticationToken;
      return token;
    }

    function hasValidToken () {
      var token = this.getToken();
      return !!token;
    }

    function login (credentials) {
      var data = 'username_param=' + encodeURIComponent(credentials.username) +
        '&password_param=' + encodeURIComponent(credentials.password) +
        '&remember-me=' + credentials.rememberMe + '&submit=Login';
      return $http.post('api/authentication', data, {
        cache: false,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).success(function (response) {
        return response;
      });
    }

    function logout () {


      // logout from the server
      $http.post('api/logout', {cache: false}).success(function (response) {
        delete $localStorage.authenticationToken;
        // to get a new csrf token call the api
        $http.get('api/account', {cache: false});
        return response;
      });

    }
  }
  
  angular
    .module('tyallsApp')
    .factory('AuthServerProvider', AuthServerProvider);

})();

(function () {
    'use strict';


    AuthService.$inject = ['$rootScope',
        '$state',
        '$sessionStorage',
        '$q',
        'PrincipalService',
        'AuthServerProvider',
        'LoginService',
        'PasswordResetInitService',
        'PasswordResetFinishService',
        'CacheFactory'];

    function AuthService($rootScope, $state, $sessionStorage, $q, PrincipalService, AuthServerProvider, LoginService, PasswordResetInitService, PasswordResetFinishService, CacheFactory) {
        var service = {
            authorize: authorize,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
        };

        return service;

        function authorize(force) {
            var authReturn = PrincipalService.identity(force).then(authThen);

            return authReturn;

            function authThen() {
                var isAuthenticated = PrincipalService.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('app.home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !PrincipalService.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('app.accessdenied');
                    } else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('app.accessdenied').then(function () {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function login(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen(data) {
                PrincipalService.identity(true).then(function (account) {
                    deferred.resolve(data);
                });
                var cache = CacheFactory.get("appCache");
                if (cache) {
                    cache.removeAll()
                }
                return cb();
            }

            return deferred.promise;
        }


        function logout() {
            AuthServerProvider.logout();
            PrincipalService.authenticate(null);
            var cache = CacheFactory.get("appCache");
            if (cache) {
                cache.removeAll()
            }
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = {"name": previousStateName, "params": previousStateParams};
            $sessionStorage.previousState = previousState;
        }

        function resetPasswordFinish(keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinishService.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit(mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInitService.save(mail, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }
    }

    angular
        .module('tyallsApp')
        .factory('AuthService', AuthService);
})();

(function() {

  'use strict';

  AccountService.$inject = [ '$resource' ];

  function AccountService( $resource ) {
    var service = $resource('api/account', {}, {
      'get': {
        method: 'GET', params: {}, isArray: false,
        interceptor: {
          response: function (response) {
            // expose response
            return response;
          }
        }
      }
    });
    return service;
  }
  
  angular
    .module('tyallsApp')
    .factory('AccountService', AccountService);
})();

(function () {
    'use strict';

    AuditBasketService.$inject = ['$http'];

    function AuditBasketService($http) {
        var service = {
            listByPropertyId: listByPropertyId,
            listByPropertyIdAndAuditBasketId: listByPropertyIdAndAuditBasketId,
            listByAuditor: listByAuditor,
            saveAuditBasket: saveAuditBasket,
        };

        return service;

        function listByAuditor() {
            return $http.get('/api/audit-baskets', {cache: true});
        }

        function listByPropertyId(propertyId) {
            return $http.get('/api/properties/' + propertyId + '/audit-baskets',
                {cache: true});
        }

        function listByPropertyIdAndAuditBasketId(propertyId, auditBasketId) {
            return $http.get('/api/properties/' + propertyId + '/audit-baskets/' + auditBasketId, {cache: true});
        }

        function saveAuditBasket(propertyId, auditBasket) {
            return $http.post('/api/properties/' + propertyId + '/audit-baskets', auditBasket, {cache: true});
        }
    }

    angular
        .module('tyallsApp')
        .factory('AuditBasketService', AuditBasketService);
})();

(function() {
  'use strict';

  AuditService.$inject = ['$http', 'getHeaderFilename'];

  function AuditService($http, getHeaderFilename) {
    var service = {
      searchAudit: searchAudit,
    };

    return service;

    function searchAudit(criteria, options) {
      // POST /api/audit-query
      var config = {};
      if (!!options && options['format'] === 'pdf') {
        config['headers'] = { 'Accept': 'application/octet-stream' };
        config['responseType'] = 'arraybuffer'
        config['transformResponse'] = function(data, headers) {
          var response = {
            data: data,
            filename: getHeaderFilename(headers)
          };
          return response;
        };
      } else if (!!options && options['format'] === 'csv') {
        config['headers'] = { 'Accept': 'text/csv' };
        config['responseType'] = 'arraybuffer'
        config['transformResponse'] = function(data, headers) {
          var response = {
            data: data,
            filename: getHeaderFilename(headers)
          };
          return response;
        };
      } else {
        config['headers'] = { 'Accept': 'application/json' };
      }
       
      return $http.post('/api/audit-query', criteria, config);
    }
  }

  angular
    .module('tyallsApp')
    .factory('AuditService', AuditService);
})();

(function() {
  'use strict';


  AnnotationService.$inject = ['$http'];
  function AnnotationService($http) {
    var service = {
      saveAnnotation: saveAnnotation,
    };

    return service;

    function saveAnnotation(propertyId, annotation) {
      // POST /api/properties/{propertyId}/annotations
      return $http.post('/api/properties/' + propertyId + '/annotations', annotation);
    }
  }

  angular
    .module('tyallsApp')
    .factory('AnnotationService', AnnotationService);
})();

(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('app.accessdenied', {
                // parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            });
    }
})();

(function () {

    'use strict';

    HomeController.$inject = ['$scope', 'PrincipalService', 'LoginService'];

    function HomeController($scope, PrincipalService, LoginService) {
        var ctrl = this;

        // ctrl.account = null;
        // ctrl.isAuthenticated = null;
        ctrl.login = LoginService.open;

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        ctrl.$onInit = function () {
            getAccount();
        };

        function getAccount() {
            PrincipalService.identity().then(function (account) {
                ctrl.account = account;
                ctrl.isAuthenticated = PrincipalService.isAuthenticated;
            });
        }
    }

    angular.module('tyallsApp')
        .controller('HomeController', HomeController);

})();

/*
 * Routed Component
 */
(function () {

    'use strict';

    var home = {
        templateUrl: 'app/home/home.html',
        bindings: {
            account: '<'
        },
        controller: 'HomeController'
    };

    angular.module('tyallsApp')
        .component('home', home)
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.home', {
                    url: '/',
                    component: 'home',
                    // views: {
                    //   'home@app': home
                    // },
                    data: {
                        authorities: []
                    },
                });

        }]);


    function stateConfig($stateProvider) {

    }
})();

(function () {

    'use strict';

    angular
        .module('tyallsApp')
        .controller('FileuploadController', FileuploadController);

    FileuploadController.$inject = ['Upload', '$log', '$resource'];

    function FileuploadController(Upload, $log, $resource) {
        var vmFile = this;
        vmFile.file = null;
        vmFile.files = [];

        vmFile.upload = upload;
        vmFile.deleteUpload = deleteUpload;

        function deleteUpload(fileupload) {
            var Fileupload = $resource('/api/fileuploads/:id', {});

            Fileupload.delete({id: fileupload.id})
                .$promise
                .then(function () {
                        $log.info('deleted file id: ' + fileupload.id);
                        var index = vmFile.files.indexOf(fileupload);
                        vmFile.files.splice(index, 1);
                    }
                );
        }

        function upload() {
            Upload.upload({
                url: '/api/fileuploads',
                fields: {},
                file: vmFile.file
            }).progress(
                function (evt) {
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    $log.info('progress: ' + progressPercentage + '%');
                }).success(function (data, status, headers, config) {
                vmFile.files.push(data);
                $log.info('file ' + config.file.name + 'uploaded. Response: ' + data);
            });
        }
    }
})();



(function () {

    'use strict';

    WfiSelectorController.$inject = [];

    function WfiSelectorController() {
        var ctrl = this;

        ctrl.$onInit = function () {
        }

        ctrl.$onChanges = function (changes) {
        }

        ctrl.selectTask = function (task) {
            ctrl.onSelectTask({
                task: task
            });
        }
    }

    angular
        .module('tyallsApp')
        .controller('WfiSelectorController', WfiSelectorController);
}());


(function () {
    'use strict';

    var wfiSelector = {
        templateUrl: 'app/entities/shared/wfi-selector/wfi-selector.html',
        bindings: {
            tasks: '<',
            currentTaskDto: '<',
            onSelectTask: '&',
        },

    }

    angular
        .module('tyallsApp')
        .component('wfiSelector', wfiSelector)
    ;
})();

(function () {

    'use strict';

    WfiDetailTabsController.$inject = ['UploadFileService', '$state'];

    function WfiDetailTabsController(UploadFileService, $state) {
        var ctrl = this;

        ctrl.$onInit = function () {
        }


        ctrl.$onChanges = function (changes) {
        }

        ctrl.downloadFile = function (file) {
            UploadFileService.getUploadStream(ctrl.currentTaskDto.propertyId, file.id)
                .then(function onSuccess(response) {
                    ctrl.file = new Blob([(response.data)], {type: 'application/pdf'});
                    ctrl.fileUrl = URL.createObjectURL(ctrl.file);
                }, function onFailure() {
                    $log.error('oops');
                });
        }


        var createComment = function ($event) {
            return ctrl.onCreateComment({
                $event: {
                    comment: $event.comment
                }
            });
        }

        var createSupportingDocument = function ($event) {
            return ctrl.onCreateSupportingDocument({
                $event: {
                    supportingDocument: $event.supportingDocument
                }
            });
        }

        ctrl.goToCreateComment = function () {
            // go to state
            var params = {
                'propertyId': ctrl.currentTaskDto.propertyId,
                'onCreateComment': createComment,
            };

            $state.go('.create-comment-dialog', params);
        }

        ctrl.goToCreateSupportingDocument = function () {
            // go to state
            var params = {
                'propertyId': ctrl.currentTaskDto.propertyId,
                'onCreateSupportingDocument': createSupportingDocument,
            };

            $state.go('.create-supporting-document-dialog', params);
        }

    }

    angular
        .module('tyallsApp')
        .controller('WfiDetailTabsController', WfiDetailTabsController);
}());


(function () {
    'use strict';

    var wfiDetailTabs = {
        templateUrl: 'app/entities/shared/wfi-selector/wfi-detail-tabs.html',
        bindings: {
            currentTaskDto: '<',
            onCreateComment: '&',
            onCreateSupportingDocument: '&',
        },
        controller: 'WfiDetailTabsController',
    }

    angular
        .module('tyallsApp')
        .component('wfiDetailTabs', wfiDetailTabs)
    ;
})();

(function () {

    'use strict';

    CommentConsoleController.$inject = ['UserService'];

    function CommentConsoleController(UserService) {
        var ctrl = this;


        ctrl.$onInit = function () {
            UserService.listByUserAndProperty(ctrl.propertyId).then(function (response) {
                ctrl.idToUserLookup = {};
                angular.forEach(response.data, function (value) {
                    this[value.id] = value;
                }, ctrl.idToUserLookup);
            })
                .catch(function (reason) {
                });
        }

        ctrl.$onChanges = function (changes) {
        }

        ctrl.dumpMentionIds = function (comment) {
            var userIds = [];
            angular.forEach(comment.mentions, function (mention) {
                this.push(ctrl.idToUserLookup[mention.userId].username);
            }, userIds);
            return userIds.join(',');
        }

    }

    angular
        .module('tyallsApp')
        .controller('CommentConsoleController', CommentConsoleController);
}());


(function () {

    'use strict';

    var commentConsole = {
        templateUrl: 'app/entities/shared/wfi-selector/comment-console.html',
        bindings: {
            commentData: '<',
            propertyId: '<',
        },
        controller: 'CommentConsoleController',
    }

    angular
        .module('tyallsApp')
        .component('commentConsole', commentConsole)
    ;
}());

(function () {

    'use strict';

    UploadPrimaryDocumentDialogController.$inject = ['onUploadPrimaryDocument', '$uibModalInstance'];

    function UploadPrimaryDocumentDialogController(onUploadPrimaryDocument, $uibModalInstance) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.newPrimaryDocument = {};

            ctrl.serverMessage = undefined;
            ctrl.onUploadPrimaryDocument = onUploadPrimaryDocument.value;
        }

        ctrl.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        ctrl.save = function () {
            ctrl.isSaving = true;

            ctrl.onUploadPrimaryDocument({
                primaryDocument: ctrl.newPrimaryDocument,
            })
                .then(onSaveSuccess)
                .catch(onSaveError)
                .finally(function () {
                    ctrl.isSaving = false;
                });

        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
        }

        function onSaveError(reason) {
            ctrl.serverMessage = reason.data.message;
        }

    }

    angular.module('tyallsApp')
        .controller('UploadPrimaryDocumentDialogController', UploadPrimaryDocumentDialogController);

})();

/*
 * Modal Routed Component
 */
(function () {
    'use strict'

    angular
        .module('tyallsApp')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.prop.task.upload-primary-document-dialog', {
                    // url: '',  // modal -- no url
                    params: {
                        onUploadPrimaryDocument: null,
                    }, // non-url params
                    resolve: {
                        onUploadPrimaryDocument: ['$transition$', function ($transition$) {
                            return $transition$.params().onUploadPrimaryDocument;
                        }],
                    },
                    onEnter: ['$state', '$uibModal', 'onUploadPrimaryDocument', function ($state, $uibModal, onUploadPrimaryDocument) {
                        $uibModal.open({
                            templateUrl: 'app/entities/shared/upload-primary-document-dialog/upload-primary-document-dialog.html',
                            controller: 'UploadPrimaryDocumentDialogController',
                            controllerAs: '$ctrl',
                            backdrop: 'static',
                            size: 'md',
                            resolve: {
                                onUploadPrimaryDocument: {value: onUploadPrimaryDocument},
                            }
                        }).result.then(function (result) {
                            $state.go('^');
                        }, function () {
                            $state.go('^');
                        });
                    }]
                })
        }]);

}());

(function () {

    'use strict';

    TaskListPrimaryDocumentDialogController.$inject = ['onUploadPrimaryDocument', '$uibModalInstance'];

    function TaskListPrimaryDocumentDialogController(onUploadPrimaryDocument, $uibModalInstance) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.newPrimaryDocument = {};

            ctrl.serverMessage = undefined;
            ctrl.onUploadPrimaryDocument = onUploadPrimaryDocument.value;
        }

        ctrl.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        ctrl.save = function () {
            ctrl.isSaving = true;

            ctrl.onUploadPrimaryDocument({
                primaryDocument: ctrl.newPrimaryDocument,
            })
                .then(onSaveSuccess)
                .catch(onSaveError)
                .finally(function () {
                    ctrl.isSaving = false;
                });

        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
        }

        function onSaveError(reason) {
            ctrl.serverMessage = reason.data.message;
        }

    }

    angular.module('tyallsApp')
        .controller('TaskListPrimaryDocumentDialogController', TaskListPrimaryDocumentDialogController);

})();

/*
 * Modal Routed Component
 */
(function () {
    'use strict'

    angular
        .module('tyallsApp')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.prop.task-list.tasklist-primary-document-dialog', {
                    // url: '',  // modal -- no url
                    params: {
                        onUploadPrimaryDocument: null,
                    }, // non-url params
                    resolve: {
                        onUploadPrimaryDocument: ['$transition$', function ($transition$) {
                            return $transition$.params().onUploadPrimaryDocument;
                        }],
                    },
                    onEnter: ['$state', '$uibModal', 'onUploadPrimaryDocument', function ($state, $uibModal, onUploadPrimaryDocument) {
                        $uibModal.open({
                            templateUrl: 'app/entities/shared/tasklist-primary-document-dialog/tasklist-primary-document-dialog.html',
                            controller: 'TaskListPrimaryDocumentDialogController',
                            controllerAs: '$ctrl',
                            backdrop: 'static',
                            size: 'md',
                            resolve: {
                                onUploadPrimaryDocument: {value: onUploadPrimaryDocument},
                            }
                        }).result.then(function (result) {
                            $state.go('^');
                        }, function () {
                            $state.go('^');
                        });
                    }]
                })
        }]);

}());

(function () {
    'use strict';


    TaskListController.$inject = ['$state',
        'UploadFileService',];

    function TaskListController($state, UploadFileService) {

        var ctrl = this;

        ctrl.$onInit = function () {

            ctrl.currentTaskDTO = null;

            ctrl.onResolveDisabled({
                $event: {
                    disabled: true
                }
            });

            ctrl.onResolveProperties({
                $event: {
                    properties: ctrl.properties
                }
            });

            ctrl.tasks = ctrl.setDetailData(ctrl.tasks);
            console.log("Date " + ctrl.date);
            console.log("Task Date " + ctrl.taskDate);
            ctrl.formatedDate = moment(ctrl.taskDate).format('dddd, MMMM Do YYYY')
        }

        ctrl.doReturn = function () {
            ctrl.returnTo();
        }

        ctrl.doPrevious = function () {
            var previousDate = moment(ctrl.taskDate).subtract(1, "days").format('YYYY-MM-DD');
            ctrl.onIteration({
                date: previousDate
            });
        }

        ctrl.doNext = function () {
            var nextDate = moment(ctrl.taskDate).add(1, "days").format('YYYY-MM-DD');
            ctrl.onIteration({
                date: nextDate
            });
        }

        var returnTo = function (propertyId, date, tasks, onIteration) {
            console.log("Property ID " + propertyId + "Date " + date);
            console.log(tasks);
            return function () {
                $state.go('app.prop.task-list', {
                    'propertyId': propertyId,
                    'date': date,
                    'tasks': tasks,
                    'returnTo': function () {
                        ctrl.doReturn();
                    },
                    'onIteration': onIteration
                });
            }
        };

        ctrl.goToTaskDetail = function (task) {
            //console.log(task);
            //console.log("Task Due Date" +task.dueDate)
            var date = task.dueDate.format('YYYY-MM-DD');
            //console.log("Task Due Date formated " +date)
            $state.go('app.prop.task', {
                'propertyId': ctrl.propertyId,
                'date': date,
                'tasks': new Array(task),
                'returnTo': returnTo(
                    ctrl.propertyId,
                    ctrl.taskDate,
                    ctrl.tasks,
                    ctrl.onIteration),
            });
        }

        ctrl.goToUploadPrimaryDocument = function (task) {
            ctrl.currentTaskDTO = task;
            $state.go('app.prop.task-list.tasklist-primary-document-dialog', {
                propertyId: ctrl.propertyId,
                documentRecordId: task.documentId,
                onUploadPrimaryDocument: ctrl.uploadPrimaryDocument,
            });
        }

        ctrl.uploadPrimaryDocument = function ($event) {
            return UploadFileService.addUploadFile(
                $event.primaryDocument,
                ctrl.currentTaskDTO.propertyId,
                ctrl.currentTaskDTO.documentId
            ).then(function () {
                ctrl.currentTaskDTO.primaryDocument = true;
            });
        }

        ctrl.setDetailData = function (detailData) {
            // need to filter the tasks so that only the most
            // 'relevant' is shown.  This should be the 'head' of
            // the workflow
            var tasks = angular.copy(detailData);
            // group tasks by processId
            var groupedTasks = {};
            angular.forEach(detailData, function (value) {

                value.lastReviewTimestamp = moment(value.lastReviewTimestamp).format('YYYY-MM-DD HH:mm')
                if (!(value.processInstanceId in groupedTasks)) {
                    groupedTasks[value.processInstanceId] = value;
                } else {

                    // populate with latest non completed task
                    if (value.completed === false) {
                        groupedTasks[value.processInstanceId] = value;
                    } else {
                        // true cannot override false
                        var thisTask = groupedTasks[value.processInstanceId];
                        if (thisTask.completed === true && (new Date(thisTask.completedTimestamp) < new Date(value.completedTimestamp))) {
                            groupedTasks[value.processInstanceId] = value;
                        }
                    }
                }

            }, groupedTasks);

            detailData = [];
            for (var o in groupedTasks) {
                detailData.push(groupedTasks[o]);
            }
            return detailData;
        }
    }

    angular
        .module('tyallsApp')
        .controller('TaskListController', TaskListController);
})();

/*
 * Routed Component
 */
(function () {

    'use strict';

    var taskList = {
        templateUrl: 'app/entities/shared/task/task-list.html',
        bindings: {
            onResolveDisabled: '&',   // [UI-VIEW.ATTR]
            onResolveProperties: '&', // [UI-VIEW.ATTR] this is how child state return possible properties to parent
            properties: '<',          // [THIS.RESOLVE] passed in from state.resolve
            propertyId: '<',          // [PARENT.RESOLVE] user selection
            account: '<',             // [THIS.RESOLVE]
            onIteration: '<',         // [THIS.RESOLVE]
            returnTo: '<',            // [THIS.RESOLVE]
            tasks: '<',               // [THIS.RESOLVE]
            taskDate: '<',            // [THIS.RESOLVE]
            // $transition$: '<',
        },
        controller: 'TaskListController',
    }

    angular
        .module('tyallsApp')
        .component('taskList', taskList)
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.prop.task-list', {
                    url: '/:date',
                    views: {
                        'prop@^': 'taskList',
                    },
                    params: {
                        onIteration: null,
                        returnTo: null,
                        tasks: null,
                    }, // non-url params
                    resolve: {
                        properties: ['PropertyService', function (PropertyService) {
                            return PropertyService.getAllPropertiesForUser()
                                .then(function (response) {
                                    return response.data;
                                });
                        }],
                        onIteration: ['$transition$', function ($transition$) {
                            return $transition$.params().onIteration;
                        }],
                        returnTo: ['$transition$', function ($transition$) {
                            return $transition$.params().returnTo;
                        }],
                        tasks: ['$transition$', function ($transition$) {
                            return $transition$.params().tasks;
                        }],
                        taskDate: ['$transition$', function ($transition$) {
                            return $transition$.params().date;
                        }],
                    },
                    data: {
                        authorities: [],
                        pageTitle: 'Task-List',
                    },

                });
        }])
})();

(function () {
    'use strict';

    TaskController.$inject = ['$state',
        '$q',
        'AnnotationService',
        'bsLoadingOverlayService',
        'TaskDTOService',
        'UploadFileService',
        '$location',
        '$anchorScroll',
        'CommentService',
        'CacheFactory'];

    function TaskController($state, $q, AnnotationService,
                            bsLoadingOverlayService, TaskDTOService,
                            UploadFileService, $location, $anchorScroll,
                            CommentService, CacheFactory) {

        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.toggle = true;

            ctrl.onResolveDisabled({
                $event: {
                    disabled: true
                }
            });

            ctrl.onResolveProperties({
                $event: {
                    properties: ctrl.properties
                }
            });

            ctrl.selectTask(ctrl.tasks[0]);
            if (ctrl.account) {
                ctrl.username = ctrl.account.username;
            }
        }

        ctrl.clearCache = function () {
            var cache = CacheFactory.get("appCache");
            if (cache) {
                cache.removeAll()
            }
        }

        ctrl.goToUploadPrimaryDocument = function () {
            $state.go('app.prop.task.upload-primary-document-dialog', {
                propertyId: ctrl.currentTaskDTO.propertyId,
                documentRecordId: ctrl.currentTaskDTO.documentRecord.id,
                onUploadPrimaryDocument: ctrl.uploadPrimaryDocument,
            });
        }

        ctrl.uploadPrimaryDocument = function ($event) {
            return UploadFileService.addUploadFile(
                $event.primaryDocument,
                ctrl.currentTaskDTO.propertyId,
                ctrl.currentTaskDTO.documentRecord.id
            )
                .then(function () {
                    ctrl.selectTask(ctrl.currentTaskDTO);
                });
        }

        ctrl.doReturn = function () {
            ctrl.clearCache();
            ctrl.returnTo();
        }

        ctrl.toggleNav = function () {
            ctrl.toggle = !ctrl.toggle;
        }


        ctrl.doPositiveReview = function () {
            return TaskDTOService
                .completeTask(
                    ctrl.currentTaskDTO.propertyId,
                    ctrl.currentTaskDTO.id)
                .then(function (response) {
                    // update the ctrl.tasks array
                    angular.forEach(ctrl.tasks, function (task) {
                        if (task.id === ctrl.currentTaskDTO.id) {
                            task.completed = true;
                        }
                    });

                    ctrl.doReturn();
                })
                .catch(function (reason) {

                });
        }

        ctrl.createComment = function ($event) {

            $event.comment.createdBy = ctrl.username;
            $event.comment.documentRecord = ctrl.currentTaskDTO.documentRecord.id;

            return CommentService
                .saveComment(
                    ctrl.currentTaskDTO.propertyId,
                    $event.comment)
                .then(function (response) {
                    ctrl.currentTaskDTO.documentRecord.comments.push(response.data);
                });
        }

        ctrl.createSupportingDocument = function ($event) {

            $event.supportingDocument.createdBy = ctrl.username;
            $event.supportingDocument.createdDate = moment().format('YYYY-MM-DDTHH:mm:ss');

            return ctrl.doUpload($event.supportingDocument);
        }

        ctrl.doUpload = function (newSupportingDoc) {
            return UploadFileService
                .handleSupportingUpload(
                    ctrl.currentTaskDTO.propertyId,
                    ctrl.currentTaskDTO.documentRecord.id,
                    newSupportingDoc.selectedFile
                )
                .success(function (response) {
                    ctrl.uploading = false;
                    ctrl.currentTaskDTO.documentRecord.supportingFiles.push(
                        {
                            createdDate: response.createdDate,
                            createdBy: newSupportingDoc.createdBy,
                            id: response.id,
                            filename: response.filename
                        }
                    );
                });
        }

        ctrl.selectTask = function (task) {
            bsLoadingOverlayService.start();

            // populate task summary
            ctrl.currentTaskDTO = task;

            // fetch the taskDTO
            TaskDTOService
                .getTaskDTO(
                    ctrl.currentTaskDTO.propertyId,
                    ctrl.currentTaskDTO.id
                )
                .then(function onTaskDTOSuccess(response) {
                    ctrl.currentTaskDTO = response.data;
                    ctrl.formatedDueDate = ctrl.currentTaskDTO.dueDate.format('D MMM yyyy')

                }, function onTaskDTOFailure(response) {
                    ctrl.currentTaskDTO = null;
                    $log.error('oops1');
                    bsLoadingOverlayService.stop();
                })
                .then(function onSuccess() {

                    // if there is an uploadfile associated with this, fetch it
                    if (!!ctrl.currentTaskDTO.documentRecord.uploadFile) {
                        UploadFileService
                            .getUploadFile(
                                ctrl.currentTaskDTO.propertyId,
                                ctrl.currentTaskDTO.documentRecord.uploadFile.id
                            )
                            .then(function onSuccess(response) {
                                ctrl.currentFileData = response;

                                // scroll into view
                                var newHash = 'review-section';
                                if ($location.hash() !== newHash) {
                                    //                $location.hash('review-section');
                                } else {
                                    $anchorScroll();
                                }

                                bsLoadingOverlayService.stop();
                            }, function onFailure() {
                                $log.error('oops');
                                bsLoadingOverlayService.stop();
                            });
                    }

                    bsLoadingOverlayService.stop();
                });
        }


        ctrl.saveAnnotations = function (annotations) {
            // find the annotations in the currentTaskDTO
            var newAnnotations = annotations.filter(function (el) {
                return el.hasOwnProperty('id') === false;
            });

            var existingAnnotations = annotations.filter(function (el) {
                return el.hasOwnProperty('id') === true;
            });

            // set the uploadFile id
            angular.forEach(newAnnotations, function (value) {
                value.uploadFile = ctrl.currentTaskDTO.documentRecord.uploadFile.id;
            })

            var promises = [];
            for (var i = 0; i < newAnnotations.length; i++) {
                promises.push(AnnotationService.saveAnnotation(ctrl.currentTaskDTO.propertyId, newAnnotations[i]));
            }

            $q.all(promises)
                .then(function onSuccess(values) {

                    angular.forEach(values, function (value) {
                        existingAnnotations.push(value.data);
                    });
                    ctrl.currentTaskDTO.documentRecord.uploadFile.annotations = existingAnnotations;
                });

        }
    }

    angular
        .module('tyallsApp')
        .controller('TaskController', TaskController);
})();

/*
 * Routed Component
 */
(function () {

    'use strict';

    var task = {
        templateUrl: 'app/entities/shared/task/task.html',
        bindings: {
            onResolveDisabled: '&',   // [UI-VIEW.ATTR]
            onResolveProperties: '&', // [UI-VIEW.ATTR] this is how child state return possible properties to parent
            properties: '<',          // [THIS.RESOLVE] passed in from state.resolve
            propertyId: '<',          // [PARENT.RESOLVE] user selection
            account: '<',
            returnTo: '<',
            tasks: '<',
            taskDate: '<',
            // $transition$: '<',
        },
        controller: 'TaskController',
    }

    angular
        .module('tyallsApp')
        .component('task', task)
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.prop.task', {
                    // url: '/{date}',
                    views: {
                        'prop@^': 'task',
                    },
                    params: {
                        date: null,
                        returnTo: null,
                        tasks: null,
                    }, // non-url params
                    resolve: {
                        properties: ['PropertyService', function (PropertyService) {
                            return PropertyService.getAllPropertiesForUser()
                                .then(function (response) {
                                    return response.data;
                                });
                        }],
                        returnTo: ['$transition$', function ($transition$) {
                            return $transition$.params().returnTo;
                        }],
                        tasks: ['$transition$', function ($transition$) {
                            return $transition$.params().tasks;
                        }],
                        taskDate: ['$transition$', function ($transition$) {
                            return $transition$.params().date;
                        }],
                    },
                    data: {
                        authorities: [],
                        pageTitle: 'Task-Day'
                    },

                });
        }])
})();

(function () {
    'use strict';

    SharedController.$inject = ['bsLoadingOverlayService', '$state', 'DailySummaryService', 'moment'];

    function SharedController(bsLoadingOverlayService, $state, DailySummaryService, moment) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.pivotDate = moment();
            ctrl.forceRefresh = false;

            ctrl.onResolveDisabled({
                $event: {
                    disabled: false
                }
            });

            ctrl.onResolveProperties({
                $event: {
                    properties: ctrl.properties
                }
            });
        }

        ctrl.updatePivotDate = function (timestamp) {
            ctrl.pivotDate = timestamp;
        }

        ctrl.fetchReporterSummaryData = function (start, end) {
            return DailySummaryService
                .getDailySummaryForProperty(ctrl.propertyId, start, end);
        }

        ctrl.fetchReviewerSummaryData = function (start, end) {
            return DailySummaryService
                .getDailySummary(ctrl.account.username, ctrl.propertyId, start, end);
        }

        ctrl.selectReviewerDetailDate = function ($event) {
            bsLoadingOverlayService.start();

            // get the tasks
            DailySummaryService
                .getDailyTasks(ctrl.account.username, ctrl.propertyId, $event.date)
                .then(function (resp) {
                    bsLoadingOverlayService.stop();
                    $state.go('app.prop.task-list', {
                        'propertyId': ctrl.propertyId,
                        'date': $event.date,
                        'tasks': resp.data,
                        'returnTo': function () {
                            $state.go('app.prop.reviewer-month');
                        },
                        'onIteration': ctrl.selectReviewerDetailDate
                    });
                });
        }

        ctrl.selectReporterDetailDate = function ($event) {
            bsLoadingOverlayService.start();
            console.log("Reporter")
            DailySummaryService
                .getDailyTasksReporter(ctrl.propertyId, $event.date)
                .then(function (resp) {
                    bsLoadingOverlayService.stop();
                    console.log(resp);
                    $state.go('app.prop.task-list', {
                        'propertyId': ctrl.propertyId,
                        'date': $event.date,
                        'tasks': resp.data,
                        'returnTo': function () {
                            $state.go('app.prop.reporter-month');
                        },
                        'onIteration': ctrl.selectReporterDetailDate
                    });
                });
        }

        ctrl.onClaim = function ($event) {
            ctrl.forceRefresh = !ctrl.forceRefresh;
        }
    }

    angular
        .module('tyallsApp')
        .controller('SharedController', SharedController);
})();

/*
 * Routed Component
 */
(function () {
    'use strict';

    var reviewerMonth = {
        templateUrl: 'app/entities/shared/reviewer-month/reviewer-month.html',
        bindings: {
            onResolveDisabled: '&',   // [UI-VIEW.ATTR]
            onResolveProperties: '&', // [UI-VIEW.ATTR] this is how child state return possible properties to parent
            properties: '<',          // [THIS.RESOLVE] passed in from state.resolve
            propertyId: '<',          // [PARENT.RESOLVE] user selection
            account: '<',             // [THIS.RESOLVE]
        },
        controller: 'SharedController',
    };

    angular
        .module('tyallsApp')
        .component('reviewerMonth', reviewerMonth)
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.prop.reviewer-month', {
                    url: '/reviewer-month',
                    views: {
                        'prop@^': 'reviewerMonth',
                    },
                    data: {
                        authorities: [],
                        pageTitle: 'Reports'
                    },
                    resolve: {
                        properties: ['PropertyService', function (PropertyService) {
                            return PropertyService.getAllPropertiesForUser()
                                .then(function (response) {
                                    return response.data;
                                });
                        }],
                        // refactor this
                        account: ['PrincipalService', function (PrincipalService) {
                            return PrincipalService.identity();
                        }]
                    }
                });
        }]);

}());

(function () {

    'use strict';

    InboxController.$inject = ['$state',
        'TaskDTOService',
        '$q',
        '$log',
        '$filter',
        'CacheFactory'];

    function InboxController($state, TaskDTOService, $q, $log, $filter, CacheFactory) {
        // function InboxController() {
        var ctrl = this;

        ctrl.$onInit = function () {
        }

        ctrl.getGroups = function () {
            return $filter('filter')(ctrl.account.userGroups, {property: ctrl.selectedPropertyIdRefresh}, true);
        }

        ctrl.requestClaimAll = function () {
            var titleText = 'Confirm Claim All';
            var bodyText = 'Are you sure you want to claim these ' + ctrl.inboxTasks.length + " tasks?";
            // confirm that the user actually want this
            $state.go('app.prop.reviewer-month.confirm-claim-all', {
                titleText: titleText,
                bodyText: bodyText,
                onPositiveConfirm: ctrl.claimAll
            });
        }

        ctrl.invalidateCache = function () {
            console.log("Clearing Cache!");
            var cache = CacheFactory.get("appCache");
            if (cache) {
                console.log("Cache Cleared!");
                cache.removeAll()
            }
        }
        ctrl.claimAll = function () {
            // need to return a promise
            var promises = [];
            angular.forEach(ctrl.inboxTasks, function (task) {
                this.push(ctrl.claim(task));
                ctrl.invalidateCache();
            }, promises);

            return $q.all(promises);
        }

        ctrl.claim = function (task) {
            return TaskDTOService.claim(task.propertyId, task.id)
                .then(function () {
                        // remove from the list
                        var index = ctrl.inboxTasks.indexOf(task);
                        ctrl.inboxTasks.splice(index, 1);
                        // propagate this back up to the parent controller
                        ctrl.onClaim({
                            $event: {
                                task: task
                            }
                        });
                        ctrl.invalidateCache();
                    },
                    function () {
                        alert('Unable to claim task, please try again or contact support')
                    }).finally(function () {
                    ctrl.invalidateCache();
                });
        }

        ctrl.$onChanges = function (changes) {
            // if (changes.selectedPropertyIdRefresh && !changes.selectedPropertyIdRefresh.isFirstChange()) {
            if (changes.selectedPropertyIdRefresh.currentValue) {
                ctrl.inboxTasks = [];
                var promisesByGroup = [];

                var filteredUserGroups = ctrl.getGroups();

                angular.forEach(filteredUserGroups, function (userGroup) {
                    $log.debug("UserGroup: ", userGroup);
                    var promise = TaskDTOService.getCandidateTasksForGroup(userGroup.id);
                    this.push({'userGroup': userGroup, 'promise': promise});
                }, promisesByGroup);

                var promises = [];
                angular.forEach(promisesByGroup, function (value) {
                    this.push(value.promise);
                }, promises);

                $q.all(promises)
                    .then(function onSuccess(resp) {
                        // loop over array of results
                        angular.forEach(resp, function (valueArray, index) {
                            // loop over each of the DTOs
                            angular.forEach(valueArray.data, function (taskDTO) {
                                // enrich with group
                                taskDTO.group = promisesByGroup[index].userGroup;
                                this.push(taskDTO);
                            }, ctrl.inboxTasks);
                        });
                    });
            }
        }

    }

    angular
        .module('tyallsApp')
        .controller('InboxController', InboxController);

})();

(function () {
    'use strict'

    var inbox = {
        templateUrl: 'app/entities/shared/reviewer-month/inbox.html',
        bindings: {
            account: '<',
            onClaim: '&',
            selectedPropertyIdRefresh: '<'
        },
        controller: 'InboxController',
    };

    angular
        .module('tyallsApp')
        .component('inbox', inbox);
}());

/*
 * Modal Routed Component
 */
(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.prop.reviewer-month.confirm-claim-all', {
                    // url: '/confirm',  // modal -- no url
                    params: {
                        onPositiveConfirm: null,
                        titleText: null,
                        bodyText: null
                    }, // non-url params
                    resolve: {
                        titleText: ['$transition$', function ($transition$) {
                            return $transition$.params().titleText;
                        }],
                        bodyText: ['$transition$', function ($transition$) {
                            return $transition$.params().bodyText;
                        }],
                        onPositiveConfirm: ['$transition$', function ($transition$) {
                            return $transition$.params().onPositiveConfirm;
                        }]
                    },
                    data: {
                        authorities: []
                    },
                    onEnter: ['onPositiveConfirm', 'titleText', 'bodyText', '$state', '$uibModal', function (onPositiveConfirm, titleText, bodyText, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/components/util/confirm-modal.html',
                            controller: 'ConfirmModalController',
                            controllerAs: '$ctrl',
                            backdrop: 'static',
                            size: 'md',
                            resolve: {
                                // passing native Strings, so need objects
                                titleText: {value: titleText},
                                bodyText: {value: bodyText},
                                onPositiveConfirm: {value: onPositiveConfirm},
                            }
                        }).result.then(function () {
                            // forces a reload, which communicates changes to parent
                            $state.go('^');
                        }, function () {
                            $state.go('^');
                        });
                    }]
                })

        }]);

})();  

/*
 * Routed Component
 */
(function () {
    'use strict';

    var reporterMonth = {
        templateUrl: 'app/entities/shared/reporter-month/reporter-month.html',
        bindings: {
            onResolveDisabled: '&',   // [UI-VIEW.ATTR]
            onResolveProperties: '&', // [UI-VIEW.ATTR] this is how child state return possible properties to parent
            properties: '<',          // [THIS.RESOLVE] passed in from state.resolve
            propertyId: '<',          // [PARENT.RESOLVE] user selection
            account: '<',             // [THIS.RESOLVE]
        },
        controller: 'SharedController',
    };

    angular
        .module('tyallsApp')
        .component('reporterMonth', reporterMonth)
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.prop.reporter-month', {
                    url: '/reporter-month',
                    views: {
                        'prop@^': 'reporterMonth',
                    },
                    data: {
                        authorities: [],
                        pageTitle: 'Reports'
                    },
                    resolve: {
                        properties: ['PropertyService', function (PropertyService) {
                            return PropertyService.getAllPropertiesForUser()
                                .then(function (response) {
                                    return response.data;
                                });
                        }],
                        // refactor this
                        account: ['PrincipalService', function (PrincipalService) {
                            return PrincipalService.identity();
                        }]
                    }
                });
        }]);

}());

(function () {
    'use strict';

    PropController.$inject = ['$state'];

    function PropController($state) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.propertyId = Number(ctrl.propertyId);
        }

        ctrl.selectProperty = function ($event) {
            ctrl.propertyId = Number($event.property);
            // reload with propertyId set
            $state.go($state.current, {propertyId: ctrl.propertyId});
        }

        ctrl.$onChanges = function (changes) {
        }

        // defer whether to disable to the child state (prop-admin or app-admin)
        ctrl.setDisabled = function ($event) {
            ctrl.disabled = $event.disabled;
        }

        // defer the available properties to the child state (prop-admin or app-admin)
        ctrl.setProperties = function ($event) {
            ctrl.properties = $event.properties;
        }
    };

    angular
        .module('tyallsApp')
        .controller('PropController', PropController);
}());

/*
 * Routed Component
 */
(function () {
    'use strict';

    var prop = {
        templateUrl: 'app/entities/shared/prop.html',
        bindings: {
            propertyId: '<',  // [THIS.RESOLVE]
        },
        controller: 'PropController',
    };

    angular
        .module('tyallsApp')
        .component('prop', prop)
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.prop', {
                    abstract: true,   // must always be abstract
                    url: '/prop/:propertyId', // optional
                    params: {
                        propertyId: {
                            squash: true,  // optional
                            value: null,
                            type: 'any',
                        },
                    },
                    component: 'prop',
                    resolve: {
                        propertyId: ['$transition$', function ($transition$) {
                            return $transition$.params().propertyId;
                        }],
                        // DO NOT RESOLVE PROPERTIES HERE
                        // DELEGATE TO CHILD
                    }
                })
        }]);
}());

(function () {

    'use strict';

    PrimaryDocumentViewerController.$inject = ['$timeout', 'CacheFactory'];

    function PrimaryDocumentViewerController($timeout, CacheFactory) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.update = false;
            ctrl.isEditing = false;
            ctrl.isSaving = false;
            ctrl.annotationsToRender = ctrl.savedAnnotations ? ctrl.savedAnnotations.slice() : [];
        };

        ctrl.$onChanges = function (changes) {
            if (changes.savedAnnotations && changes.savedAnnotations.currentValue) {
                ctrl.annotationsToRender = angular.copy(changes.savedAnnotations.currentValue);
            }
        };

        ctrl.clearCache = function () {
            var cache = CacheFactory.get("appCache");
            if (cache) {
                cache.removeAll()
            }
        }

        ctrl.clearUnsavedAnnotations = function () {
            // has this actually changed?
            ctrl.update = true;

            if (ctrl.savedAnnotations.length === ctrl.annotationsToRender.length) return;
            ctrl.annotationsToRender = ctrl.savedAnnotations.slice();
        };

        ctrl.saveAnnotations = function () {
            ctrl.update = false;
            ctrl.isEditing = false;
            ctrl.isSaving = true;
            $timeout(function () {
                    ctrl.onSaveAnnotations({
                        annotations: ctrl.annotationsToRender
                    })
                }, 2000
            ).then(function () {
                ctrl.isSaving = false;
                ctrl.clearCache();
            });
        };

        ctrl.editClick = function () {
            ctrl.isEditing = true;
        };

        ctrl.commentClick = function () {
            ctrl.isEditing = true;
        };

        ctrl.appliedSaveButtonClass = function () {
            if (ctrl.isEditing) {
                return 'btn btn-primary';
            } else {
                return 'btn btn-default';
            }
        }
    }

    angular
        .module('tyallsApp')
        .controller('PrimaryDocumentViewerController', PrimaryDocumentViewerController);
})();


(function () {
    'use strict';

    var primaryDocumentViewer = {
        templateUrl: 'app/entities/shared/primary-document-viewer/primary-document-viewer.html',
        bindings: {
            account: '<',
            savedAnnotations: '<',
            onSaveAnnotations: '&',
            data: '<',
            documentId: '<',
            updateUi: '=',
            isSaving: '=?'
        },
        controller: 'PrimaryDocumentViewerController',
    };

    angular
        .module('tyallsApp')
        .component('primaryDocumentViewer', primaryDocumentViewer)
    ;
})();

(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .directive('myCanvas', myCanvas);

    myCanvas.$inject = ['PDFJS', 'PDFJSAnnotate', '$log', '$timeout'];

    function myCanvas(PDFJS, PDFJSAnnotate, $log, $timeout) {
        return {
            restrict: 'AEC',
            scope: {
                data: '<',
                annotationsToRender: '<',
                documentId: '<',
                updateUi: '=',
                isSaving: '=?'
            },
            link: link
        };

        function link(scope, elem, attr) {

            var UI = PDFJSAnnotate.UI;
            scope.renderedPages = [];
            var PAGE_HEIGHT;
            var FIRST_PAGE_ROTATION;
            var RENDER_OPTIONS = {};
            var okToRender = false;
            var NUM_PAGES = 0;

            // PDFJS.workerSrc = './app/vendor-pdf.js';
            PDFJS.workerSrc = './pdfjs/pdf.worker.js';
            PDFJS.disableWorker = false;
            var worker = new PDFJS.PDFWorker('pdf-worker');

            var tooltype = 'cursor';

            elem.on('$destroy', function () {
                // RENDER_OPTIONS.pdfDocument.destroy();
            });


            scope.$watch('data', function (newVals, oldVals, scope) {

                scope.wasWatched = true;
                var binaryData = newVals;

                // the savedAnnotations is initialised by PrimarryDocumentViewer
                // then updated by PDFJSAnnotate as annotations drawn
                var myService = {
                    documentId: scope.documentId,
                    savedAnnotations: scope.annotationsToRender
                };

                // get/update the store adapter
                PDFJSAnnotate.setStoreAdapter(new PDFJSAnnotate.MyLocalStoreAdapter(myService));

                RENDER_OPTIONS.documentId = scope.documentId;
                RENDER_OPTIONS.pdfDocument = null;
                RENDER_OPTIONS.scale = 1;
                RENDER_OPTIONS.rotate = 0;
                RENDER_OPTIONS.binaryData = binaryData;

                // reset the document to top
                NUM_PAGES = 0;
                scope.renderedPages = [];
                okToRender = false;
                var currentPage = document.getElementById('viewer').dataset.currentPage;
                render(true, currentPage);
            });

            scope.$watchGroup(['data', 'annotationsToRender'],
                function (newVals, oldVals, scope) {

                    if (scope.wasWatched) {
                        scope.wasWatched = false;
                        return;
                    }

                    var binaryData = newVals[0];

                    // the savedAnnotations is initialised by PrimarryDocumentViewer
                    // then updated by PDFJSAnnotate as annotations drawn
                    var myService = {
                        documentId: scope.documentId,
                        savedAnnotations: scope.annotationsToRender
                    };

                    // get/update the store adapter
                    PDFJSAnnotate.setStoreAdapter(new PDFJSAnnotate.MyLocalStoreAdapter(myService));

                    RENDER_OPTIONS.documentId = scope.documentId;
                    RENDER_OPTIONS.pdfDocument = null;
                    RENDER_OPTIONS.scale = 1;
                    RENDER_OPTIONS.rotate = 0;
                    RENDER_OPTIONS.binaryData = binaryData;

                    // reset the document to top
                    NUM_PAGES = 0;
                    scope.renderedPages = [];
                    okToRender = false;

                    if (scope.updateUi) {
                        render(true);
                    }
                    scope.isSaving = false;
                });


            // ----------START ROTATE/SCALE STUFF----------
            (function () {
                function setScaleRotate(scale, rotate) {
                    scale = parseFloat(scale, 10);
                    rotate = parseInt(rotate, 10);

                    if (RENDER_OPTIONS.scale !== scale || RENDER_OPTIONS.rotate !== rotate) {
                        RENDER_OPTIONS.scale = scale;
                        RENDER_OPTIONS.rotate = rotate;

                        scope.renderedPages = [];  // reset the cached pages
                        render();
                    }
                }

                function handleScaleChange(e) {
                    setScaleRotate(e.target.value, RENDER_OPTIONS.rotate);
                }

                function handleRotateRightClick() {
                    setScaleRotate(RENDER_OPTIONS.scale, RENDER_OPTIONS.rotate + 90);
                }

                function handleRotateLeftClick() {
                    setScaleRotate(RENDER_OPTIONS.scale, RENDER_OPTIONS.rotate - 90);
                }

                document.querySelector('.toolbar-container select#scale').selected = RENDER_OPTIONS.scale;
                document.querySelector('.toolbar-container select#scale').addEventListener('change', handleScaleChange);
                document.querySelector('.toolbar-container #rotateButtonLeft').addEventListener('click', handleRotateLeftClick);
                document.querySelector('.toolbar-container #rotateButtonRight').addEventListener('click', handleRotateRightClick);
            })();
            // ----------END ROTATE/SCALE STUFF----------

            // ----------START TOOLBAR STUFF----------
            (function () {

                var tooltype = 'cursor';
                if (tooltype) {
                    setActiveToolbarItem(tooltype, document.querySelector('.toolbar-container button[data-tooltype=cursor]'));
                }


                function setActiveToolbarItem(type, button) {
                    var active = document.querySelector('.toolbar-container button.active');
                    if (active) {
                        active.classList.remove('active');

                        switch (tooltype) {
                            case 'cursor':
                                UI.disableEdit();
                                break;
                            case 'point':
                                UI.disablePoint();
                                break;
                            case 'area':
                                UI.disableRect();
                                break;
                        }
                    }
                    if (button) {
                        button.classList.add('active');
                    }

                    // update last used type
                    tooltype = type;

                    switch (type) {
                        case 'cursor':
                            UI.enableEdit();
                            break;
                        case 'point':
                            UI.enablePoint();
                            break;
                        case 'area':
                            UI.enableRect(type);
                            break;
                    }
                }

                function handleToolbarClick(e) {
                    if (e.target.nodeName === 'BUTTON') {
                        setActiveToolbarItem(e.target.getAttribute('data-tooltype'), e.target);
                    }
                }

                document.querySelector('.toolbar-container').addEventListener('click', handleToolbarClick);
            })();
            // ----------END TOOLBAR STUFF----------

            // ----------START SCROLL STUFF----------
            (function () {

                function handleScroll(e) {
                    // var margin = 600;
                    var margin = 100;
                    var visiblePageNum = Math.round((e.target.scrollTop + margin) / PAGE_HEIGHT) + 1;
                    var visiblePage = document.querySelector('.page[data-page-number="' + visiblePageNum + '"][data-loaded="false"]');

                    if (Number.isNaN(visiblePageNum) === false && scope.renderedPages.indexOf(visiblePageNum) === -1) {
                        okToRender = true;
                        scope.renderedPages.push(visiblePageNum);
                    } else {
                        okToRender = false;
                    }
                    document.getElementById('viewer').dataset.currentPage = visiblePageNum;
                    if (visiblePage && okToRender) {
                        $timeout(function () {
                            UI.renderPage(visiblePageNum, RENDER_OPTIONS);
                        });
                    }
                }

                document.getElementById('content-wrapper').addEventListener('scroll', handleScroll);
            })();

            // ----------END SCROLL STUFF-----------

            function setDefaultVisiblePage() {
                var margin = 50;
                var currentHeight = document.getElementById('content-wrapper').scrollTop;
                var visiblePageNum = Math.round((currentHeight + margin) / PAGE_HEIGHT) + 1;
                if (Number.isNaN(visiblePageNum)) {
                    visiblePageNum = 1;
                }
                return visiblePageNum;
            }

            function scrollToPage(pageNumber) {
                var visiblePageNum = pageNumber;
                if (visiblePageNum) {
                    var margin = 50;
                    var currentHeight = document.getElementById('content-wrapper').scrollTop;
                    visiblePageNum = Math.round((currentHeight + margin) / PAGE_HEIGHT) + 1;
                }
                var newScroll = currentHeight - ((visiblePageNum - 1) * (PAGE_HEIGHT - 155));
                document.getElementById('content-wrapper').scrollTop = newScroll;
            }

            function render(initScroll, intiPage) {

                var loadingTask = PDFJS.getDocument({
                    url: RENDER_OPTIONS.binaryData,
                    worker: worker,
                });
                loadingTask.promise.then(function (pdf) {

                    var visiblePageNum = setDefaultVisiblePage();

                    if (intiPage) {
                        scrollToPage(intiPage);
                    } else if (initScroll) {
                        document.getElementById('content-wrapper').scrollTop = 0;
                    } else {
                        scrollToPage();
                    }
                    document.getElementById('viewer').dataset.currentPage = visiblePageNum;

                    RENDER_OPTIONS.pdfDocument = pdf;

                    var viewer = document.getElementById('viewer');
                    viewer.innerHTML = '';
                    NUM_PAGES = pdf.pdfInfo.numPages;
                    for (var i = 0; i < NUM_PAGES; i++) {
                        var pageNum = i + 1;
                        var page = UI.createPage(pageNum);
                        viewer.appendChild(page);
                    }

                    scope.renderedPages.push(visiblePageNum);

                    UI.renderPage(visiblePageNum, RENDER_OPTIONS).then(function (results) {
                        var pdfPage = results[0];
                        var annotations = results[1];

                        var viewport = pdfPage.getViewport(RENDER_OPTIONS.scale, RENDER_OPTIONS.rotate);
                        // set height to be height of page 1
                        PAGE_HEIGHT = viewport.height;
                        if (pdfPage.pageInfo.rotate !== 0) {
                            PAGE_HEIGHT = viewport.width;
                        }
                    }).then(function () {
                        if (scope.firstRender) {
                            scope.firstRender = false;
                        }
                    });
                });
            }

        }
    }
})();

(function () {

    'use strict';

    SharedDateCreateSupportingDocumentDialogController.$inject = [
        'onCreateSupportingDocument',
        '$uibModalInstance',
        'CacheFactory'];

    function SharedDateCreateSupportingDocumentDialogController(onCreateSupportingDocument, $uibModalInstance, CacheFactory) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.newSupportingDoc = {};

            ctrl.serverMessage = undefined;
            ctrl.onCreateSupportingDocument = onCreateSupportingDocument.value;
        }

        ctrl.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        ctrl.save = function () {
            ctrl.isSaving = true;

            ctrl.onCreateSupportingDocument({
                supportingDocument: ctrl.newSupportingDoc,
            })
                .then(onSaveSuccess)
                .catch(onSaveError)
                .finally(function () {
                    ctrl.isSaving = false;
                    ctrl.clearCache();
                });

        }

        ctrl.clearCache = function () {
            var cache = CacheFactory.get("appCache");
            if (cache) {
                cache.removeAll()
            }
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
        }

        function onSaveError(reason) {
            ctrl.serverMessage = reason.data.message;
        }

    }

    angular.module('tyallsApp')
        .controller('SharedDateCreateSupportingDocumentDialogController', SharedDateCreateSupportingDocumentDialogController);

})();

/*
 * Modal Routed Component
 */
(function () {
    'use strict'

    angular
        .module('tyallsApp')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.prop.task.create-supporting-document-dialog', {
                    // url: '',  // modal -- no url
                    params: {
                        propertyId: null,
                        onCreateSupportingDocument: null,
                    }, // non-url params
                    resolve: {
                        onCreateSupportingDocument: ['$transition$', function ($transition$) {
                            return $transition$.params().onCreateSupportingDocument;
                        }],
                        propertyId: ['$transition$', function ($transition$) {
                            return $transition$.params().propertyId;
                        }],
                    },
                    onEnter: ['$state', '$uibModal', 'onCreateSupportingDocument', 'propertyId', function ($state, $uibModal, onCreateSupportingDocument, propertyId) {
                        $uibModal.open({
                            templateUrl: 'app/entities/shared/create-supporting-document-dialog/shared-date-create-supporting-document-dialog.html',
                            controller: 'SharedDateCreateSupportingDocumentDialogController',
                            controllerAs: '$ctrl',
                            backdrop: 'static',
                            size: 'md',
                            resolve: {
                                candidates: ['UserService', function (UserService) {
                                    return UserService.listByUserAndProperty(propertyId).then(function (resp) {
                                        return resp.data;
                                    });
                                }],
                                onCreateSupportingDocument: {value: onCreateSupportingDocument},
                            }
                        }).result.then(function (result) {
                            // onCreateSupportingDocument({
                            //   supportingDocument: result
                            // });
                            $state.go('^');
                        }, function () {
                            $state.go('^');
                        });
                    }]
                })
        }]);

}());

(function () {

    'use strict';

    SharedDateCreateCommentDialogController.$inject = ['onCreateComment',
        '$uibModalInstance',
        'candidates',
        'CacheFactory'];

    function SharedDateCreateCommentDialogController(onCreateComment, $uibModalInstance, candidates, CacheFactory) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.candidates = candidates;

            ctrl.newComment = {
                createdDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
                mentions: []
            };

            ctrl.serverMessage = undefined;
            ctrl.onCreateComment = onCreateComment.value;
        }

        ctrl.clearCache = function () {
            var cache = CacheFactory.get("appCache");
            if (cache) {
                cache.removeAll()
            }
        }

        ctrl.addMention = function (mention) {
            ctrl.newComment.mentions.push(mention);
        }

        ctrl.deleteMention = function (mention) {
            var idx = ctrl.newComment.mentions.map(function (e) {
                return e.userId;
            }).indexOf(mention.userId);
            if (idx >= 0) {
                ctrl.newComment.mentions.splice(idx, 1);
            }
        }

        ctrl.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        ctrl.save = function () {
            ctrl.isSaving = true;

            ctrl.onCreateComment({
                comment: ctrl.newComment,
            })
                .then(onSaveSuccess)
                .catch(onSaveError)
                .finally(function () {
                    ctrl.isSaving = false;
                    ctrl.clearCache();
                });
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
        }

        function onSaveError(reason) {
            ctrl.serverMessage = reason.data.message;
        }
    }

    angular.module('tyallsApp')
        .controller('SharedDateCreateCommentDialogController', SharedDateCreateCommentDialogController);

})();

/*
 * Modal Routed Component
 */
(function () {
    'use strict'

    angular
        .module('tyallsApp')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.prop.task.create-comment-dialog', {
                    // url: '',  // modal -- no url
                    params: {
                        propertyId: null,
                        onCreateComment: null,
                    }, // non-url params
                    resolve: {
                        onCreateComment: ['$transition$', function ($transition$) {
                            return $transition$.params().onCreateComment;
                        }],
                        propertyId: ['$transition$', function ($transition$) {
                            return $transition$.params().propertyId;
                        }],
                    },
                    onEnter: ['$state', '$uibModal', 'onCreateComment', 'propertyId', 'UserService', function ($state, $uibModal, onCreateComment, propertyId, UserService) {
                        $uibModal.open({
                            templateUrl: 'app/entities/shared/create-comment-dialog/shared-date-create-comment-dialog.html',
                            controller: 'SharedDateCreateCommentDialogController',
                            controllerAs: '$ctrl',
                            backdrop: 'static',
                            size: 'md',
                            resolve: {
                                candidates: ['UserService', function (UserService) {
                                    return UserService.listByUserAndProperty(propertyId).then(function (resp) {
                                        return resp.data;
                                    });
                                }],
                                onCreateComment: {value: onCreateComment},
                            }
                        }).result.then(function (result) {
                            // onCreateComment({
                            //   comment: result
                            // });
                            $state.go('^');
                        }, function () {
                            $state.go('^');
                        });
                    }]
                })
        }]);
}());

(function () {

    'use strict';

    MentionListController.$inject = ['$filter'];

    function MentionListController($filter) {
        var ctrl = this;
        ctrl.filteredCandidates = [];

        ctrl.$onInit = function () {
            ctrl.filteredCandidates = angular.copy(ctrl.candidates);
            ctrl.filteredCandidates = $filter('filter')(ctrl.filteredCandidates, {enabled: true});
        }

        ctrl.$onChanges = function (changes) {
        }

        ctrl.deleteMention = function (userId) {
            var deleteMention = {
                userId: userId
            }
            ctrl.onDeleteMention({mention: deleteMention});
            ctrl.filteredCandidates = $filter('candidatesFilter')(ctrl.candidates, ctrl.mentions);
        }

        ctrl.addMention = function (userId) {
            var newMention = {
                userId: userId
            };
            ctrl.onAddMention({mention: newMention});
            ctrl.filteredCandidates = $filter('candidatesFilter')(ctrl.candidates, ctrl.mentions);
        }

    }

    angular
        .module('tyallsApp')
        .controller('MentionListController', MentionListController);
}());


(function () {

    'use strict';

    var mentionList = {
        templateUrl: 'app/entities/shared/create-comment-dialog/mention-list.html',
        bindings: {
            candidates: '<',
            mentions: '<',
            onAddMention: '&',
            onDeleteMention: '&',
        },
        controller: 'MentionListController',
    }

    angular
        .module('tyallsApp')
        .component('mentionList', mentionList)
    ;
})();

(function () {

    'use strict';

    MentionInputController.$inject = [];

    function MentionInputController() {
        var ctrl = this;

        ctrl.userId = '';

        ctrl.addMention = function () {
            ctrl.onAddMentionUserId({userId: ctrl.userId});
        }
    }

    angular
        .module('tyallsApp')
        .controller('MentionInputController', MentionInputController);
}());


(function () {

    'use strict';

    var mentionInput = {
        templateUrl: 'app/entities/shared/create-comment-dialog/mention-input.html',
        bindings: {
            onAddMentionUserId: '&',
            candidates: '<'
        },
        controller: 'MentionInputController',
    }

    angular
        .module('tyallsApp')
        .component('mentionInput', mentionInput)
    ;
})();

(function () {

    'use strict';

    MentionDetailController.$inject = ['$filter'];

    function MentionDetailController($filter) {
        var ctrl = this;

        ctrl.delete = function () {
            ('calling MentionDetailController: %o', ctrl.mention.userId);
            ctrl.onDeleteMentionUserId({userId: ctrl.mention.userId});
        }

        ctrl.getUsernameFromId = function (id) {

            var results = $filter('filter')(ctrl.idToUserLookup, {id: id}, true);
            return results[0].username;
        }
    }

    angular
        .module('tyallsApp')
        .controller('MentionDetailController', MentionDetailController);
}());


(function () {

    'use strict';

    var mentionDetail = {
        templateUrl: 'app/entities/shared/create-comment-dialog/mention-detail.html',
        bindings: {
            mention: '<',
            onDeleteMentionUserId: '&',
            idToUserLookup: '<',
        },
        controller: 'MentionDetailController',
    }

    angular
        .module('tyallsApp')
        .component('mentionDetail', mentionDetail)
    ;
})();

(function () {

    'use strict';


    angular
        .module('tyallsApp')
        .filter('candidatesFilter', candidatesFilter);

    candidatesFilter.$inject = [];

    function candidatesFilter() {
        return function (collection, params) {
            return collection.filter(function (item) {
                // filter each item against existing selected mentions
                return params.filter(function (mention) {
                    return item.id === mention.userId;
                }).length > 0 ? false : true;
            });
        }
    }
}());

(function () {

    'use strict';

    SummaryCardRepController.$inject = [];

    function SummaryCardRepController() {
        var ctrl = this;

        ctrl.selectDetailDate = function (date) {
            ctrl.onSelectDetailDate({date: date});
        }
    }

    angular
        .module('tyallsApp')
        .controller('SummaryCardRepController', SummaryCardRepController);
}());


(function () {
    'use strict';

    var summaryCardRep = {
        templateUrl: 'app/entities/shared/calendar-rep/summary-card-rep.html',
        bindings: {
            day: '<',
            dailyTaskCount: '<',
            nonDailyTaskCount: '<',
            summary: '<',
            onSelectDetailDate: '&'
        },
        controller: 'SummaryCardRepController',
    }

    angular
        .module('tyallsApp')
        .component('summaryCardRep', summaryCardRep)
    ;
})();

(function () {
    'use strict'

    CalendarRepController.$inject = ['moment', '$log', 'bsLoadingOverlayService'];

    function CalendarRepController(moment, $log, bsLoadingOverlayService) {
        var ctrl = this;

        ctrl.$onInit = function () {
            _activate();
        }

        function _activate() {
            ctrl.selected = ctrl.pivotDate; // scope bound to controller
            ctrl.selected = _removeTimeAndSetSunday(ctrl.selected || moment());
            // ctrl.navMonth = ctrl.selected.clone();
            ctrl.navMonth = ctrl.selected;

            var start = ctrl.selected.clone();
            start.date(1);
            _removeTimeAndSetSunday(start.day(0));

            // build the month
            _buildMonth(start.clone(), ctrl.navMonth.clone())
                .then(function processSummaryCardData(data) {
                    ctrl.processedData = data;
                });
        }

        ctrl.selectDetailDate = function (date) {
            ctrl.onSelectDetailDate({
                $event: {
                    date: date,
                }
            });
        }

        ctrl.$onChanges = function (changes) {
            if (changes.forceRefresh && !changes.forceRefresh.isFirstChange()) {
                _activate();
            }
            if (changes.selectedPropertyIdRefresh && !changes.selectedPropertyIdRefresh.isFirstChange()) {
                _activate();
            }
        }


        // ---------- PRIVATE FUNCTIONS -----------
        // scope.select = function(day) {
        //     scope.selected = day.date;
        // };

        ctrl.next = function () {
            var next = ctrl.navMonth.clone();
            _removeTimeAndSetSunday(next.month(next.month() + 1).date(1));
            ctrl.navMonth.month(ctrl.navMonth.month() + 1);
            _buildMonth(next, ctrl.navMonth)
                .then(function processSummaryCardData(data) {
                    ctrl.processedData = data;
                });
        };

        ctrl.previous = function () {
            var previous = ctrl.navMonth.clone();
            _removeTimeAndSetSunday(previous.month(previous.month() - 1).date(1));
            ctrl.navMonth.month(ctrl.navMonth.month() - 1);
            _buildMonth(previous, ctrl.navMonth)
                .then(function processSummaryCardData(data) {
                    ctrl.processedData = data;
                });
        }

        function _removeTimeAndSetSunday(date) {
            return date.day(0).hour(0).minute(0).second(0).millisecond(0);
        }

        function _buildMonth(datePointer, navMonth) {

            ctrl.weeks = []; // reset the weeks
            var done = false;
            var monthIndex = datePointer.month();
            var count = 0;
            var startDate = datePointer.clone();
            var endDate;
            while (!done) {
                ctrl.weeks.push({days: _buildWeek(datePointer.clone(), navMonth.clone())});
                datePointer.add(1, "w");
                done = count++ > 2 && monthIndex !== datePointer.month(); // do at least 4 iterations and month boundary crossed in this iteration
                monthIndex = datePointer.month();  // update the logic to track month boundary crossed
            }

            // endDate needs updating
            endDate = datePointer.subtract(1, "d");

            // fetch the summary data
            bsLoadingOverlayService.start();
            return ctrl.getSummaryDataCb({
                start: startDate.format('YYYY-MM-DD'),
                end: endDate.format('YYYY-MM-DD')
            })
                .then(function onSuccess(resp) {
                    bsLoadingOverlayService.stop();
                    return resp;
                }, function onFailure() {
                    bsLoadingOverlayService.stop();
                    $log.error('ouch');
                });
        }

        function _buildWeek(datePointer, month) {
            var days = [];
            for (var i = 0; i < 7; i++) {
                days.push({
                    // name: datePointer.format("dd").substring(0,1),
                    name: datePointer.format("YYYY-MM-DD"),
                    number: datePointer.date(),
                    isCurrentMonth: datePointer.month() === month.month(),
                    isToday: datePointer.isSame(new Date(), "day"),
                    date: datePointer
                });
                datePointer = datePointer.clone();
                datePointer.add(1, "d");
            }
            return days;
        }
    }

    angular
        .module('tyallsApp')
        .controller('CalendarRepController', CalendarRepController);
}());

(function () {
    'use strict';

    var calendarRep = {
        templateUrl: 'app/entities/shared/calendar-rep/calendar-rep.html',
        bindings: {
            propertyId: '<',
            pivotDate: '<',
            onUpdatePivotDate: '&',
            getSummaryDataCb: '&',
            onSelectDetailDate: '&',
            selectedPropertyIdRefresh: '<',
            forceRefresh: '<',
        },
        controller: 'CalendarRepController',
    }

    angular
        .module('tyallsApp')
        .component('calendarRep', calendarRep);
})();

(function() {

  'use strict';
  
  UserGroupCardListController.$inject = ['$state'];

  function UserGroupCardListController($state) {
    var ctrl = this; 
    
    ctrl.goToAddUserGroup = function() {
      $state.go('.add-user-group-dialog', {
        'id': ctrl.user.id,
        'user': ctrl.user,
        'propertyId': ctrl.propertyId,
        'onSuccessfulEdit': addUserGroup,
      });
    }

    ctrl.removeUserGroup = function($event) {
      return ctrl.onRemoveUserGroup({
        $event: {
          userId : ctrl.user.id,
          userGroupId : $event.userGroupId,
        }
      });
    }

    var addUserGroup = function($event) {
      return ctrl.onAddUserGroup({
        $event: {
          userId : ctrl.user.id,
          userGroup : $event.userGroup,
        }
      });
    }
  }

  angular
    .module('tyallsApp')
    .controller('UserGroupCardListController', UserGroupCardListController);
}());


(function() {

  'use strict';

  var userGroupCardList = {
    templateUrl: 'app/entities/prop-admin/user-console/user-group-card-list.html',
    bindings: {
      userGroups: '<',
      user: '<',
      onRemoveUserGroup: '&',
      onAddUserGroup: '&',
      propertyId: '<'
    },
    controller: 'UserGroupCardListController',
  }

  angular
    .module('tyallsApp')
    .component('userGroupCardList', userGroupCardList); 
  ;
}());

(function() {

  'use strict';

  UserGroupCardController.$inject = ['$state'];

  function UserGroupCardController($state) {
    var ctrl = this; 
    
    ctrl.requestRemoveUserGroup = function(userGroup) {
      var titleText = 'Confirm User Group removal';
      var bodyText = 'Are you sure you want to remove user (' + ctrl.user.username + ') from group (' + userGroup.name + ')?';
      // confirm that the user actually want this
      $state.go('.confirm-remove-user-group-dialog', {
        titleText: titleText,
        bodyText: bodyText,
        onPositiveConfirm: ctrl.removeUserGroup
      });  
    }
    
    ctrl.removeUserGroup = function($event) {
      return ctrl.onRemoveUserGroup({
        $event: {
          userGroupId: ctrl.userGroup.id,
        }
      });
    }
  }

  angular
    .module('tyallsApp')
    .controller('UserGroupCardController', UserGroupCardController);
}());


(function() {

  'use strict';

  var userGroupCard = {
    templateUrl: 'app/entities/prop-admin/user-console/user-group-card.html',
    bindings: {
      user: '<',
      userGroup: '<',
      onRemoveUserGroup: '&'
    },
    controller: 'UserGroupCardController',
  }

  angular
    .module('tyallsApp')
    .component('userGroupCard', userGroupCard);
  ;
}());

(function() {

  'use strict';

  UserContainerController.$inject = [];

  function UserContainerController() {
    var ctrl = this; 

    ctrl.$onInit = function() {
      ctrl.doRowFilter = false;
      ctrl.sortType = 'username';  // set the default sort type
      ctrl.sortReverse = false;    // set the default sort order
      ctrl.searchFilter = '';      // set the default search/filter term
    }

    ctrl.removeUserFromUserGroup = function($event) {
      return ctrl.onRemoveUserGroup({
        $event: {
          userId: $event.userId,
          userGroupId: $event.userGroupId,
        }
      });
    }
    
    ctrl.removeUserFromPropertyProfile = function($event) {
      return ctrl.onRemovePropertyProfile({
        $event: {
          userId: $event.userId,
          propertyProfileId: $event.propertyProfileId,
        }
      });
    }

    ctrl.addUserToUserGroup = function($event) {
      return ctrl.onAddUserGroup({
        $event: {
          userId: $event.userId,
          userGroup: $event.userGroup,
        }
      });
    }

    ctrl.addUserToPropertyProfile = function($event) {
      return ctrl.onAddPropertyProfile({
        $event: {
          userId: $event.userId,
          propertyProfile: $event.propertyProfile,
        }
      });
    }
  }

  angular
    .module('tyallsApp')
    .controller('UserContainerController', UserContainerController);
}());

(function() {

  'use strict';

  var userContainer = {
    templateUrl: 'app/entities/prop-admin/user-console/user-container.html',
    bindings: {
      users: '<',
      propertyId: '<',
      onRemovePropertyProfile: '&',
      onRemoveUserGroup: '&',
      onAddPropertyProfile: '&',
      onAddUserGroup: '&',
    },
    controller: 'UserContainerController',
  }
  
  angular
    .module('tyallsApp')
    .component('userContainer', userContainer)
  ;
}());

(function() {

  'use strict';

  UserConsoleController.$inject = ['UserService'];

  function UserConsoleController(UserService, users) {
    var ctrl = this;

    ctrl.$onInit = function () {
      if (users) {
        ctrl.users = users;
        console.log('Users in ' + users);
      }
    }

    ctrl.$onChanges = function (changes) {
      if (changes.propertyId) {
        UserService.getWithPropertyId(ctrl.propertyId)
            .then(function (response) {
              ctrl.users = response.data;
            })
            .catch()
        ;
      }

    }

  }

  angular
    .module('tyallsApp')
    .controller('UserConsoleController', UserConsoleController);
}());


(function() {

  'use strict';

  var userConsole = {
    templateUrl: 'app/entities/prop-admin/user-console/user-console.html',
    bindings: {
      propertyId: '<',         // [PARENT.RESOLVE]
    },
    controller: 'UserConsoleController',
  }

  angular
    .module('tyallsApp')
    .component('userConsole', userConsole)
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('app.prop.prop-admin.user-console', {
          url: '/users',
          redirectTo: 'app.prop.prop-admin.user-console.list-user',
          views: {
            'user-console@^': {
              component: 'userConsole',
            }
          },
        })

    }]);
}());

(function() {

  'use strict';

  PropertyProfileCardListController.$inject = ['$state'];

  function PropertyProfileCardListController($state) {
    var ctrl = this; 
    
    ctrl.goToAddPropertyProfile = function() {
      $state.go('.add-property-profile-dialog', {
        'id': ctrl.user.id,
        'user': ctrl.user,
        'propertyId': ctrl.propertyId,
        'onSuccessfulEdit': addPropertyProfile,
      });
    }

    ctrl.removePropertyProfile = function($event) {
      return ctrl.onRemovePropertyProfile({
        $event: {
          userId : ctrl.user.id,
          propertyProfileId : $event.propertyProfileId,
        }
      }); 
    }
    
    var addPropertyProfile = function($event) {
      return ctrl.onAddPropertyProfile({
        $event: {
          userId : ctrl.user.id,
          propertyProfile : $event.propertyProfile,
        }
      })
      ; 
    }
  }

  angular
    .module('tyallsApp')
    .controller('PropertyProfileCardListController', PropertyProfileCardListController);
}());


(function() {

  'use strict';

  var propertyProfileCardList = {
    templateUrl: 'app/entities/prop-admin/user-console/property-profile-card-list.html',
    bindings: {
      propertyProfiles: '<',
      user: '<',
      onRemovePropertyProfile: '&',
      onAddPropertyProfile: '&',
      propertyId: '<'
    },
    controller: 'PropertyProfileCardListController',
  }

  angular
    .module('tyallsApp')
    .component('propertyProfileCardList', propertyProfileCardList); 
  ;
}());

(function() {

  'use strict';

  PropertyProfileCardController.$inject = ['$state'];

  function PropertyProfileCardController($state) {
    var ctrl = this; 

    ctrl.requestRemovePropertyProfile = function(propertyProfile) {
      var titleText = 'Confirm Property Profile removal';
      var bodyText = 'Are you sure you want to remove user (' + ctrl.user.username + ') from property profile (' + propertyProfile.profileName + ')?';
      // confirm that the user actually want this
      $state.go('.confirm-remove-property-profile-dialog', {
        titleText: titleText,
        bodyText: bodyText,
        onPositiveConfirm: ctrl.removePropertyProfile
      });  
    }

    ctrl.removePropertyProfile = function($event) {
      return ctrl.onRemovePropertyProfile({
        $event: {
          propertyProfileId: ctrl.propertyProfile.id
        }
      });
    }
  }

  angular
    .module('tyallsApp')
    .controller('PropertyProfileCardController', PropertyProfileCardController);
}());


(function() {

  'use strict';

  var propertyProfileCard = {
    templateUrl: 'app/entities/prop-admin/user-console/property-profile-card.html',
    bindings: {
      user: '<',
      propertyProfile: '<',
      onRemovePropertyProfile: '&'
    },
    controller: 'PropertyProfileCardController',
  }

  angular
    .module('tyallsApp')
    .component('propertyProfileCard', propertyProfileCard)
  ;
}());

(function() {
  
  'use strict';

  MembershipCardListController.$inject = [];

  function MembershipCardListController() {
    var ctrl = this; 

    ctrl.$onInit = function() {
    }

  }

  angular
    .module('tyallsApp')
    .component('membershipCardList', {
      templateUrl: 'app/entities/prop-admin/user-console/membership-card-list.html',
      bindings: {
        memberships: '<',
      },
      controller: MembershipCardListController,
    }
    );
}());

(function() {
  
  'use strict';

  MembershipCardController.$inject = [];

  function MembershipCardController() {
    var ctrl = this; 
  }

  angular
    .module('tyallsApp')
    .component('membershipCard', {
      templateUrl: 'app/entities/prop-admin/user-console/membership-card.html',
      bindings: {
        membership: '<',
      },
      controller: MembershipCardController,
    }
    );
}());

(function () {

    'use strict';

    ListUserController.$inject = ['UserService', '$q'];

    function ListUserController(UserService, $q) {
        var ctrl = this;

        ctrl.$onInit = function () {
        }

        ctrl.$onChanges = function (changes) {
        }

        // cb -- let caller handle catch
        ctrl.removePropertyProfile = function ($event) {
            return UserService.removeUserFromPropertyProfile($event.userId, $event.propertyProfileId)
                .then(function (response) {
                    angular.forEach(ctrl.users, function (outerValue) {
                        if (outerValue.id === response.data.id) {  // matched user
                            angular.forEach(outerValue.propertyProfiles, function (innerValue, index) {
                                if (innerValue.id === $event.propertyProfileId) {
                                    outerValue.propertyProfiles.splice(index, 1);
                                }

                            })
                        }
                    });
                });
        }

        // cb -- let caller handle catch
        ctrl.removeUserGroup = function ($event) {
            return UserService.removeUserFromUserGroup($event.userId, $event.userGroupId)
                .then(function (response) {
                    angular.forEach(ctrl.users, function (outerValue) {
                        if (outerValue.id === response.data.id) {  // matched user
                            angular.forEach(outerValue.userGroups, function (innerValue, index) {
                                if (innerValue.id === $event.userGroupId) {
                                    outerValue.userGroups.splice(index, 1);
                                }

                            })
                        }
                    })
                });
        }

        // cb -- let caller handle catch
        ctrl.addPropertyProfile = function ($event) {
            return UserService.addUserToPropertyProfile($event.userId, $event.propertyProfile.id)
                .then(function (response) {
                    angular.forEach(ctrl.users, function (outerValue) {
                        if (outerValue.id === $event.userId) {  // matched user
                            var exists = false;
                            angular.forEach(outerValue.propertyProfiles, function (innerValue, index) {
                                if (innerValue.id === $event.propertyProfile.id) {
                                    exists = true;
                                }
                            });
                            if (!exists) outerValue.propertyProfiles.push($event.propertyProfile);
                        }
                    });
                });
        }

        // cb -- let caller handle catch
        ctrl.addUserGroup = function ($event) {
            return UserService.addUserToUserGroup($event.userId, $event.userGroup.id)
                .then(function (response) {
                    angular.forEach(ctrl.users, function (outerValue) {
                        if (outerValue.id === $event.userId) {  // matched user
                            var exists = false;
                            angular.forEach(outerValue.userGroups, function (innerValue, index) {
                                if (innerValue.id === $event.userGroup.id) {
                                    exists = true;
                                }
                            });
                            if (!exists) outerValue.userGroups.push($event.userGroup);
                        }
                    })
                });
        }
    }

    angular
        .module('tyallsApp')
        .controller('ListUserController', ListUserController);
}());


/*
* Routed Component
*/
(function() {

  'use strict';

  var listUser = {
    templateUrl: 'app/entities/prop-admin/user-console/list-user.html',
    bindings: {
      propertyId: '<',         // [PARENT.RESOLVE]
      users: '<',              // [UI-VIEW.ATTR] 
    },
    controller: 'ListUserController',
  }

  angular
    .module('tyallsApp')
    .component('listUser', listUser)
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('app.prop.prop-admin.user-console.list-user', {
          // url: '/users',
          data: {
            authorities: [],
            pageTitle: 'User Console'
          },
          views: {
            'user-console-content@^': {
              component: 'listUser',
            }
          },
        })

    }]);
}());

/*
 * Modal Routed Component
 */
(function() {
  'use strict';

  angular
    .module('tyallsApp')
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('app.prop.prop-admin.user-console.list-user.confirm-remove-user-group-dialog', {
          // url: '',  // modal -- no url
          params: {
            onPositiveConfirm: null,
            titleText: null,
            bodyText: null,
          }, // non-url params
          resolve: {
            titleText: ['$transition$', function($transition$) {
              return $transition$.params().titleText;
            }],
            bodyText: ['$transition$', function($transition$) {
              return $transition$.params().bodyText;
            }],
            onPositiveConfirm: ['$transition$', function($transition$) {
              return $transition$.params().onPositiveConfirm;
            }]
          },
          data: {
            authorities: []
          },
          onEnter: ['onPositiveConfirm', 'titleText', 'bodyText', '$state', '$uibModal', function(onPositiveConfirm, titleText, bodyText, $state, $uibModal) {
            $uibModal.open({   
              templateUrl: 'app/components/util/confirm-modal.html',
              controller: 'ConfirmModalController',
              controllerAs: '$ctrl',
              backdrop: 'static',   
              size: 'md',      
              resolve: {
                // passing native Strings, so need objects
                titleText: { value: titleText },
                bodyText: { value: bodyText },
                onPositiveConfirm: { value: onPositiveConfirm },
              }                
            }).result.then(function() {
              $state.go('^');
            }, function() {    
              $state.go('^');  
            });
          }]
        }) 

    }]);

})();  

/*
 * Modal Routed Component
 */
(function() {
  'use strict';

  angular
    .module('tyallsApp')
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('app.prop.prop-admin.user-console.list-user.confirm-remove-property-profile-dialog', {
          // url: '',  // modal -- no url
          params: {
            onPositiveConfirm: null,
            titleText: null,
            bodyText: null,
          }, // non-url params
          resolve: {
            titleText: ['$transition$', function($transition$) {
              return $transition$.params().titleText;
            }],
            bodyText: ['$transition$', function($transition$) {
              return $transition$.params().bodyText;
            }],
            onPositiveConfirm: ['$transition$', function($transition$) {
              return $transition$.params().onPositiveConfirm;
            }]
          },
          data: {
            authorities: []
          },
          onEnter: ['onPositiveConfirm', 'titleText', 'bodyText', '$state', '$uibModal', function(onPositiveConfirm, titleText, bodyText, $state, $uibModal) {
            $uibModal.open({   
              templateUrl: 'app/components/util/confirm-modal.html',
              controller: 'ConfirmModalController',
              controllerAs: '$ctrl',
              backdrop: 'static',   
              size: 'md',      
              resolve: {
                // passing native Strings, so need objects
                titleText: { value: titleText },
                bodyText: { value: bodyText },
                onPositiveConfirm: { value: onPositiveConfirm },
              }                
            }).result.then(function() {
              $state.go('^');
            }, function() {    
              $state.go('^');  
            });
          }]
        }) 

    }]);

})();  

(function() {
  'use strict';

  AddUserGroupDialogController.$inject = ['onSuccessfulEdit', 'user', '$uibModalInstance', 'availableGroups', '$filter'];

  function AddUserGroupDialogController (onSuccessfulEdit, user, $uibModalInstance, availableGroups, $filter) {
    var ctrl = this;

    ctrl.$onInit = function() {

      ctrl.serverMessage = undefined;
      ctrl.user = user.value;
      ctrl.onSuccessfulEdit = onSuccessfulEdit.value;

      ctrl.availableGroups = filterGroups(availableGroups, ctrl.user.userGroups);
    }

    function filterGroups(availableGroups, filterGroups) {
      var filtered = [];
      for (var arr in availableGroups) {
        var found = false;
        for (var filter in filterGroups) {
          if (filterGroups[filter].id === availableGroups[arr].id) {
            found = true;
            break;
          }
        };
        if (!found) filtered.push(availableGroups[arr]);
      };

      return filtered;
    }

    ctrl.clear = function() {
      $uibModalInstance.dismiss('cancel');
    }

    ctrl.save = function() {
      ctrl.isSaving = true;

      ctrl.onSuccessfulEdit({
        userGroup: ctrl.userGroup,
      })
        .then(onSaveSuccess)
        .catch(onSaveError)
        .finally(function() {
          ctrl.isSaving = false;
        });
    }

    function onSaveSuccess (result) {
      $uibModalInstance.close(result);
    }

    function onSaveError (reason) {
      ctrl.serverMessage = reason.data.message;
    }

  }

  angular
    .module('tyallsApp')
    .controller('AddUserGroupDialogController', AddUserGroupDialogController);
})();

/*
 * Modal Routed Component
 */
(function() {
  'use strict';

  angular
    .module('tyallsApp')
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider 
        .state('app.prop.prop-admin.user-console.list-user.add-user-group-dialog', {
          // url: '',  // modal -- no url
          params: { 
            user: null,
            propertyId: null,
            onSuccessfulEdit: null,
          }, // non-url params
          resolve: {
            user: ['$transition$', function($transition$) {
              return $transition$.params().user;
            }],
            propertyId: ['$transition$', function($transition$) {
              return $transition$.params().propertyId;
            }],
            onSuccessfulEdit: ['$transition$', function($transition$) {
              return $transition$.params().onSuccessfulEdit;
            }]
          },
          data: {
            authorities: []
          },
          onEnter: ['onSuccessfulEdit', 'user', 'propertyId', '$state', '$uibModal', function(onSuccessfulEdit, user, propertyId, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'app/entities/prop-admin/user-console/dialogs/add-user-group/add-user-group-dialog.html',
              controller: 'AddUserGroupDialogController',
              controllerAs: '$ctrl',
              backdrop: 'static',
              size: 'md',
              resolve: {
                availableGroups: [ 'UserGroupService', function(UserGroupService) {
                  return UserGroupService.getWithPropertyId(propertyId)
                    .then(function(response) {
                      return response.data;
                    });
                }],
                user: { value: user },
                onSuccessfulEdit: { value: onSuccessfulEdit },
              }
            }).result.then(function(response) {
              // onSuccessfulEdit({
              //   userGroup: response,
              // });
              $state.go('^');
            }, function(reason) {
              $state.go('^');
            });
          }]
        })
    }])
})();

(function() {
  'use strict';

  AddPropertyProfileDialogController.$inject = ['onSuccessfulEdit', 'user', '$uibModalInstance', 'availablePropertyProfiles',  '$filter'];

  function AddPropertyProfileDialogController(onSuccessfulEdit, user, $uibModalInstance, availablePropertyProfiles, $filter) {
    var ctrl = this;

    ctrl.$onInit = function() {

      ctrl.serverMessage = undefined;
      ctrl.user = user.value;
      ctrl.onSuccessfulEdit = onSuccessfulEdit.value;
      
      ctrl.availablePropertyProfiles = filterPropertyProfiles(availablePropertyProfiles, ctrl.user.propertyProfiles);
    }

    function filterPropertyProfiles(availablePropertyProfiles, filterPropertyProfiles) {
      var filtered = [];
      for (var arr in availablePropertyProfiles) {
        var found = false;
        for (var filter in filterPropertyProfiles) {
          if (filterPropertyProfiles[filter].id === availablePropertyProfiles[arr].id) {
            found = true;
            break;
          }
        };
        if (!found) filtered.push(availablePropertyProfiles[arr]);
      };

      return filtered;
    }

    ctrl.clear = function() {
      $uibModalInstance.dismiss('cancel');
    }

    ctrl.save = function() {
      ctrl.isSaving = true;

      ctrl.onSuccessfulEdit({
        propertyProfile: ctrl.propertyProfile,
      })
        .then(onSaveSuccess)
        .catch(onSaveError)
        .finally(function() {
          ctrl.isSaving = false;
        });
    }
    
    function onSaveSuccess (result) {
      $uibModalInstance.close(result);
    }

    function onSaveError (reason) {
      ctrl.serverMessage = reason.data.message;
    }

  }

  angular
    .module('tyallsApp')
    .controller('AddPropertyProfileDialogController', AddPropertyProfileDialogController);
})();

/*
 * Modal Routed Component
 */
(function() {
  'use strict';

  angular
    .module('tyallsApp')
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider 
        .state('app.prop.prop-admin.user-console.list-user.add-property-profile-dialog', {
          // url: '',  // modal -- no url
          params: { 
            user: null,
            propertyId: null,
            onSuccessfulEdit: null,
          }, // non-url params
          data: {
            authorities: []
          },
          resolve: {
            user: ['$transition$', function($transition$) {
              return $transition$.params().user;
            }],
            propertyId: ['$transition$', function($transition$) {
              return $transition$.params().propertyId;
            }],
            onSuccessfulEdit: ['$transition$', function($transition$) {
              return $transition$.params().onSuccessfulEdit;
            }]
          },
          onEnter: ['$filter', 'onSuccessfulEdit', 'user', 'propertyId', '$state', '$uibModal', function($filter, onSuccessfulEdit, user, propertyId, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'app/entities/prop-admin/user-console/dialogs/add-property-profile/add-property-profile-dialog.html',
              controller: 'AddPropertyProfileDialogController',
              controllerAs: '$ctrl',
              backdrop: 'static',
              size: 'md',
              resolve: {
                availablePropertyProfiles: [ 'PropertyProfileService', function(PropertyProfileService) {
                  return PropertyProfileService.getWithPropertyId(propertyId)
                    .then(function(response) {
                      return $filter('removeUnassignableProfiles')(response.data);
                    });
                }],
                user: { value: user },
                onSuccessfulEdit: { value: onSuccessfulEdit },
              }
            }).result.then(function(response) {
              $state.go('^');
            }, function(reason) {
              $state.go('^');
            });
          }]
        });

    }]);

})();

(function() {
  'use strict';

  PropAdminController.$inject = [];

  function PropAdminController() {
    var ctrl = this;

    ctrl.$onInit = function() {

      ctrl.onResolveDisabled({
        $event: {
          disabled: false
        }
      });

      ctrl.onResolveProperties({
        $event: {
          properties: ctrl.properties
        }
      });
    }

    ctrl.$onChanges = function(changes) {
    }
  }

  angular
    .module('tyallsApp')
    .controller('PropAdminController', PropAdminController);
})();

/*
 * Routed Component
 */
(function() {
  'use strict';

  var propAdmin = {
    templateUrl: 'app/entities/prop-admin/prop-admin.html',
    bindings: {
      onResolveDisabled: '&',   // [UI-VIEW.ATTR]
      onResolveProperties: '&', // [UI-VIEW.ATTR] this is how child state return possible properties to parent
      properties: '<',          // [THIS.RESOLVE] passed in from state.resolve 
      propertyId: '<',          // [PARENT.RESOLVE] user selection, inherited from app.prop
    },
    controller: 'PropAdminController'
  };

  angular
    .module('tyallsApp')
    .component('propAdmin', propAdmin)
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('app.prop.prop-admin', {
          url: '/prop-admin',
          redirectTo: 'app.prop.prop-admin.user-console',
          views: {
            'prop@^' : 'propAdmin',
          },
          data: {
            authorities: [],
            pageTitle: 'PropAdmin'
          },
          resolve: {
            // override the property list fetched in parent
            properties: [ 'PropertyService', function(PropertyService) {
              return PropertyService.getAllPropertiesForPropAdmin()
                .then(function(response) {
                  return response.data; 
                });
            }],
          }
        })

    }]);
})();

(function() {

  'use strict';

  ListAuditorController.$inject = [ 'UserService', '$filter' ];

  function ListAuditorController( UserService, $filter ) {
    var ctrl = this; 

    ctrl.$onInit = function() {
      ctrl.auditors = [];
    }

    ctrl.$onChanges = function(changes) {
      if (changes.propertyId) {
        UserService.getAuditorsWithPropertyId(changes.propertyId.currentValue)
          .then(function(response) {
            ctrl.auditors = response.data;
          })
          .catch(function(reason) {
            console.log(reason);      
          });
      }
    }


  }

  angular
    .module('tyallsApp')
    .controller('ListAuditorController', ListAuditorController);
}());

/*
 * Routed Component
 */
(function() {

  'use strict';

  var listAuditor = {
    templateUrl: 'app/entities/prop-admin/auditor-console/list-auditor.html',
    bindings: {
      propertyId: '<',  // [UI-VIEW.ATTR]
    },
    controller: 'ListAuditorController',
  }
  
  angular
    .module('tyallsApp')
    .component('listAuditor', listAuditor)
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('app.prop.prop-admin.auditor-console.list-auditor', {
          url: '/auditors',
          data: {
            authorities: [],
            pageTitle: 'Auditors'
          },
          views: {
            'auditor-console-content@^' : 'listAuditor',
          }
        })
    }]);
}());

(function() {

  'use strict';

  AuditorConsoleController.$inject = [];

  function AuditorConsoleController() {
    var ctrl = this; 

    ctrl.$onInit = function() {
    }
    
    ctrl.$onChanges = function(changes) {
    }
  }
  
  angular
    .module('tyallsApp')
    .controller('AuditorConsoleController', AuditorConsoleController);
}());


/*
 * Routed Component
 */
(function() {

  'use strict';

  var auditorConsole = {
    templateUrl: 'app/entities/prop-admin/auditor-console/auditor-console.html',
    bindings: {
      propertyId: '<',  // [PARENT.RESOLVE]
    },
    controller: 'AuditorConsoleController',
  }

  angular
    .module('tyallsApp')
    .component('auditorConsole', auditorConsole)
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('app.prop.prop-admin.auditor-console', {
          redirectTo: '.auditor-console.list-auditor',
          views: {
            'auditor-console@^': { 
              component: 'auditorConsole',
            }
          }
        })

    }]);
}());

(function() {

  'use strict';

  ListAuditBasketAdminController.$inject = [ '$state' ];

  function ListAuditBasketAdminController( $state ) {
    var ctrl = this; 

    ctrl.$onInit = function() {
    }

    ctrl.goToCreateAuditBasket = function() {
      $state.go('app.prop.prop-admin.audit-basket-console.create-audit-basket', {
        'onCreateAuditBasket': ctrl.createAuditBasket,
      });
    }

    ctrl.$onChanges = function(changes) {
      console.log(JSON.stringify(changes));
    }
  }

  angular
    .module('tyallsApp')
    .controller('ListAuditBasketAdminController', ListAuditBasketAdminController);
}());

/*
* Routed Component
*/
(function () {

    'use strict';

    var listAuditBasketAdmin = {
        templateUrl: 'app/entities/prop-admin/audit-basket-console/list-audit-basket-admin.html',
        bindings: {
            propertyId: '<',           // [PARENT.RESOLVE]
            onCreateAuditBasket: '&',  // [UI-VIEW.ATTR]
            auditBaskets: '<',         // [UI-VIEW.ATTR]
            hasError: '<',
            auditBasketsLoaded: '<',
        },
        controller: 'ListAuditBasketAdminController',
    }

    angular
        .module('tyallsApp')
        .component('listAuditBasketAdmin', listAuditBasketAdmin)
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.prop.prop-admin.audit-basket-console.list-audit-basket', {
                    data: {
                        authorities: [],
                        pageTitle: 'User Console'
                    },
                    views: {
                        'audit-basket-console-content@^': {
                            component: 'listAuditBasketAdmin',
                        }
                    },
                })

        }]);
}());

(function() {
    'use strict';

    AddWorkflowInstanceDialogController.$inject = ['onSuccessfulEdit', 'AuditService', 'availableWorkflowDefinitions', '$uibModalInstance'];

    function AddWorkflowInstanceDialogController(onSuccessfulEdit, AuditService, availableWorkflowDefinitions, $uibModalInstance) {
        var ctrl = this;

        ctrl.$onInit = function() {
            ctrl.workflowInstances = [];
            ctrl.availableWorkflowDefinitions = availableWorkflowDefinitions;

            ctrl.serverMessage = undefined;
            ctrl.onSuccessfulEdit = onSuccessfulEdit.value;
        };

        ctrl.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        ctrl.back = function() {

            ctrl.workflowInstances = [];
        };

        ctrl.doSearch = function() {

      // get all the selected wfds
            var wfds = [];
            angular.forEach(ctrl.availableWorkflowDefinitions, function (value) {
                if (value.selected === true) {
                    this.push(value.id);
                }
            }, wfds);

            var propCodes = [];
            for (var i = 0; i < wfds.length; i++) {
                var propCode = wfds[i].split("-")[0];
                propCodes.push(propCode);
            }
            var criteria = {
                'properties': propCodes,
                'workflowDefinitionIds': wfds,
                'startDate': moment(ctrl.startDate).format('DD/MM/YYYY'),
                'endDate': moment(ctrl.endDate).format('DD/MM/YYYY'),
            };


            return AuditService.searchAudit(criteria)
          .then(function (response) {
              ctrl.workflowInstances = response.data;  
          })
        .catch(function(reason){

        });
        };

        ctrl.save = function() {
            ctrl.isSaving = true;

            var selectedWfis = [];

            angular.forEach( ctrl.workflowInstances, function(value) {
                if (value.selected === true) {
                    this.push(value);
                }
            }, selectedWfis);
      
            ctrl.onSuccessfulEdit({
                workflowInstances: selectedWfis, 
            })
        .then(onSaveSuccess)
        .catch(onSaveError)
        .finally(function() {
            ctrl.isSaving = false;
        });
        };

        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
        }

        function onSaveError (reason) {
            ctrl.serverMessage = reason.data.message;
        }

    }

    angular
    .module('tyallsApp')
    .controller('AddWorkflowInstanceDialogController', AddWorkflowInstanceDialogController);
})();

/*
 * Modal Routed Component
 */
(function() {
  'use strict';

  angular
    .module('tyallsApp')
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider 
        .state('app.prop.prop-admin.audit-basket-console.create-audit-basket.add-workflow-instance-dialog', {
          // url: '',  // modal -- no url
          params: { 
            propertyId: null,
            onSuccessfulEdit: null,
          }, // non-url params
          data: {
            authorities: []
          },
          resolve: {
            propertyId: ['$transition$', function($transition$) {
              return $transition$.params().propertyId;
            }],
            onSuccessfulEdit: ['$transition$', function($transition$) {
              return $transition$.params().onSuccessfulEdit;
            }]
          },
          onEnter: ['onSuccessfulEdit', 'propertyId', '$state', '$uibModal', function(onSuccessfulEdit, propertyId, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'app/entities/prop-admin/audit-basket-console/dialogs/add-workflow-instance/add-workflow-instance-dialog.html',
              controller: 'AddWorkflowInstanceDialogController',
              controllerAs: '$ctrl',
              backdrop: 'static',
              size: 'md',
              resolve: {
                availableWorkflowDefinitions: [ 'ProcessDefinitionDTOService', function(ProcessDefinitionDTOService) {
                  return ProcessDefinitionDTOService
                    .getAllProcessDefinitionDTO(propertyId)
                    .then(function(response) { 
                      return response.data;   
                    });
                }],
                onSuccessfulEdit: { value: onSuccessfulEdit },
              }
            }).result.then(function(response) {
              // onSuccessfulEdit({
              //     workflowInstances: response 
              // });
              $state.go('^');
            }, function(reason) {
              $state.go('^');
            });
          }]
        });

    }]);

})();

(function() {
    'use strict';

    AddAuditorDialogController.$inject = ['onSuccessfulEdit', 'availableAuditors', '$uibModalInstance'];

    function AddAuditorDialogController(onSuccessfulEdit, availableAuditors, $uibModalInstance) {
        var ctrl = this;

        ctrl.$onInit = function() {
            ctrl.auditors = [];

            ctrl.availableAuditors = availableAuditors;
            ctrl.serverMessage = undefined;
            ctrl.onSuccessfulEdit = onSuccessfulEdit.value;
        };

        ctrl.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        ctrl.save = function() {
            ctrl.isSaving = true;

      // return the selected wfis
            var selectedAuditors = [];
      
            angular.forEach( ctrl.availableAuditors, function(value) {
                if (value.selected === true) {
                    this.push(value);
                }
            }, selectedAuditors);

            ctrl.onSuccessfulEdit({
                auditors: selectedAuditors, 
            })
        .then(onSaveSuccess)
        .catch(onSaveError)
        .finally(function() {
            ctrl.isSaving = false;
        });

        };

        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
        }

        function onSaveError (reason) {
            ctrl.serverMessage = reason.data.message;
        }

    }

    angular
    .module('tyallsApp')
    .controller('AddAuditorDialogController', AddAuditorDialogController);
})();

/*
 * Modal Routed Component
 */
(function() {
  'use strict';

  angular
    .module('tyallsApp')
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider 
        .state('app.prop.prop-admin.audit-basket-console.create-audit-basket.add-auditor-dialog', {
          // url: '',  // modal -- no url
          params: { 
            propertyId: null,
            onSuccessfulEdit: null,
          }, // non-url params
          data: {
            authorities: []
          },
          resolve: {
            propertyId: ['$transition$', function($transition$) {
              return $transition$.params().propertyId;
            }],
            onSuccessfulEdit: ['$transition$', function($transition$) {
              return $transition$.params().onSuccessfulEdit;
            }]
          },
          onEnter: ['onSuccessfulEdit', 'propertyId', '$state', '$uibModal', function(onSuccessfulEdit, propertyId, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'app/entities/prop-admin/audit-basket-console/dialogs/add-auditor/add-auditor-dialog.html',
              controller: 'AddAuditorDialogController',
              controllerAs: '$ctrl',
              backdrop: 'static',
              size: 'lg',
              resolve: {
                availableAuditors: [ 'UserService', function(UserService) {
                  return UserService.getAuditorsWithPropertyId(propertyId)
                    .then(function(response) {
                      return response.data;
                    })
                }],
                onSuccessfulEdit: { value: onSuccessfulEdit },
              }
            }).result.then(function(response) {
              // onSuccessfulEdit({
              //     auditors: response
              // });
              $state.go('^');
            }, function(reason) {
              $state.go('^');
            });
          }]
        });

    }]);

})();

(function() {

  'use strict';

  CreateAuditBasketController.$inject = ['$state', '$q', 'CacheFactory'];

  function CreateAuditBasketController($state, $q, CacheFactory) {


    const ctrl = this;
    const addSelectedWorkflowInstances = function ($event) {
      angular.forEach($event.workflowInstances, function (value) {
        this.push(value);

      }, ctrl.selectedWorkflowInstances);

      return $q.when('x');
    };

    const addSelectedAuditors = function($event) {
      angular.forEach($event.auditors, function(value) {
        this.push(value);
      }, ctrl.selectedAuditors);

      ctrl.selectedAuditors = removeDuplicates(ctrl.selectedAuditors, 'username');

      return $q.when('x');
    };

    ctrl.$onInit = function() {
      ctrl.serverMessage = undefined;
      ctrl.selectedWorkflowInstances = [];
      ctrl.selectedAuditors = [];
    }

    ctrl.saveAuditBasket = function() {
      // build a request
      const request = {};
      const formattedWfis = [];
      const formattedAuditors = [];

      angular.forEach(ctrl.selectedWorkflowInstances, function(value) {
        this.push({
          'processDefinitionId': value.workflowDefinitionId,
          'propertyId': ctrl.propertyId,
          'dueDate': value.dueDate,
        });
      }, formattedWfis);
      
      angular.forEach(ctrl.selectedAuditors, function(value) {
        this.push(value.id);
      }, formattedAuditors);

      request.auditors = formattedAuditors;
      request.wfis = formattedWfis;

      ctrl.onCreateAuditBasket({
        $event: { 
          'auditBasketRequest' : request
        }
      })
        .then(function(response) {
          if (ctrl.propertyId) {
            var cacheKey = "/api/properties/" + ctrl.propertyId + "/audit-baskets";
            var cache = CacheFactory.get("appCache");
            if (cache) {
              cache.remove(cacheKey);
            }
          }

          $state.go('^.list-audit-basket', {}, {reload: true});
        })
        .catch(function(reason) {
          ctrl.serverMessage = reason.data;
        })
      ;
    }

    ctrl.removeAuditor = function(auditor) {
      angular.forEach(ctrl.selectedAuditors, function(value, index) {
        if (value.username === auditor.username) {
          this.splice(index, 1);
        }
      }, ctrl.selectedAuditors);
    }
    
    ctrl.removeWorkflowInstance = function(workflowInstance) {
      angular.forEach(ctrl.selectedWorkflowInstances, function(value, index) {
        if (value.workflowName === workflowInstance.workflowName && value.dueDate === workflowInstance.dueDate) {
          this.splice(index, 1);
        }
      }, ctrl.selectedWorkflowInstances);
    }

    ctrl.goToAddWorkflowInstance = function() {
      $state.go('.add-workflow-instance-dialog', {
        'propertyId': ctrl.propertyId,
        'onSuccessfulEdit': addSelectedWorkflowInstances,
      });
    }
    
    ctrl.goToAddAuditor = function() {
      $state.go('.add-auditor-dialog', {
        'propertyId': ctrl.propertyId,
        'onSuccessfulEdit': addSelectedAuditors,
      });
    }

    function removeDuplicates(myArr, prop) {
      return myArr.filter(function(obj, pos, arr){
        return arr.map(function(mapObj) { return mapObj[prop]}).indexOf(obj[prop]) === pos;
      });
    }

    ctrl.$onChanges = function(changes) {
      if (changes.propertyId) {
      }
    }
  }

  angular
    .module('tyallsApp')
    .controller('CreateAuditBasketController', CreateAuditBasketController);
}());

/*
 * Routed Component
 */
(function() {
  'use strict';

  var createAuditBasket = {
    templateUrl: 'app/entities/prop-admin/audit-basket-console/create-audit-basket.html',
    bindings: {
      propertyId: '<',           // [PARENT.RESOLVE]
      onCreateAuditBasket: '&',
    },
    controller: 'CreateAuditBasketController',
  }

  angular
    .module('tyallsApp')
    .component('createAuditBasket', createAuditBasket)
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider 
        .state('app.prop.prop-admin.audit-basket-console.create-audit-basket', {
          url: '/create',
          params: { 
            onCreateAuditBasket: null,
          }, // non-url params
          data: {
            authorities: []
          },
          views: {
            'audit-basket-console-content@^': {              
              component: 'createAuditBasket',
            }
          },
        });

    }]);

})();

(function() {

    'use strict';

    AuditBasketContainerController.$inject = [ '$state' ];

    function AuditBasketContainerController( $state ) {
        var ctrl = this;

        ctrl.$onInit = function () {
        };

        ctrl.goToReadAuditBasket = function (auditBasket) {
            $state.go('app.prop.audit-basket-viewer.read-audit-basket',
                {
                    'auditBasket': auditBasket,
                    'id': auditBasket.id,
                });
        };

        ctrl.goToCreateAuditBasket = function () {
            $state.go('app.prop.prop-admin.audit-basket-console.create-audit-basket', {
                'onCreateAuditBasket': ctrl.createAuditBasket,
            });
        };
        ctrl.$onChanges = function (changes) {
        };
    }
    angular
    .module('tyallsApp')
    .controller('AuditBasketContainerController', AuditBasketContainerController);
})();

(function() {

    'use strict';

    var auditBasketContainer = {
        templateUrl: 'app/entities/prop-admin/audit-basket-console/audit-basket-viewer/audit-basket-container.html',
        bindings: {
            auditBaskets: '<',
            hasError: '<',
            auditBasketsLoaded: '<',
            property: '<'
        },
        controller: 'AuditBasketContainerController',
    };
  
    angular
    .module('tyallsApp')
    .component('auditBasketContainer', auditBasketContainer)
  ;
})();

(function () {

    'use strict';

    AuditBasketConsoleController.$inject = ['AuditBasketService'];

    function AuditBasketConsoleController(AuditBasketService) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.hasError = false;
            ctrl.auditBasketsLoaded = false;
            ctrl.auditBaskets = null;
        };

        ctrl.$onChanges = function (changes) {
            ctrl.hasError = false;
            ctrl.auditBasketsLoaded = false;
            ctrl.auditBaskets = null;
            if (changes.propertyId) {
                AuditBasketService.listByPropertyId(ctrl.propertyId)
                    .then(function (response) {
                        ctrl.auditBaskets = response.data;
                        ctrl.auditBasketsLoaded = true;
                    })
                    .catch(function (err) {
                        ctrl.hasError = true;
                        ctrl.auditBaskets = null;
                        console.log('Has error' + ctrl.hasError);
                        console.log('Unable to load audit baskets', err);

                    }
                    )
                ;
            }
        };

        ctrl.createAuditBasket = function ($event) {
            return AuditBasketService.saveAuditBasket(ctrl.propertyId, $event.auditBasketRequest)
                .then(function (response) {
                    ctrl.auditBaskets.push(response.data);
                });
        };
    }

    angular
        .module('tyallsApp')
        .controller('AuditBasketConsoleController', AuditBasketConsoleController);
})();

(function() {

  'use strict';

  var auditBasketConsole = {
    templateUrl: 'app/entities/prop-admin/audit-basket-console/audit-basket-console.html',
    bindings: {
      propertyId: '<',                // [PARENT.RESOLVE]
    },
    controller: 'AuditBasketConsoleController',
  }
  
  angular
    .module('tyallsApp')
    .component('auditBasketConsole', auditBasketConsole)
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('app.prop.prop-admin.audit-basket-console', {
            url: '/audit-basket-console',
            redirectTo: 'app.prop.prop-admin.audit-basket-console.list-audit-basket',
            views: {
                'audit-basket-console@^': {
                    component: 'auditBasketConsole',
                }
            },
        })

    }]);
}());

(function() {

  'use strict';

  angular
    .module('tyallsApp')
    .directive('portfolioSnapshot', portfolioSnapshot);

  portfolioSnapshot.$inject = [];

  function portfolioSnapshot() {
    return {
      restrict: 'E',
      scope: {
        snapshot: '=',
      },
      templateUrl: 'app/entities/portfolio/portfolio-snapshot.html',
      link: link
    };

    function link(scope, el, attr) {
      scope.wiCount = 0;
      scope.wiCompletedCount = 0;
      scope.wiNonCompletedCount = 0;
      scope.wiOverdueCount = 0;

      scope.$watch('snapshot', function(newValue) {
        if (newValue) {
          activate();
        }
      });

      activate();

      function activate() {

        // reset all values
          scope.wiCount = 0;
          scope.wiCompletedCount = 0;
          scope.wiNonCompletedCount = 0;
          scope.wiOverdueCount = 0;


        // loop over all dates and get the summary for each
        angular.forEach(scope.snapshot, function(value, key) {
          scope.wiCount += value.wiCount;
          scope.wiCompletedCount += value.wiCompletedCount;
          scope.wiNonCompletedCount += value.wiNonCompletedCount;
          scope.wiOverdueCount += value.wiOverdueCount;
        })

      }

    };
  }
}());

(function () {
  'use strict';

  PortfolioController.$inject = ['DailySummaryService', 'moment', '$q', 'bsLoadingOverlayService',];

  function PortfolioController(DailySummaryService, moment, $q, bsLoadingOverlayService) {
    var ctrl = this;

    ctrl.$onInit = function () {
      ctrl.property = ctrl.property;
      ctrl.startDate = null;
      ctrl.endDate = null;
      ctrl.portfolio = null;
    }

    ctrl.onSubmit = function () {

      // for each property, get the summary for the date range
      bsLoadingOverlayService.start();
      var promises = [];
      for (var i = 0; i < ctrl.property.length; i++) {
        promises.push(
            DailySummaryService
                .getDailySummaryDetailForProperty(ctrl.property[i].id,
                    moment(ctrl.startDate).format('YYYY-MM-DD'),
                    moment(ctrl.endDate).format('YYYY-MM-DD'))
        );

      }

      $q
          .all(promises)
          .then(function (values) {
            ctrl.portfolio = values;
          })
          .catch(function (reason) {
            console.log("Error processing summaries");
          }).finally(function () {
        bsLoadingOverlayService.stop();
      });
    }
  }

  angular
      .module('tyallsApp')
      .controller('PortfolioController', PortfolioController);

})();

/*
 * Routed Component
 */
(function() {
  'use strict';

  var portfolio = {
    templateUrl: 'app/entities/portfolio/portfolio.html',
    bindings: {
      property: '<'  // [THIS.RESOLVE] 
    },
    controller: 'PortfolioController',
  }

  angular
    .module('tyallsApp')
    .component('portfolio', portfolio)
    .config(['$stateProvider',function($stateProvider) {
      $stateProvider
        .state('app.portfolio', {
          url: '/portfolio',
          data: {
            authorities: [],
            pageTitle: 'Portfolio'
          },
          component: 'portfolio',
          resolve: {
            property: [ 'PropertyService', function(PropertyService) {
              return PropertyService.getAllPropertiesForUser()
                .then(function(response) {
                  return response.data;
                });
            }]
          }
        })
      ;

    }]);
})();

(function() {
  'use strict';

  angular
    .module('tyallsApp')
    .filter('percentage', percentage);

  percentage.$inject = ['$filter'];

  function percentage($filter) {
    return function(input, decimals) {
      return $filter('number')(input * 100, decimals) + '%';
    };
  }
})();

(function () {
    'use strict';

    MentionController.$inject = ['$state', 'DailySummaryService', 'MentionService', 'bsLoadingOverlayService'];

    function MentionController($state, DailySummaryService, MentionService, bsLoadingOverlayService) {
        var ctrl = this;

        ctrl.filterUnread = function (item) {
            if (!!ctrl.showUnreadOnly === false) return true;
            return !!item.readDate === ctrl.showUnreadOnly ? false : true;
        }

        ctrl.$onInit = function () {
            ctrl.showUnreadOnly = true;
        }

        ctrl.getPage = function (page) {
            bsLoadingOverlayService.start();
            MentionService.query(page, 10, ctrl.showUnreadOnly)
                .then(function (resp) {
                    ctrl.mentionsPage = resp.data;
                })
                .finally(function () {
                    bsLoadingOverlayService.stop();
                });
        }

        ctrl.changeState = function (propertyId, wfiId, mentionId) {
            MentionService
                .markMentionAsRead(propertyId, mentionId)
                .then(function () {
                    return DailySummaryService
                        .getTaskForMention(propertyId, wfiId);
                })
                .then(function (resp) {
                    $state.go('app.prop.task', {
                        'propertyId': propertyId,
                        'date': resp.data[0].dueDate,
                        'tasks': resp.data,
                        'returnTo': function () {
                            $state.go('app.mentions', {}, {reload: true});
                        },
                    });
                });
        }
    }

    angular
        .module('tyallsApp')
        .controller('MentionController', MentionController);
})();

/*
 * Routed Component
 */
(function () {
    'use strict';

    var mention = {
        templateUrl: 'app/entities/mentions/mentions.html',
        bindings: {
            mentionsPage: '<',           // [THIS.RESOLVE]
            idToPropertyLookup: '<'  // [THIS.RESOLVE]
        },
        controller: 'MentionController',
    };

    angular
        .module('tyallsApp')
        .component('mention', mention)
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.mentions', {
                    url: '/mentions',
                    data: {
                        authorities: [],
                        pageTitle: 'Mentions'
                    },
                    component: 'mention',
                    resolve: {
                        mentionsPage: ['MentionService', function (MentionService) {
                            return MentionService.query(0, 10, true).then(function (resp) {
                                return resp.data;
                            });
                        }],
                        idToPropertyLookup: ['PropertyService', function (PropertyService) {
                            return PropertyService
                                .getAllPropertiesForUser()
                                .then(function (response) {
                                    var idToPropertyLookup = {};
                                    angular.forEach(response.data, function (value) {
                                        this[value.id] = value;
                                    }, idToPropertyLookup);
                                    return idToPropertyLookup;
                                })

                        }]

                    }
                })

        }]);
}());

(function () {

    'use strict';

    NonDailyLauncherController.$inject = ['WorkflowInstanceService', 'UploadFileService'];

    function NonDailyLauncherController(WorkflowInstanceService, UploadFileService) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.property = ctrl.property;
            ctrl.selectedDueDate = null;
            ctrl.launched = [];
            ctrl.launchList = [];

            activate();
        }

        ctrl.hasConfirmedLaunchRequest = function () {
            if (!ctrl.launchRequests) return false;

            // confirmed launch;
            var confirmedLaunch = false;

            angular.forEach(ctrl.launchRequests, function (request) {
                confirmedLaunch = confirmedLaunch || (request.confirm && request.confirm === true);
            }, confirmedLaunch);

            return confirmedLaunch;
        }

        var activate = function () {
            ctrl.launchRequests = [];

            // build out the launchRequests collection
            angular.forEach(ctrl.availableWfds, function (value, key) {
                var request = {};
                request.processDefinitionId = value.id;
                request.processDefinitionName = value.name;
                // request.isLaunched = ctrl.isLaunched(request) ? 'Launched' : 'No';
                // add the dueDate to the request
                // request.dueDate = ctrl.launched.filter(function(l){return l.processDefinitionId === value.id})[0].dueDate
                this.push(request);

            }, ctrl.launchRequests);

        }

        ctrl.doUpload = function () {
            // vm.uploading = true;
            // bsLoadingOverlayService.start();

            // build a list of promises
            var promises = [];
            for (var key in ctrl.launchRequests) {

                if (!!ctrl.launchRequests[key].confirm) {
                    ctrl.launchRequests[key].status = 'launching...';
                    UploadFileService
                        .handleUpload(
                            ctrl.propertyId,
                            ctrl.launchRequests[key].processDefinitionId,
                            ctrl.launchRequests[key].selectedDueDate,
                            ctrl.launchRequests[key].file)
                        .then(function (response) {
                            // find the launchRequest that matches
                            // response.data.processDefinitionId

                            angular.forEach(ctrl.launchRequests, function (request) {
                                if (request.processDefinitionId === response.data.processDefinitionId) {
                                    request.status = 'done';
                                    request.dueDate = response.data.dueDate;
                                    request.isLaunched = 'Launched';
                                    reset(response.data.processDefinitionId);
                                }
                            });
                        });
                }
            }
        }

        var reset = function (processDefinitionId) {
            angular.forEach(ctrl.launchRequests, function (request) {
                if (request.processDefinitionId === processDefinitionId) {
                    request.confirm = false;
                }
            });
        }

        ctrl.selectProperty = function (event) {
            // ctrl.selectedProperty = ctrl.property.filter(function(value) { return value.id === event.propertyId})[0];
        }

        ctrl.isLaunched = function (available) {
            if (available === null || ctrl.launched === null) return false;

            return ctrl
                .launched
                .filter(function (value) {
                    var ret = value.processDefinitionId === available.processDefinitionId;
                    return ret;
                }).length > 0;

        }
    }

    angular
        .module('tyallsApp')
        .controller('NonDailyLauncherController', NonDailyLauncherController);
})();

/*
 * Routed Component
 */
(function () {
    'use strict';

    var nonDailyLauncher = {
        templateUrl: 'app/entities/launcher/non-daily-launcher.html',
        bindings: {
            propertyId: '<',         // [PARENT.RESOLVE]
            availableWfds: '<',
        },
        controller: 'NonDailyLauncherController'
    };

    angular
        .module('tyallsApp')
        .component('nonDailyLauncher', nonDailyLauncher)
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.prop.launch-console.non-daily-launcher', {
                    url: '/non-daily-launcher',
                    views: {
                        'non-daily-launcher@^': 'nonDailyLauncher',
                    },
                    data: {
                        authorities: [],
                        pageTitle: 'Non Daily Launcher'
                    },
                    resolve: {
                        availableWfds: ['ProcessDefinitionDTOService', 'propertyId', function (ProcessDefinitionDTOService, propertyId) {
                            return ProcessDefinitionDTOService
                                .getAllNonDailyProcessDefinitionDTO(propertyId)
                                .then(function (response) {
                                    return response.data;
                                })
                                ;
                        }]
                    }
                })
        }]);
}());

(function () {

    'use strict';

    DailyLauncherController.$inject = [
        'WorkflowInstanceService',
        'ProcessDefinitionDTOService',
        'UploadFileService',
        'bsLoadingOverlayService',
        'CacheFactory'];

    function DailyLauncherController(WorkflowInstanceService,
                                     ProcessDefinitionDTOService,
                                     UploadFileService,
                                     bsLoadingOverlayService,
                                     CacheFactory) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.selectedDueDate = null;
            ctrl.launched = [];
            ctrl.launchList = [];
            ctrl.availableWfds = [];

            activate();
        }

        ctrl.clearCache = function () {
            console.log("Clearing Cache!");
            var cache = CacheFactory.get("appCache");
            if (cache) {
                console.log("Cache Cleared!");
                cache.removeAll()
            }
        }
        ctrl.hasConfirmedLaunchRequest = function () {
            if (!ctrl.launchRequests) return false;

            // confirmed launch;
            var confirmedLaunch = false;

            angular.forEach(ctrl.launchRequests, function (request) {
                confirmedLaunch = confirmedLaunch || (request.confirm && request.confirm === true);
            }, confirmedLaunch);

            return confirmedLaunch;
        }

        var activate = function () {
            ctrl.launchRequests = [];

            // build out the launchRequests collection
            angular.forEach(ctrl.availableWfds, function (value, key) {
                var request = {};
                request.processDefinitionId = value.id;
                request.processDefinitionName = value.name;
                request.isLaunched = ctrl.isLaunched(request) ? 'Launched' : 'No';
                this.push(request);

            }, ctrl.launchRequests);

        }

        ctrl.doUpload = function () {
            var promises = [];
            try {
                for (var key in ctrl.launchRequests) {
                    try {
                        if (!!ctrl.launchRequests[key].confirm) {
                            ctrl.launchRequests[key].status = 'launching...';
                            UploadFileService
                                .handleUpload(
                                    ctrl.propertyId,
                                    ctrl.launchRequests[key].processDefinitionId,
                                    ctrl.selectedDueDate,
                                    ctrl.launchRequests[key].file)
                                .then(function (response) {
                                    angular.forEach(ctrl.launchRequests, function (request) {
                                        if (request.processDefinitionId === response.data.processDefinitionId) {
                                            request.status = 'done';
                                            request.isLaunched = 'Launched';
                                            reset(response.data.processDefinitionId);
                                        }
                                    });
                                    ctrl.clearCache();
                                });
                        }
                    } catch (e) {
                        console.log("Error Doing Upload " + key, e)
                    }
                }
            } catch (e) {
                console.log("Error Doing Upload", e)
            } finally {
                ctrl.clearCache();
            }
        }

        var reset = function (processDefinitionId) {
            angular.forEach(ctrl.launchRequests, function (request) {
                if (request.processDefinitionId === processDefinitionId) {
                    request.confirm = false;
                }
            });
        }

        ctrl.selectProperty = function (event) {
            // ctrl.selectedProperty = ctrl.property.filter(function(value) { return value.id === event.propertyId})[0];
        }

        ctrl.getLaunchedWfis = function () {
            // fetch the ProcessDefinitions
            bsLoadingOverlayService.start();
            ProcessDefinitionDTOService
                .getAllDailyProcessDefinitionDTO(ctrl.propertyId)
                .then(function (response) {
                    ctrl.availableWfds = response.data;
                })
                .catch(function (reason) {

                });

            WorkflowInstanceService
                .getWorkflowInstanceByPropertyAndDueDate(ctrl.propertyId, ctrl.selectedDueDate)
                .then(function (response) {
                    ctrl.launched = response.data;
                    activate();
                })
                .catch(function (reason) {
                    console.log('oops %o', reason);
                })
                .finally(function () {
                    bsLoadingOverlayService.stop();
                });

        }

        ctrl.back = function () {

            ctrl.availableWfds = [];
        };

        ctrl.dateSearch = function () {
            ctrl.getLaunchedWfis();
        }

        ctrl.isLaunched = function (available) {
            if (available === null || ctrl.launched === null) return false;

            return ctrl
                .launched
                .filter(function (value) {
                    return value.processDefinitionId === available.processDefinitionId;
                }).length > 0;

        }
    }

    angular
        .module('tyallsApp')
        .controller('DailyLauncherController', DailyLauncherController);
})();

/*
 * Routed Component
 */
(function () {
    'use strict';

    var dailyLauncher = {
        templateUrl: 'app/entities/launcher/daily-launcher.html',
        bindings: {
            propertyId: '<',         // [PARENT.RESOLVE]
        },
        controller: 'DailyLauncherController'
    };

    angular
        .module('tyallsApp')
        .component('dailyLauncher', dailyLauncher)
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.prop.launch-console.daily-launcher', {
                    url: '/daily-launcher',
                    views: {
                        'daily-launcher@^': 'dailyLauncher',
                    },
                    data: {
                        authorities: [],
                        pageTitle: 'Daily Launcher'
                    },
                })
        }]);
}());

(function() {
  'use strict';

  LaunchConsoleController.$inject = [];

  function LaunchConsoleController() {
    var ctrl = this;

    ctrl.$onInit = function() {

      ctrl.onResolveDisabled({
        $event: {
          disabled: false
        }
      });

      ctrl.onResolveProperties({
        $event: {
          properties: ctrl.properties
        }
      });
    }

    ctrl.$onChanges = function(changes) {
    }
  }

  angular
    .module('tyallsApp')
    .controller('LaunchConsoleController', LaunchConsoleController);
})();

/*
 * Routed Component
 */
(function() {
  'use strict';

  var launchConsole = {
    templateUrl: 'app/entities/launch-console/launch-console.html',
    bindings: {
      onResolveDisabled: '&',   // [UI-VIEW.ATTR]
      onResolveProperties: '&', // [UI-VIEW.ATTR] this is how child state return possible properties to parent
      properties: '<',          // [THIS.RESOLVE] passed in from state.resolve 
      propertyId: '<',          // [PARENT.RESOLVE] user selection, inherited from app.prop
    },
    controller: 'LaunchConsoleController'
  };

  angular
    .module('tyallsApp')
    .component('launchConsole', launchConsole)
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('app.prop.launch-console', {
          url: '/launch-console',
          redirectTo: 'app.prop.launch-console.daily-launcher',
          views: {
            'prop@^' : 'launchConsole',
          },
          data: {
            authorities: [],
            pageTitle: 'LaunchConsole'
          },
          resolve: {
            // override the property list fetched in parent
            properties: [ 'PropertyService', function(PropertyService) {
              return PropertyService.getAllPropertiesForUser()
                .then(function(response) {
                  return response.data; 
                });
            }],
          }
        })

    }]);
})();

(function () {
    'use strict';

    InviteController.$inject = ['InviteService'];

    function InviteController(InviteService) {
        var ctrl = this;

        ctrl.$onInit = function () {

            InviteService
                .query()
                .then(function (response) {
                    ctrl.invites = response.data;
                })
                .catch(function (reason) {

                });
        }

        ctrl.accept = function (invite) {
            InviteService
                .acceptInvite(invite)
                .then(function (response) {
                })
                .catch(function (reason) {

                });
        }

    }

    angular
        .module('tyallsApp')
        .controller('InviteController', InviteController);

})();

/*
 * Routed Component
 */
(function () {
    'use strict';

    var invites = {
        templateUrl: 'app/entities/invites/invites.html',
        bindings: {
            // account: '<'
        },
        controller: 'InviteController',
    }

    angular
        .module('tyallsApp')
        .component('invites', invites)
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.invites', {
                    url: '/invites',
                    data: {
                        authorities: [],
                        pageTitle: 'Invites'
                    },
                    views: {
                        'content@': {
                            component: 'invites',
                        }
                    }
                });
        }]);
})();

(function () {

    'use strict';

    FileController.$inject = ['$scope',
        'UploadFileService',
        'ProcessDefinitionDTOService',
        '$log', 'PrincipalService',
        'bsLoadingOverlayService', 'moment', 'CacheFactory'];

    function FileController($scope, UploadFileService, ProcessDefinitionDTOService, $log, PrincipalService, bsLoadingOverlayService, moment, CacheFactory) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.processDefinitions = null;
            ctrl.properties = ctrl.properties;
            getAccount();
            resetData();
            activate();
        }

        function activate() {
            // if only 1 property, then select it
            if (ctrl.properties.length === 1) {
                ctrl.selectedProperty = ctrl.properties[0];
            }
        }

        function getAccount() {
            PrincipalService.identity().then(function (account) {
                ctrl.account = account;
            });
        }

        ctrl.clearCache = function () {
            console.log("Clearing Cache!");
            var cache = CacheFactory.get("appCache");
            if (cache) {
                console.log("Cache Cleared!");
                cache.removeAll()
            }
        }

        ctrl.doUpload = function () {
            ctrl.uploading = true;
            bsLoadingOverlayService.start();

            UploadFileService.handleUpload(ctrl.selectedProperty.id, ctrl.selectedWorkflow.id, ctrl.selectedDueDate, ctrl.selectedFile)
                .success(function () {
                    bsLoadingOverlayService.stop();
                    ctrl.uploading = false;
                    ctrl.reset();
                    ctrl.clearCache();
                })
                .error(function (error) {
                    bsLoadingOverlayService.stop();
                });
        }

        ctrl.reset = function () {
            $scope.uploadForm.$setPristine();
            $scope.uploadForm.$setUntouched();
            resetData();
        }

        function resetData() {
            ctrl.selectedFile = null;
            ctrl.selectedDueDate = moment().toDate();
            ctrl.selectedWorkflow = null;
        }

        $scope.$watch(function () {
            return ctrl.selectedProperty
        }, function (newValue) {
            if (newValue) {
                $log.debug('Updating available workflowIds for propertyId: ', ctrl.selectedProperty.id);
                ProcessDefinitionDTOService.getAllProcessDefinitionDTO(ctrl.selectedProperty.id)
                    .then(function onSuccess(resp) {
                        $log.debug('returning ', angular.toJson(resp.data, true));
                        ctrl.processDefinitions = resp.data;
                        ctrl.selectedWorkflow = null;
                    });
            }
        });
    }

    angular
        .module('tyallsApp')
        .controller('FileController', FileController);
})();

/*
 * Routed Component
 */
(function () {
    'use strict'

    var file = {
        templateUrl: 'app/entities/file/file.html',
        bindings: {
            properties: '<'  // [THIS.RESOLVE]
        },
        controller: 'FileController',
    }

    angular
        .module('tyallsApp')
        .component('file', file)
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.file', {
                    url: '/file',
                    data: {
                        authorities: [],
                        pageTitle: 'File'
                    },
                    component: 'file',
                    resolve: {
                        properties: ['PropertyService', function (PropertyService) {
                            return PropertyService.getAllPropertiesForUser()
                                .then(function (response) {
                                    return response.data;
                                });
                        }]
                    }
                });
        }]);
}());

(function() {

    'use strict';

    ReadAuditBasketController.$inject = [ 'DailySummaryService', '$state' ];

    function ReadAuditBasketController( DailySummaryService, $state ) {
        var ctrl = this; 

        ctrl.$onInit = function() {
        };

        ctrl.goToTask = function(index) {

            var wfi = ctrl.auditBasket.wfis[index];

            DailySummaryService
        .getTaskForMention(ctrl.propertyId, wfi.processInstanceId)
        .then(function(resp) {
            $state.go('app.prop.task', {
                'propertyId': ctrl.propertyId,
                'date': wfi.dueDate,
                'tasks': resp.data,
                'returnTo': function () {
                    $state.go('app.prop.audit-basket-viewer.read-audit-basket',
                        {
                            'propertyId': ctrl.propertyId,
                            'auditBasket': ctrl.auditBasket,
                            'id': ctrl.auditBasket.id
                        }
              );
                },
            });
        });
        };
    }
  
    angular
    .module('tyallsApp')
    .controller('ReadAuditBasketController', ReadAuditBasketController);
})();

/*
 * Routed Component
 */
(function() {
  'use strict';

  // share the component with prop-admin
  var readAuditBasket = {
    templateUrl: 'app/entities/audit-basket-viewer/read-audit-basket.html',
    bindings: {
      propertyId: '<',
      auditBasket: '<',
    },
    controller: 'ReadAuditBasketController',
  }

  angular
    .module('tyallsApp')
    .component('readAuditBasket', readAuditBasket)
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider 
        .state('app.prop.audit-basket-viewer.read-audit-basket', {
          url: '/audit-baskets/:id',
          params: {
            auditBasket: null,
          }, // non-url params
          data: {
            authorities: []
          },
          views: {
            'audit-basket-viewer-content@^' : 'readAuditBasket',
          },
          resolve: {
            auditBasket: ['AuditBasketService', '$transition$', function(AuditBasketService, $transition$) {
              var auditBasketId = $transition$.params().auditBasket.id;
              var propertyId = $transition$.params().propertyId;
              return AuditBasketService.listByPropertyIdAndAuditBasketId(propertyId, auditBasketId)
              .then(function(response){
                return response.data; 
              });
            }],
            propertyId: ['$transition$', function($transition$) {
              return $transition$.params().propertyId;
            }],
          },
        });

    }]);

})();

(function() {

  'use strict';

  ListAuditBasketController.$inject = [];

  function ListAuditBasketController() {
    var ctrl = this; 

    ctrl.$onInit = function() {
    } 

    ctrl.$onChanges = function(changes) {
    }     

  }       

  angular 
    .module('tyallsApp')
    .controller('ListAuditBasketController', ListAuditBasketController);
}());


/*
 * Routed Component
 */
(function() {
    'use strict';

    var listAuditBasket = {
        templateUrl: 'app/entities/audit-basket-viewer/list-audit-basket.html',
        bindings: {
            propertyId: '<',          // [PARENT.RESOLVE] user selection
            auditBaskets: '<',        // [THIS.RESOLVE]
        },
        controller: 'ListAuditBasketController',
    };

    angular
		.module('tyallsApp')
		.component('listAuditBasket', listAuditBasket)
		.config(['$stateProvider', function($stateProvider) {
    $stateProvider
				.state('app.prop.audit-basket-viewer.list-audit-basket', {
    url: '/audit-baskets',
    data: {
        authorities: [],
        pageTitle: 'Audit Baskets'
    },
    views: {
        'audit-basket-viewer-content@^' : 'listAuditBasket',
    },
    resolve: {
        propertyId: ['$transition$', function($transition$) {
            return $transition$.params().propertyId;
        }],
        auditBaskets: [ 'AuditBasketService', 'propertyId', function(AuditBasketService, propertyId) {
            if (propertyId === null) {
                return [];
            }
            return AuditBasketService.listByPropertyId(propertyId).then(function(response) {
                return response.data.filter(
									function(el) {
										// must have at least one wfi
    return true;
										// return el.wfis[0].property === Number(propertyId);
}
								);
            });
        }],
    }
});

}]);
})();


(function() {

	'use strict';

	AuditBasketViewerController.$inject = [];

	function AuditBasketViewerController() {
		var ctrl = this; 

		ctrl.$onInit = function() {
			ctrl.onResolveDisabled({
				$event: {
					disabled: false
				}
			});

			ctrl.onResolveProperties({
				$event: {
					properties: ctrl.properties
				}
			});

		} 

		ctrl.$onChanges = function(changes) {
		}
	}

	angular
		.module('tyallsApp')
		.controller('AuditBasketViewerController', AuditBasketViewerController);
}()); 

/*
 *  * Routed Component
 *   */
(function() {

	'use strict';

	var auditBasketViewer = {
		templateUrl: 'app/entities/audit-basket-viewer/audit-basket-viewer.html',
		bindings: {
			onResolveDisabled: '&',   // [UI-VIEW.ATTR]
			onResolveProperties: '&', // [UI-VIEW.ATTR] this is how child state return possible properties to parent
			properties: '<',          // [THIS.RESOLVE] passed in from state.resolve 
			propertyId: '<',          // [PARENT.RESOLVE] user selection
			auditBaskets: '<',        // [THIS.RESOLVE]
		},
		controller: 'AuditBasketViewerController',
	}

	angular
		.module('tyallsApp')
		.component('auditBasketViewer', auditBasketViewer)
		.config(['$stateProvider', function($stateProvider) {
			$stateProvider
				.state('app.prop.audit-basket-viewer', {
					redirectTo: '.prop.audit-basket-viewer.list-audit-basket',
					views: {
						'prop@^': { 
							component: 'auditBasketViewer',
						}
					},
					resolve: {
						propertyId: ['$transition$', function($transition$) {
							return $transition$.params().propertyId;
						}],
						properties: ['PropertyService', function(PropertyService) {
							return PropertyService.getAllPropertiesForUser()
								.then(function(response) {
									return response.data;
								});
						}],

					}
				});

		}]);
}());


(function () {

    'use strict';

    AuditController.$inject = ['DailySummaryService', '$state', '$document', '$window', '$scope',
        'ProcessDefinitionDTOService', 'bsLoadingOverlayService', 'moment', '$q', 'AuditService'];

    function AuditController(DailySummaryService, $state, $document, $window, $scope, ProcessDefinitionDTOService, bsLoadingOverlayService, moment, $q, AuditService) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.properties = ctrl.properties.data;
            ctrl.selectedProperties = [];

            ctrl.workflowDefinitions = [];
            ctrl.selectedWorkflowDefinitions = [];

            ctrl.searchResults = [];
            ctrl.hasSelectedWorkflow = false;
        }

        ctrl.checkStartDate = function () {
            var sdate = new Date(ctrl.queryForm.startDate.$viewValue);
            var edate = new Date(ctrl.queryForm.endDate.$viewValue);
            if (ctrl.queryForm.startDate.$valid && sdate > edate) {
                ctrl.queryForm.endDate.$setValidity('end-date-after-start-date', false);
            } else {
                ctrl.queryForm.endDate.$setValidity('end-date-after-start-date', true);
            }
        }

        ctrl.doSearch = function () {
            bsLoadingOverlayService.start();

            performAuditQuery(false)
                .then(function (results) {
                    ctrl.searchResults = results.data;
                    bsLoadingOverlayService.stop();
                })
                .catch(function () {
                    bsLoadingOverlayService.stop();
                });
        }

        ctrl.downloadPdf = function () {
            bsLoadingOverlayService.start();

            performAuditQuery({format: 'pdf'})
                .success(function (response) {
                    if ($window.navigator.msSaveOrOpenBlob) {
                        $window.navigator.msSaveOrOpenBlob(new Blob([response.data]), response.filename);
                    } else {
                        var url = URL.createObjectURL(new Blob([response.data]));
                        var a = $document[0].createElement('a');
                        a.href = url;
                        a.download = response.filename;
                        a.target = '_blank';
                        a.click();
                    }
                    bsLoadingOverlayService.stop();
                })
                .catch(function () {
                    bsLoadingOverlayService.stop();
                });
        }

        ctrl.downloadCsv = function () {
            bsLoadingOverlayService.start();

            performAuditQuery({format: 'csv'})
                .success(function (response) {
                    if ($window.navigator.msSaveOrOpenBlob) {
                        $window.navigator.msSaveOrOpenBlob(new Blob([response.data]), response.filename);
                    } else {
                        var url = URL.createObjectURL(new Blob([response.data]));
                        var a = $document[0].createElement('a');
                        a.href = url;
                        a.download = response.filename;
                        a.target = '_blank';
                        a.click();
                    }
                    bsLoadingOverlayService.stop();
                })
                .catch(function () {
                    bsLoadingOverlayService.stop();
                });
        }

        ctrl.fetchWorkflowDefinitions = function () {
            // fetch all the workflowDefinitions for each property
            var promises = [];
            for (var i = 0; i < ctrl.selectedProperties.length; i++) {
                promises.push(ProcessDefinitionDTOService.getAllProcessDefinitionDTO(ctrl.selectedProperties[i].id));
            }

            return $q.all(promises)
        }

        ctrl.changeState = function (result) {
            console.log("result: %o", result);

            // map the propertyCode to the propertyId
            var propertyId;
            angular.forEach(ctrl.selectedProperties, function (property) {
                if (property.propertyCode === result.propertyCode) {
                    propertyId = property.id;
                }
            });

            DailySummaryService
                .getTaskForMention(propertyId, result.wfiId)
                .then(function (resp) {
                    $state.go('app.prop.task', {
                        'propertyId': propertyId,
                        'date': result.dueDate,
                        'tasks': resp.data,
                        'returnTo': function () {
                            $state.go('app.audit');
                        },
                    });
                });
        }

        function performAuditQuery(options) {
            // consolidate criteria
            const selectedWorkflowDefinitionIds = [];
            angular.forEach(ctrl.selectedWorkflowDefinitions, function (value) {
                this.push(value.id);
            }, selectedWorkflowDefinitionIds);

            const selectedPropCodes = [];
            angular.forEach(ctrl.selectedProperties, function (value) {
                this.push(value.propertyCode);
            }, selectedPropCodes);
            const criteria = {
                'properties': selectedPropCodes,
                'selectAllWorkflows': !ctrl.hasSelectedWorkflow,
                'workflowDefinitionIds': selectedWorkflowDefinitionIds,
                'startDate': moment(ctrl.startDate).format('DD/MM/YYYY'),
                'endDate': moment(ctrl.endDate).format('DD/MM/YYYY'),
            };

            return AuditService.searchAudit(criteria, options);
        }

        $scope.$watch(function () {
            return ctrl.selectedProperties
        }, function (newValue) {
            if (newValue) {
                ctrl.fetchWorkflowDefinitions()
                    .then(function (results) {
                        // loop over all the results and extract the data and flatmap
                        ctrl.workflowDefinitions = [];
                        angular.forEach(results, function (value) {
                            angular.forEach(value.data, function (pd) {
                                // lookup propertyCode
                                var propertyCode;
                                angular.forEach(ctrl.selectedProperties, function (property) {
                                    if (property.id === pd.propertyId) {
                                        propertyCode = property.propertyCode;
                                    }
                                }, propertyCode);
                                pd.propertyCode = propertyCode;
                                ctrl.workflowDefinitions.push(pd);
                            });
                        });
                    })
                    .catch(function (response) {

                    });
            }
        });
    }

    angular
        .module('tyallsApp')
        .controller('AuditController', AuditController);

})();

/*
 * Routed Component
 */
(function () {

    'use strict';

    var audit = {
        templateUrl: 'app/entities/audit/audit.html',
        bindings: {
            properties: '<',   // [THIS.RESOLVE]
        },
        controller: 'AuditController',
    };

    angular
        .module('tyallsApp')
        .component('audit', audit)
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.audit', {
                    url: '/audit',
                    component: 'audit',
                    data: {
                        authorities: [],
                        pageTitle: 'Audit'
                    },
                    resolve: {
                        properties: ['PropertyService', function (PropertyService) {
                            return PropertyService.getAllPropertiesForUser();
                        }]
                    }
                });

        }]);
})();

(function () {

    'use strict';

    WfdAdminConsoleController.$inject = ['WorkflowDefinitionService', '$state'];

    function WfdAdminConsoleController(WorkflowDefinitionService, $state) {
        var ctrl = this;

        ctrl.$onInit = function () {
        }

        ctrl.getBpmn = function (wfdId) {
            ('%o', wfdId);


            WorkflowDefinitionService.getUploadStream(wfdId)
                .then(function onSuccess(response) {
                    ctrl.file = new Blob([(response.data)], {type: 'application/pdf'});
                    ctrl.fileUrl = URL.createObjectURL(ctrl.file);
                }, function onFailure() {
                    $log.error('oops');
                });
        }

        ctrl.goToCreateWfd = function () {
            $state.go('app.app-admin.create-wfd-dialog', {
                propertyId: ctrl.propertyId,
                onCreateWfd: ctrl.createWfd,
            });
        }

        // cb -- let caller handle catch, must return promise
        ctrl.createWfd = function ($event) {
            return WorkflowDefinitionService.createWfd($event.wfd);
        }
    }

    angular
        .module('tyallsApp')
        .controller('WfdAdminConsoleController', WfdAdminConsoleController);
}());


(function () {

    'use strict';

    var wfdAdminConsole = {
        templateUrl: 'app/entities/app-admin/wfd-admin-console/wfd-admin-console.html',
        bindings: {
            // users: '<',
            properties: '<',
            workflowDefinitions: '<',
        },
        controller: 'WfdAdminConsoleController',
    }

    angular
        .module('tyallsApp')
        .component('wfdAdminConsole', wfdAdminConsole)
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.app-admin.wfd-admin-console', {
                    url: '/wfds',
                    views: {
                        'wfd-admin-console@^': {
                            component: 'wfdAdminConsole',
                        }
                    },
                    resolve: {
                        properties: ['PropertyService', function (PropertyService) {
                            return PropertyService.getAllPropertiesForAdmin()
                                .then(function (response) {
                                    return response.data;
                                });
                        }],
                        workflowDefinitions: ['WorkflowDefinitionService', function (WorkflowDefinitionService) {
                            return WorkflowDefinitionService.getAllWfds()
                                .then(function (response) {
                                    return response.data;
                                });
                        }],
                    }
                })

        }]);
}());

(function() {

  'use strict';
  
  UserGroupConsoleController.$inject = [ 'UserGroupService', 'PropertyService', 'bsLoadingOverlayService' ];

  function UserGroupConsoleController( UserGroupService, PropertyService, bsLoadingOverlayService  ) {
    var ctrl = this; 

    ctrl.$onInit = function() {
      ctrl.userGroups = [];
      ctrl.idToPropertyLookup = {};

      bsLoadingOverlayService.start();
      PropertyService
        .getAllPropertiesForAdmin()
        .then( function(response) {
          ctrl.idToPropertyLookup = {};
          angular.forEach(response.data, function(value) {
            this[value.id] = value;
          }, ctrl.idToPropertyLookup);
        })
        .catch(function(reason) {
            console.log('oops');
        })
        .finally(function() {
          bsLoadingOverlayService.stop();
        });
    }

    ctrl.$onChanges = function(changes) {
      if (changes.propertyId) {
        // refresh the userGroup data
        bsLoadingOverlayService.start();

        UserGroupService
          .getWithPropertyId(changes.propertyId.currentValue)
          .then( function(response) {
            ctrl.userGroups = response.data; 
          })
          .catch(function(response) {
            console.log('oops');
          })
          .finally(function() {
            bsLoadingOverlayService.stop();
          });
      }; 
    }
  }

  angular
    .module('tyallsApp')
    .controller('UserGroupConsoleController', UserGroupConsoleController);
}());


(function() {

  'use strict';

  var userGroupConsole = {
    templateUrl: 'app/entities/app-admin/user-group-console/user-group-console.html',
    bindings: {
      propertyId: '<',
    },
    controller: 'UserGroupConsoleController',
  }

  angular
    .module('tyallsApp')
    .component('userGroupConsole', userGroupConsole)
  ;
}());

(function() {

  'use strict';
  
  UserAdminConsoleController.$inject = [ 'UserService', '$state' ];

  function UserAdminConsoleController( UserService, $state ) {
    var ctrl = this; 

    ctrl.$onInit = function() {
    }

    ctrl.goToCreateUser = function() {
      $state.go('app.app-admin.create-user-dialog', { 
        propertyId: ctrl.propertyId,
        onCreateUser: ctrl.createUser,
      });
    }

    ctrl.goToUserDetail = function(user) {
      $state.go('app.app-admin.detail-user-dialog', {
        user: user,
        onAddUserToProperty: ctrl.addUserToProperty,
        onRemoveUserFromProperty: ctrl.removeUserFromProperty,
      });
    };
    
    ctrl.addUserToProperty = function($event) {
      return UserService.addUserToProperty($event.user, $event.property);
    }
    
    ctrl.removeUserFromProperty = function($event) {
      return UserService.removeUserFromProperty($event.user, $event.property);
    }

    // cb -- let caller handle catch, must return promise
    ctrl.createUser = function($event) {
      return UserService.createUser($event.user);
    }

    ctrl.requestToggleEnable = function(user) {
      var titleText = 'Confirm Activate/Deactivate User';
      var bodyText = 'Are you sure you want to Activate/Deactivate user (' + user.username + ')?  This action will reset all memberships and property-profiles.';
      // confirm that the user actually want this
      $state.go('.confirm-toggle-user-dialog', {
        titleText: titleText,
        bodyText: bodyText,
        onPositiveConfirm: ctrl.toggleEnable.bind(ctrl, user)
      });  
    }

    ctrl.toggleEnable = function(user) {
      if (user.enabled) {
        disableUser(user);
      } else {
        enableUser(user);
      }
    }

    function disableUser(user) {
      UserService
        .disableUser(user)
        .then(function(response) {
          // update vm.users
          angular.forEach(ctrl.users, function(value, index) {
            if (value.id === response.data.id) {
              ctrl.users[index] = response.data;
            }
          })
        })
        .catch(function(reason) {
          console.log(reason);
        });
    }

    function enableUser(user) {
      UserService
        .enableUser(user)
        .then(function(response) {
          // update vm.users
          angular.forEach(ctrl.users, function(value, index) {
            if (value.id === response.data.id) {
              ctrl.users[index] = response.data;
            }
          })
        })
        .catch(function(reason) {
          console.log(reason);
        });
    }

  }

  angular
    .module('tyallsApp')
    .controller('UserAdminConsoleController', UserAdminConsoleController);
}());


(function() {

  'use strict';

  var userAdminConsole = {
    templateUrl: 'app/entities/app-admin/user-admin-console/user-admin-console.html',
    bindings: {
      users: '<',
      properties: '<',
    },
    controller: 'UserAdminConsoleController',
  }

  angular
    .module('tyallsApp')
    .component('userAdminConsole', userAdminConsole) 
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('app.app-admin.user-admin-console', {
          url: '/users',
          views: {
            'user-admin-console@^': {
              component: 'userAdminConsole',
            }
          },
          resolve: {
            properties: [ 'PropertyService', function( PropertyService ) {
              return PropertyService.getAllPropertiesForAdmin()
                .then(function(response) {
                  return response.data; 
                });
            }],
            users: [ 'UserService', function( UserService ) {

              return UserService.query()
                .then(function(response){
                  return response.data; 
                });
            }],
          }
        })

    }]);
}());

/*
 * Modal Routed Component
 */
(function() {

  'use strict';

  angular
    .module('tyallsApp')
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('app.app-admin.user-admin-console.confirm-toggle-user-dialog', {
          params: {
            onPositiveConfirm: null,
            titleText: null,
            bodyText: null,
          }, // non-url params
          resolve: {
            titleText: ['$transition$', function($transition$) {
              return $transition$.params().titleText;
            }],
            bodyText: ['$transition$', function($transition$) {
              return $transition$.params().bodyText;
            }],
            onPositiveConfirm: ['$transition$', function($transition$) {
              return $transition$.params().onPositiveConfirm;
            }]
          },
          onEnter: ['onPositiveConfirm', 'titleText', 'bodyText', '$state', '$uibModal', function(onPositiveConfirm, titleText, bodyText, $state, $uibModal) {
            $uibModal.open({   
              templateUrl: 'app/components/util/confirm-modal.html',
              controller: 'ConfirmModalController',
              controllerAs: '$ctrl',
              backdrop: 'static',   
              size: 'md',      
              resolve: {
                // passing native Strings, so need objects
                titleText: { value: titleText },
                bodyText: { value: bodyText },
                onPositiveConfirm: { value: onPositiveConfirm },
              }                
            }).result.then(function() {
              $state.go('^');
            }, function() {    
              $state.go('^');  
            });
          }]
        })

    }]);
}());

(function() {

  'use strict';
  
  ScheduleAdminConsoleController.$inject = [ 'ScheduleService', '$state' ];

  function ScheduleAdminConsoleController( ScheduleService, $state ) {
    var ctrl = this; 

    ctrl.$onInit = function() {
    }

    ctrl.goToCreateSchedule = function() {
      $state.go('app.app-admin.create-schedule-dialog', { 
        propertyId: ctrl.propertyId,
        onCreateSchedule: ctrl.createSchedule,
      });
    }

    // cb -- let caller handle catch, must return promise
    ctrl.createSchedule = function($event) {
      return ScheduleService.createSchedule($event.schedule);
    }
  }

  angular
    .module('tyallsApp')
    .controller('ScheduleAdminConsoleController', ScheduleAdminConsoleController);
}());


(function() {

  'use strict';

  var scheduleAdminConsole = {
    templateUrl: 'app/entities/app-admin/schedule-admin-console/schedule-admin-console.html',
    bindings: {
      // users: '<',
      properties: '<',
    },
    controller: 'ScheduleAdminConsoleController',
  }

  angular
    .module('tyallsApp')
    .component('scheduleAdminConsole', scheduleAdminConsole) 
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('app.app-admin.schedule-admin-console', {
          url: '/schedules',
          views: {
            'schedule-admin-console@^': {
              component: 'scheduleAdminConsole',
            }
          },
          resolve: {
            properties: [ 'PropertyService', function( PropertyService ) {
              return PropertyService.getAllPropertiesForAdmin()
                .then(function(response) {
                  return response.data; 
                });
            }],
            // users: [ 'UserService', function( UserService ) {
            //
            //   return UserService.query()
            //     .then(function(response){
            //       return response.data; 
            //     });
            // }],
          }
        })

    }]);
}());

(function () {

    'use strict';

    InviteConsoleController.$inject = ['InviteService', 'UserService', '$state'];

    function InviteConsoleController(InviteService, UserService, $state) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.invites = [];
            ctrl.idToUserLookup = {};
        }

        ctrl.$onChanges = function (changes) {
            if (changes.propertyId) {
                InviteService.getWithPropertyId(changes.propertyId.currentValue).then(function (response) {
                    ctrl.invites = response.data;
                })
                    .catch(function (response) {
                        ('oops');
                    });

                // refresh the lookups
                UserService.getWithPropertyId(changes.propertyId.currentValue).then(function (response) {
                    ctrl.idToUserLookup = {};
                    angular.forEach(response.data, function (value) {
                        this[value.id] = value;
                    }, ctrl.idToUserLookup);
                })
                    .catch(function (reason) {

                    });
            }
        }

        ctrl.goToCreateUserInvite = function (propertyId) {
            $state.go('app.prop.app-admin.create-user-invite-dialog', {
                propertyId: ctrl.propertyId
            });
        }
    }

    angular
        .module('tyallsApp')
        .controller('InviteConsoleController', InviteConsoleController);
}());


(function () {

    'use strict';

    var inviteConsole = {
        templateUrl: 'app/entities/app-admin/invite-console/invite-console.html',
        bindings: {
            propertyId: '<',
        },
        controller: 'InviteConsoleController',
    }

    angular
        .module('tyallsApp')
        .component('inviteConsole', inviteConsole)
    ;
}());

(function() {
  'use strict';

  AppAdminDetailUserDialogController.$inject = ['onAddUserToProperty', 'onRemoveUserFromProperty', 'user', 'properties', '$uibModalInstance'];

  function AppAdminDetailUserDialogController(onAddUserToProperty, onRemoveUserFromProperty, user, properties, $uibModalInstance) {
    var ctrl = this;

    ctrl.$onInit = function() {
      ctrl.selectedProperty = {
      };

      ctrl.serverMessage = undefined;
      ctrl.user = user.value;

      // only show properties not already a member
      ctrl.properties = properties.value.filter(function(obj) {
    return !ctrl.user.propertyProfiles.some(function(obj2) {
        return obj.id == obj2.propertyId && obj2.profileName === 'USER';
    });
});
      ctrl.onAddUserToProperty = onAddUserToProperty.value;
      ctrl.onRemoveUserFromProperty = onRemoveUserFromProperty.value;

      ctrl.propertyLookup = {};
      properties.value.forEach(function(value) {
        ctrl.propertyLookup[value.id] = value;
      });
    }

    ctrl.clear = function() {
      $uibModalInstance.dismiss('cancel');
    }

    ctrl.removeUserFromProperty = function(propertyId) {
      ctrl.isSaving = true;

      ctrl.onRemoveUserFromProperty({
        user: ctrl.user,
        property: ctrl.propertyLookup[propertyId]
      })
        .then(onSaveSuccess)
        .catch(onSaveError)
        .finally(function() {
          ctrl.isSaving = false;
        });
    }

    ctrl.save = function() {
      ctrl.isSaving = true;

      ctrl.onAddUserToProperty({
        user: ctrl.user,
        property: ctrl.propertyLookup[ctrl.selectedProperty.propertyId]
      })
        .then(onSaveSuccess)
        .catch(onSaveError)
        .finally(function() {
          ctrl.isSaving = false;
        });
    }

    function onSaveSuccess (result) {
      $uibModalInstance.close(result);
    }

    function onSaveError (reason) {
      ctrl.serverMessage = reason.data.message;
    }
  }

  angular
    .module('tyallsApp')
    .controller('AppAdminDetailUserDialogController', AppAdminDetailUserDialogController);
})();

/*
 * Modal Routed Component
 */
(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.app-admin.detail-user-dialog', {
                    // url: '/user/create',  // modal -- no url
                    params: {
                        user: null,
                        onAddUserToProperty: null,
                        onRemoveUserFromProperty: null,
                    },
                    resolve: {
                        properties: ['PropertyService', function (PropertyService) {
                            return PropertyService.getAllPropertiesForAdmin()
                                .then(function (response) {
                                    return response.data;
                                });
                        }],
                        onAddUserToProperty: ['$transition$', function ($transition$) {
                            return $transition$.params().onAddUserToProperty;
                        }],
                        onRemoveUserFromProperty: ['$transition$', function ($transition$) {
                            return $transition$.params().onRemoveUserFromProperty;
                        }],
                        user: ['$transition$', function ($transition$) {
                            return $transition$.params().user;
                        }]

                    },
                    data: {
                        authorities: []
                    },
                    onEnter: ['onAddUserToProperty', 'onRemoveUserFromProperty', 'user', 'properties', '$state', '$uibModal', function (onAddUserToProperty, onRemoveUserFromProperty, user, properties, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/app-admin/detail-user-dialog/app-admin-detail-user-dialog.html',
                            controller: 'AppAdminDetailUserDialogController',
                            controllerAs: '$ctrl',
                            backdrop: 'static',
                            size: 'md',
                            resolve: {
                                user: {value: user},
                                properties: {value: properties},
                                onAddUserToProperty: {value: onAddUserToProperty},
                                onRemoveUserFromProperty: {value: onRemoveUserFromProperty},
                            }
                        }).result.then(function (response) {
                            $state.go('^');
                        }, function () {
                            $state.go('^');
                        });
                    }]
                })

        }]);

})();

(function () {
    'use strict';


    AppAdminCreateWfdDialogController.$inject = ['ProcessDefinitionDTOService', '$scope', 'onCreateWfd', 'properties', '$uibModalInstance'];

    function AppAdminCreateWfdDialogController(ProcessDefinitionDTOService, $scope, onCreateWfd, properties, $uibModalInstance) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.selectedWfd = {};
            ctrl.workflowDefinitionKeys = [];
            ctrl.serverMessage = undefined;
            ctrl.properties = properties.value;
            ctrl.onCreateWfd = onCreateWfd.value;

            ctrl.dailyStates = [
                {'id': 'DAILY', 'desc': 'Daily'},
                {'id': 'NONDAILY', 'desc': 'Non Daily'},
            ];
        }

        // $scope.$watch(function() { return ctrl.selectedWfd.propertyId}, function(newValue) {
        //   if (newValue) {
        //     ProcessDefinitionDTOService
        //       .getAllNonDailyProcessDefinitionDTO(newValue)
        //       .then(function(response) {
        //         console.log(response.data);
        //         ctrl.workflowDefinitions = [];
        //         angular.forEach(response.data, function(value) {
        //           ctrl.workflowDefinitions.push(value.key);
        //         });
        //
        //         // set the timezoneid
        //         ctrl.timezoneId = ctrl.properties.filter(function(item){ return item.id === newValue; })[0].timezoneId;
        //
        //         console.log(ctrl.timezoneId);
        //
        //
        //       })
        //       .catch(function(reason) {
        //
        //       });
        //   }
        // });

        ctrl.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        ctrl.save = function () {
            ctrl.isSaving = true;

            ctrl.onCreateWfd({
                wfd: ctrl.selectedWfd
            })
                .then(onSaveSuccess)
                .catch(onSaveError)
                .finally(function () {
                    ctrl.isSaving = false;
                });
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
        }

        function onSaveError(reason) {
            ctrl.serverMessage = reason.data.message;
        }
    }

    angular
        .module('tyallsApp')
        .controller('AppAdminCreateWfdDialogController', AppAdminCreateWfdDialogController);
})();

/*
 * Modal Routed Component
 */
(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.app-admin.create-wfd-dialog', {
                    // url: '/user/create',  // modal -- no url
                    params: {
                        onCreateWfd: null,
                    },
                    resolve: {
                        properties: ['PropertyService', function (PropertyService) {
                            return PropertyService.getAllPropertiesForAdmin()
                                .then(function (response) {
                                    return response.data;
                                });
                        }],
                        onCreateWfd: ['$transition$', function ($transition$) {
                            return $transition$.params().onCreateWfd;
                        }]

                    },
                    data: {
                        authorities: []
                    },
                    onEnter: ['onCreateWfd', 'properties', '$state', '$uibModal', function (onCreateWfd, properties, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/app-admin/create-wfd-dialog/app-admin-create-wfd-dialog.html',
                            controller: 'AppAdminCreateWfdDialogController',
                            controllerAs: '$ctrl',
                            backdrop: 'static',
                            size: 'md',
                            resolve: {
                                properties: {value: properties},
                                onCreateWfd: {value: onCreateWfd},
                            }
                        }).result.then(function (response) {
                            $state.go('^');
                        }, function () {
                            $state.go('^');
                        });
                    }]
                })

        }]);

})();

(function() {
  'use strict';

  AppAdminCreateUserInviteDialogController.$inject = ['propertyId', '$uibModalInstance', 'UserInviteService' ];

  function AppAdminCreateUserInviteDialogController(propertyId, $uibModalInstance, UserInviteService) {
    var ctrl = this;

    ctrl.$onInit = function() {
      ctrl.propertyId = propertyId;
    }

    ctrl.clear = function() {
      $uibModalInstance.dismiss('cancel');
    }

    ctrl.save = function() {
      ctrl.isSaving = true;

      var propertyAndEmailVm = {
        propertyId: ctrl.propertyId,
        email: ctrl.selectedUser.email
      };
      UserInviteService
        .save(propertyAndEmailVm)
        .then(onSaveSuccess)
        .catch(onSaveError);
    }

    function onSaveSuccess (result) {
      $uibModalInstance.close(result);
      ctrl.isSaving = false;
    }

    function onSaveError () {
      ctrl.isSaving = false;
    }
  }

  angular
    .module('tyallsApp')
    .controller('AppAdminCreateUserInviteDialogController', AppAdminCreateUserInviteDialogController);

})();

/*
 * Modal Routed Component
 */
(function() {
  'use strict';

  angular
    .module('tyallsApp')
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('app.prop.app-admin.create-user-invite-dialog', {
          // url: '/user/create-invite',  // modal -- no url
          params: { 
            propertyId: null,
            onCreateUserInvite: null,
          },
          data: {
            authorities: []
          },
          resolve: {
            propertyId: ['$transition$', function($transition$) {
              return $transition$.params().propertyId;
            }],
            onCreateUserInvite: ['$transition$', function($transition$) {
              return $transition$.params().onCreateUserInvite;
            }]
          },
          onEnter: ['onCreateUserInvite', 'propertyId', '$state', '$uibModal', function(onCreateUserInvite, propertyId, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'app/entities/app-admin/create-user-invite-dialog/app-admin-create-user-invite-dialog.html',
              controller: 'AppAdminCreateUserInviteDialogController',
              controllerAs: '$ctrl',
              backdrop: 'static',
              size: 'md',
              resolve: {
                propertyId: { value: propertyId },
                onCreateUserInvite: { value: onCreateUserInvite },
              }
            }).result.then(function() {
              $state.go('^');
            }, function() {
              $state.go('^');
            });
          }]
        });

    }]);
})();

(function() {
  'use strict';

  AppAdminCreateUserGroupDialogController.$inject = ['onCreateGroup', '$uibModalInstance' ];

  function AppAdminCreateUserGroupDialogController(onCreateGroup, $uibModalInstance ) {
    var ctrl = this;

    ctrl.$onInit = function() {
      ctrl.serverMessage = undefined; 
      ctrl.onCreateGroup = onCreateGroup.value;
    }

    ctrl.clear = function() {
      $uibModalInstance.dismiss('cancel');
    }

    ctrl.confirm = function() {
      ctrl.isSaving = true;

      ctrl.onPositiveConfirm()
        .then(onSaveSuccess)
        .catch(onSaveError)
        .finally(function() {
          ctrl.isSaving = false;
        });

    }

    function onSaveSuccess (result) {
      $uibModalInstance.close(result);
    }

    function onSaveError (reason) {
      ctrl.serverMessage = reason.data.message;
    }
  }

  angular
    .module('tyallsApp')
    .controller('AppAdminCreateUserGroupDialogController', AppAdminCreateUserGroupDialogController);
})();

/*
 * Modal Routed Component
 */
(function() {
  'use strict';

  angular
    .module('tyallsApp')
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider 
        .state('app.prop.app-admin.create-user-group-dialog', {
          // url: '/user-group/create', // modal -- no url
          data: {
            authorities: []
          },
          resolve: {
            onCreateUserGroup: ['$transition$', function($transition$) {
              return $transition.params().onCreateUserGroup;
            }]
          },
          onEnter: ['onCreateUserGroup', '$state', '$uibModal', function( onCreateUserGroup, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'app/entities/app-admin/create-user-group-dialog/app-admin-create-user-group-dialog.html',
              controller: 'AppAdminCreateUserGroupDialogController',
              controllerAs: '$ctrl',
              backdrop: 'static',
              size: 'md',
              resolve: {
                onCreateUserGroup: { value: onCreateUserGroup },
              }
            }).result.then(function() {
              $state.go('^');
            }, function() {
              $state.go('^');
            });
          }]
        })
      ;
    }]);
})();

(function () {
    'use strict';


    AppAdminCreateUserDialogController.$inject = ['onCreateUser', 'properties', '$uibModalInstance'];

    function AppAdminCreateUserDialogController(onCreateUser, properties, $uibModalInstance) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.selectedUser = {};

            ctrl.serverMessage = undefined;
            ctrl.properties = properties.value;
            ctrl.onCreateUser = onCreateUser.value;
        }

        ctrl.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        ctrl.save = function () {
            ctrl.isSaving = true;

            ctrl.onCreateUser({
                user: ctrl.selectedUser
            })
                .then(onSaveSuccess)
                .catch(onSaveError)
                .finally(function () {
                    ctrl.isSaving = false;
                });
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
        }

        function onSaveError(reason) {
            ctrl.serverMessage = reason.data.message;
        }
    }

    angular
        .module('tyallsApp')
        .controller('AppAdminCreateUserDialogController', AppAdminCreateUserDialogController);
})();

/*
 * Modal Routed Component
 */
(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.app-admin.create-user-dialog', {
                    // url: '/user/create',  // modal -- no url
                    params: {
                        onCreateUser: null,
                    },
                    resolve: {
                        properties: ['PropertyService', function (PropertyService) {
                            return PropertyService.getAllPropertiesForAdmin()
                                .then(function (response) {
                                    return response.data;
                                });
                        }],
                        onCreateUser: ['$transition$', function ($transition$) {
                            return $transition$.params().onCreateUser;
                        }]

                    },
                    data: {
                        authorities: []
                    },
                    onEnter: ['onCreateUser', 'properties', '$state', '$uibModal', function (onCreateUser, properties, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/app-admin/create-user-dialog/app-admin-create-user-dialog.html',
                            controller: 'AppAdminCreateUserDialogController',
                            controllerAs: '$ctrl',
                            backdrop: 'static',
                            size: 'md',
                            resolve: {
                                properties: {value: properties},
                                onCreateUser: {value: onCreateUser},
                            }
                        }).result.then(function (response) {
                            $state.go('^');
                        }, function () {
                            $state.go('^');
                        });
                    }]
                })

        }]);

})();

(function() {
  'use strict';


  AppAdminCreateScheduleDialogController.$inject = ['ProcessDefinitionDTOService', '$scope', 'onCreateSchedule', 'properties', '$uibModalInstance'];

  function AppAdminCreateScheduleDialogController(ProcessDefinitionDTOService, $scope, onCreateSchedule, properties, $uibModalInstance) {
    var ctrl = this;

    ctrl.$onInit = function() {
      ctrl.selectedSchedule = {
      };
      ctrl.timezoneId = null;
      ctrl.workflowDefinitionKeys = [];
      ctrl.serverMessage = undefined;
      ctrl.properties = properties.value;
      ctrl.onCreateSchedule = onCreateSchedule.value;
    }

    $scope.$watch(function() { return ctrl.selectedSchedule.propertyId}, function(newValue) {
      if (newValue) {
        ProcessDefinitionDTOService
          .getAllNonDailyProcessDefinitionDTO(newValue)
          .then(function(response) {
            (response.data);
            ctrl.workflowDefinitions = [];
            angular.forEach(response.data, function(value) {
              ctrl.workflowDefinitions.push(value.key);
            });

            // set the timezoneid
            ctrl.timezoneId = ctrl.properties.filter(function(item){ return item.id === newValue; })[0].timezoneId;

            (ctrl.timezoneId);


          })
          .catch(function(reason) {

          });
      }
    });

    ctrl.clear = function() {
      $uibModalInstance.dismiss('cancel');
    }

    ctrl.save = function() {
      ctrl.isSaving = true;

      ctrl.onCreateSchedule({
        schedule: ctrl.selectedSchedule
      })
        .then(onSaveSuccess)
        .catch(onSaveError)
        .finally(function() {
          ctrl.isSaving = false;
        });
    }

    function onSaveSuccess (result) {
      $uibModalInstance.close(result);
    }

    function onSaveError (reason) {
      ctrl.serverMessage = reason.data.message;
    }
  }

  angular
    .module('tyallsApp')
    .controller('AppAdminCreateScheduleDialogController', AppAdminCreateScheduleDialogController);
})();

/*
 * Modal Routed Component
 */
(function() {
  'use strict';

  angular
    .module('tyallsApp')
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('app.app-admin.create-schedule-dialog', {
          // url: '/user/create',  // modal -- no url
          params: {
            onCreateSchedule: null,
          },
          resolve: {
            properties: [ 'PropertyService', function( PropertyService ) {
              return PropertyService.getAllPropertiesForAdmin()
                .then(function(response) {
                  return response.data; 
                });
            }],
            onCreateSchedule: ['$transition$', function($transition$) {
              return $transition$.params().onCreateSchedule;
            }]

          },
          data: {
            authorities: []
          },
          onEnter: ['onCreateSchedule', 'properties', '$state', '$uibModal', function(onCreateSchedule, properties, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'app/entities/app-admin/create-schedule-dialog/app-admin-create-schedule-dialog.html',
              controller: 'AppAdminCreateScheduleDialogController',
              controllerAs: '$ctrl',
              backdrop: 'static',
              size: 'md',
              resolve: {
                properties: { value: properties },
                onCreateSchedule: { value: onCreateSchedule },
              }
            }).result.then(function(response) {
              $state.go('^');
            }, function() {
              $state.go('^');
            });
          }]
        })

    }]);

})();

(function() {
  'use strict';


  AppAdminController.$inject = [];

  function AppAdminController() {
    var ctrl = this;

    ctrl.$onInit = function() {
    }

    ctrl.$onChanges = function(changes) {
    }
  }

  angular
    .module('tyallsApp')
    .controller('AppAdminController', AppAdminController);
})();

/*
 * Routed Component
 */
(function() {
  'use strict';

  var appAdmin = {
    templateUrl: 'app/entities/app-admin/app-admin.html',
    bindings: {
    },
    controller: 'AppAdminController'
  };

  angular
    .module('tyallsApp')
    .component('appAdmin', appAdmin)
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('app.app-admin', {
          url: '/app-admin',
          redirectTo: 'app.app-admin.user-admin-console',
          data: {
            authorities: [],
            pageTitle: 'AppAdmin'
          },
          views: {
            '@^': 'appAdmin'
          },
        })

    }]);
})();

(function() {
  'use strict';

  RemoveUnassignableProfiles.$inject = [];

  function RemoveUnassignableProfiles() {
    return function(propertyProfiles) {
      var out = [];
      for(var i = 0; i < propertyProfiles.length; i++) {
        if ( 
          propertyProfiles[i].profileName !== 'REVIEWER' && 
          propertyProfiles[i].profileName !== 'REPORTER' && 
          propertyProfiles[i].profileName !== 'INITIATOR' ) {continue;};

        out.push(propertyProfiles[i]);
      }
      return out;
    }
  }

  angular
    .module('tyallsApp')
    .filter('removeUnassignableProfiles', RemoveUnassignableProfiles);

})();  

(function() {
  'use strict'

  PropertySelectorController.$inject = ['$cookies'];

  function PropertySelectorController($cookies) {
    var ctrl = this;

    ctrl.$onInit = function () {
      ctrl.disabled = false;

      ctrl.defaultOptionText = '-- select a property --';
      ctrl.defaultPropertyId = angular.copy(Number(ctrl.defaultPropertyId));
      if (ctrl.idToPropertyLookup) {
        if (ctrl.idToPropertyLookup.length === 1) {
          var p = ctrl.idToPropertyLookup[0].id
          ctrl.defaultPropertyId = p;
          ctrl.selectProperty(p);
        } else if ($cookies.get('selectedProp')) {

        } else if (ctrl.defaultPropertyId) {
          var q = ctrl.idToPropertyLookup.filter(function (value) {
            return value.id === +ctrl.defaultPropertyId;
          })[0].id;
          ctrl.defaultPropertyId = q;
          ctrl.selectProperty(q);
        }
      }
    }

    ctrl.selectProperty = function(property) {
      var propId = Number(property)
      $cookies.put('selectedProp', propId);
      ctrl.onSelectProperty({
        $event: {
          property: propId,
        }
      });
    }

    ctrl.$onChanges = function(changes) {
      // watch the defaultPropertyId
      if( changes.defaultPropertyId && changes.defaultPropertyId.currentValue ) {
        ctrl.defaultPropertyId = Number(changes.defaultPropertyId.currentValue);
      }

      if (!!changes.idToPropertyLookup && !!changes.idToPropertyLookup.currentValue && !changes.idToPropertyLookup.isFirstChange()) {
        if (changes.idToPropertyLookup.currentValue.length ===1) {
          ctrl.selectProperty(changes.idToPropertyLookup.currentValue[0].id);
          ctrl.defaultPropertyId = changes.idToPropertyLookup.currentValue[0].id;

        }
        ctrl.idToPropertyLookup = angular.copy(changes.idToPropertyLookup.currentValue);
      }

    }
  }

  angular
    .module('tyallsApp')
    .controller('PropertySelectorController', PropertySelectorController);
}());

(function() {
  'use strict';

  var propertySelector = {
    templateUrl: 'app/components/util/property-selector.html', 
    bindings: {
      idToPropertyLookup: '<',  
      defaultPropertyId: '<',   
      onSelectProperty: '&',    
      disabled: '<',            
    },
    controller: 'PropertySelectorController',
  };

  angular
    .module('tyallsApp')
    .component('propertySelector', propertySelector);
})();

(function() {
    'use strict';

    angular
        .module('tyallsApp')
        .service('getHeaderFilename', getHeaderFilename);

    getHeaderFilename.$inject = [];

    function getHeaderFilename() {
        return function(headers) {
            var header = headers('content-disposition');
            var result = header.split(';')[1].trim().split('=')[1];
            return result.replace(/"/g, '');
        };
    }

})();

(function() {
  'use strict';

  FilterUserRows.$inject = [];

  function FilterUserRows() {
    return function(users, doFilter, isFiltered) {
      if (!doFilter) {
        return users;
      } else {

        var out = [];
        for(var i = 0; i < users.length; i++) {
          if (!!isFiltered[users[i].id]) {
            out.push(users[i]);
          }
        }
      }
      return out;
    }
  }

  angular
    .module('tyallsApp')
    .filter('filterUserRows', FilterUserRows);

})();  

(function() {
    'use strict';

    angular
        .module('tyallsApp')
        .directive('fileModel', fileModel);

    fileModel.$inject = ['$parse'];

    function fileModel ($parse) {
        var directive = {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                element.bind('change', function() {
                    scope.$apply(model.assign(scope, element[0].files[0]));
                });
            }
        };

        return directive;
    }

})();

(function() {
  'use strict';

  ConfirmModalController.$inject = ['$uibModalInstance', 'titleText', 'bodyText', 'onPositiveConfirm'];

  function ConfirmModalController($uibModalInstance, titleText, bodyText, onPositiveConfirm) {
    var ctrl = this;

    ctrl.$onInit = function() {

      ctrl.serverMessage = undefined;
      ctrl.bodyText = bodyText.value;
      ctrl.titleText = titleText.value;
      ctrl.onPositiveConfirm = onPositiveConfirm.value;
    }

    ctrl.clear = function() {
      $uibModalInstance.dismiss('cancel');
    }

    ctrl.confirm = function() {
      ctrl.isSaving = true;

      ctrl.onPositiveConfirm()
        .then(onSaveSuccess)
        .catch(onSaveError)
        .finally(function() {
          ctrl.isSaving = false;
        });

    }

    function onSaveSuccess (result) {
      $uibModalInstance.close(result);
    }

    function onSaveError (reason) {
      ctrl.serverMessage = reason.data.message;
    }

  }

  angular
    .module('tyallsApp')
    .controller('ConfirmModalController', ConfirmModalController);

})();  

(function() {
    'use strict';

    angular.module('tyallsApp')
        .directive('accountCard', accountCard);

    accountCard.$inject = [];

    function accountCard() {
        return {
            restrict: 'E',
            scope: {
                account: '='
            },
            template: ['<section id="user-info" style="margin-bottom: 10px">',
                '{{account.username}}   {{account.firstName}}',
                '<ul>profiles: [ <li ng-repeat="profile in account.profiles">{{profile}}</li> ]</ul>',
                '<ul>groups: [ <li ng-repeat="group in account.groups">{{group}}</li> ]</ul>',
                '<ul>properties: [ <li ng-repeat="property in account.properties">{{property}}</li> ]</ul>',
                '</section>'].join('')
        };
    }
})();



(function() {                  
  'use strict';

  LoginDialogController.$inject = ['$rootScope', '$state', '$timeout', 'AuthService', '$uibModalInstance'];

  function LoginDialogController ($rootScope, $state, $timeout, AuthService, $uibModalInstance) {
    var ctrl = this;

    ctrl.authenticationError = false;
    ctrl.credentials = {};
    ctrl.password = null;
    ctrl.rememberMe = true;
    ctrl.username = null;
    ctrl.resetUsername = null;
    ctrl.isResetingPassword = false;
    ctrl.hasBeenReset = false
    ctrl.isLoading = false;

    $timeout(function () {
      angular.element('#username').focus();
    });

    ctrl.cancel = function () {
      ctrl.credentials = {
        username: null,
        password: null,
        rememberMe: true
      };
      ctrl.authenticationError = false; 
      $uibModalInstance.dismiss('cancel');
    }       

    ctrl.login = function(event) {        
      event.preventDefault();         
      AuthService.login({
        username: ctrl.username,          
        password: ctrl.password,          
        rememberMe: ctrl.rememberMe       
      }).then(function () {           
        ctrl.authenticationError = false; 
        $uibModalInstance.close();      
        if ($state.current.name === 'register' || $state.current.name === 'activate' ||
          $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
            $state.go('app.home');              
        }

        $rootScope.$broadcast('authenticationSuccess');

        // previousState was set in the authExpiredInterceptor before being redirected to login modal.
        // since login is successful, go to stored previousState and clear previousState
        if (AuthService.getPreviousState()) {
          var previousState = AuthService.getPreviousState();
          AuthService.resetPreviousState();
          $state.go(previousState.name, previousState.params, {reload: true});
        }
        window.DD_RUM && window.DD_RUM.addRumGlobalContext('usr', {
          username: ctrl.username,
        });
      }).catch(function () {
        ctrl.authenticationError = true;
      });
    }

    ctrl.requestResetPassword = function () {
      ctrl.isResetingPassword = true;
    }

    ctrl.close = function () {
      $uibModalInstance.dismiss('cancel');
    }

    ctrl.requestReset = function (event) {

      event.preventDefault();
      ctrl.isLoading = true;
      AuthService.resetPasswordInit(ctrl.resetUsername).then(function () {
        ctrl.isResetingPassword = false;
        ctrl.hasBeenReset = true;
        ctrl.isLoading = false;
      }).catch(function (response) {
        console.log(JSON.stringify(response));
        ctrl.isResetingPassword = false;
        ctrl.hasBeenReset = true;
        ctrl.isLoading = false;
      });
    }
  }

  angular
    .module('tyallsApp')
    .controller('LoginDialogController', LoginDialogController);
})();

(function() {                  
  'use strict';

  LoginService.$inject = ['$uibModal'];

  function LoginService ($uibModal) {
    var service = {        
      open: open
    };

    var modalInstance = null;
    var resetModal = function () {  
      modalInstance = null;           
    };  

    return service;

    function open () {     
      if (modalInstance !== null) return;
      // modals must use controllers!
      modalInstance = $uibModal.open({
        animation: true,                
        templateUrl: 'app/components/login/login-dialog.html',
        controller: 'LoginDialogController',  
        controllerAs: '$ctrl',             
      });
      modalInstance.result.then(      
        resetModal,
        resetModal
      );
    }   
  }

  angular
    .module('tyallsApp')
    .factory('LoginService', LoginService);

})();

(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .factory('delayInterceptor', delayInterceptor);

    delayInterceptor.$inject = ['$timeout'];

    function delayInterceptor($timeout) {
        return {
            response:
                function (response) {
                    console.log(response.config.url);

                    // only put a delay for specific URLS
                    if (response.config.url.match(/user-wfi-summary/g)) {
                        return $timeout(function () {
                            return response;
                        }, 2500);
                    } else {
                        return response;
                    }
                }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector'];

    function authExpiredInterceptor($rootScope, $q, $injector) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var AuthService = $injector.get('AuthService');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                AuthService.logout();
                if (to && to.name !== 'accessdenied') {
                    AuthService.storePreviousState(to.name, params);
                }
                var LoginService = $injector.get('LoginService');
                LoginService.open();
            }
            return $q.reject(response);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$window', 'AuthService', 'PrincipalService', 'VERSION', '$injector'];

    function stateHandler($rootScope, $state, $window, AuthService, PrincipalService, VERSION, $injector) {
        return {
            initialize: initialize
        };

        function initialize() {

            $state.defaultErrorHandler(function (error) {

                if (error.type === 6) {
                    if (error.detail.status === 401) {
                        console.log("API call got 401, attempting login")
                        var LoginService = $injector.get('LoginService');
                        LoginService.open();
                    }
                } else {
                    console.error(error);
                }
            });
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (PrincipalService.isIdentityResolved()) {
                    AuthService.authorize();
                }
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                // scroll to the top of the page
                document.body.scrollTop = document.documentElement.scrollTop = 0;
            });

            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
                if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();     

(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {

       httpRequestInterceptorCacheBusterProvider.setMatchlist([
        /.*protected.*/,
        /.*authentication.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('authExpiredInterceptor');

        // this will introduce a false delay for debugging
        // $httpProvider.interceptors.push('delayInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name: 'boolean',
            decode: function (val) {
                return val === true || val === 'true';
            },
            encode: function (val) {
                return val ? 1 : 0;
            },
            equals: function (a, b) {
                return this.is(a) && a === b;
            },
            is: function (val) {
                return [true, false, 0, 1].indexOf(val) >= 0;
            },
            pattern: /bool|true|0|1/
        });
    }
})(); 

(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider', 'DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider, DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*  
    If you wish to debug an application with this information
    then you should open up a debug console in the browser
    then call this method directly in this console:

    angular.reloadWithDebugInfo();
    */
    }
})(); 

(function () {
    'use strict'

    AppNavController.$inject = ['VERSION', '$state', 'AuthService', 'PrincipalService', 'LoginService'];

    function AppNavController(VERSION, $state, AuthService, PrincipalService, LoginService) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.isNavbarCollapsed = true;
            ctrl.isAuthenticated = PrincipalService.isAuthenticated;

            ctrl.VERSION = VERSION;
            ctrl.$state = $state;

            angular.element(document).ready(function () {
                feather.replace();
            });
        }

        ctrl.login = function () {
            ctrl.collapseNavbar();
            LoginService.open();
        }

        ctrl.logout = function () {
            ctrl.collapseNavbar();
            AuthService.logout();
            $state.go('app.home');
        }

        ctrl.toggleNavbar = function () {
            ctrl.isNavbarCollapsed = !ctrl.isNavbarCollapsed;
        }

        ctrl.collapseNavbar = function () {
            ctrl.isNavbarCollapsed = true;
        }
    }

    angular
        .module('tyallsApp')
        .controller('AppNavController', AppNavController);
}());

(function () {
    'use strict'

    var appNav = {
        templateUrl: 'app/app-nav/app-nav.html',
        bindings: {},
        controller: 'AppNavController'
    };

    angular
        .module('tyallsApp')
        .component('appNav', appNav);
}());

(function() {
  'use strict';

  AppController.$inject = [];

  function AppController() {
    var ctrl = this;

    ctrl.$onInit = function() {
    }

  };

  angular
    .module('tyallsApp')
    .controller('AppController', AppController);
}());

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('tyallsApp')
        .constant('VERSION', "1.13.0-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

/*
 * Routed Component
 */
(function () {
    'use strict';

    var app = {
        templateUrl: 'app/app.html',
        bindings: {
            account: '<',  // [THIS.RESOLVE]
        },
        controller: 'AppController'
    };

    angular
        .module('tyallsApp')
        .component('app', app)
        .config(['$stateProvider', function ($stateProvider) {

            $stateProvider
                .state('app', {
                    abstract: true,
                    component: 'app',
                    resolve: {
                        account: ['PrincipalService', function (PrincipalService) {
                            return PrincipalService.identity();
                        }]
                    }
                });
        }]);
}());

(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app.account.requestReset', {
            // parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                '@app': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'AuthService'];

    function RequestResetController($timeout, AuthService) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function () {
            angular.element('#email').focus();
        });

        function requestReset() {

            vm.error = null;
            vm.errorEmailNotExists = null;

            AuthService.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'email address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app.account.finishReset', {
            // parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                '@app': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'AuthService', 'LoginService'];

    function ResetFinishController($stateParams, $timeout, AuthService, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function () {
            angular.element('#password').focus();
        });

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                AuthService.resetPasswordFinish({
                    key: $stateParams.key,
                    newPassword: vm.resetAccount.password
                }).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function () {
    'use strict';


    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app.account', {
            abstract: true,
            // parent: 'app'
        });
    }

    angular
        .module('tyallsApp')
        .config(stateConfig);
})();
(function(){'use strict';angular.module('tyallsApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/app.html','<app-nav></app-nav><div bs-loading-overlay class="bs-loading-container" ui-view></div>');
$templateCache.put('app/loading-overlay-template.html','<div style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; background-color: rgba(255,255,255,0.7);"><div class="floatingCircleGWrapper"><div id="floatingCirclesG"><div class="f_circleG" id="frotateG_01"></div><div class="f_circleG" id="frotateG_02"></div><div class="f_circleG" id="frotateG_03"></div><div class="f_circleG" id="frotateG_04"></div><div class="f_circleG" id="frotateG_05"></div><div class="f_circleG" id="frotateG_06"></div><div class="f_circleG" id="frotateG_07"></div><div class="f_circleG" id="frotateG_08"></div></div></div><style>.floatingCircleGWrapper {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 61px;\n  height: 61px;\n  margin: auto;\n  background-color: #32465A;\n  border-radius: 10px;\n}\n\n        #floatingCirclesG {\n          position: absolute;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          width: 51px;\n          height: 51px;\n          margin: auto;\n          transform: scale(0.6);\n          -o-transform: scale(0.6);\n          -ms-transform: scale(0.6);\n          -webkit-transform: scale(0.6);\n          -moz-transform: scale(0.6);\n        }\n\n        .f_circleG {\n          position: absolute;\n          background-color: rgb(255, 255, 255);\n          height: 9px;\n          width: 9px;\n          border-radius: 5px;\n          -o-border-radius: 5px;\n          -ms-border-radius: 5px;\n          -webkit-border-radius: 5px;\n          -moz-border-radius: 5px;\n          animation-name: f_fadeG;\n          -o-animation-name: f_fadeG;\n          -ms-animation-name: f_fadeG;\n          -webkit-animation-name: f_fadeG;\n          -moz-animation-name: f_fadeG;\n          animation-duration: 0.622s;\n          -o-animation-duration: 0.622s;\n          -ms-animation-duration: 0.622s;\n          -webkit-animation-duration: 0.622s;\n          -moz-animation-duration: 0.622s;\n          animation-iteration-count: infinite;\n          -o-animation-iteration-count: infinite;\n          -ms-animation-iteration-count: infinite;\n          -webkit-animation-iteration-count: infinite;\n          -moz-animation-iteration-count: infinite;\n          animation-direction: normal;\n          -o-animation-direction: normal;\n          -ms-animation-direction: normal;\n          -webkit-animation-direction: normal;\n          -moz-animation-direction: normal;\n        }\n\n        #frotateG_01 {\n          left: 0;\n          top: 21px;\n          animation-delay: 0.2295s;\n          -o-animation-delay: 0.2295s;\n          -ms-animation-delay: 0.2295s;\n          -webkit-animation-delay: 0.2295s;\n          -moz-animation-delay: 0.2295s;\n        }\n\n        #frotateG_02 {\n          left: 6px;\n          top: 6px;\n          animation-delay: 0.316s;\n          -o-animation-delay: 0.316s;\n          -ms-animation-delay: 0.316s;\n          -webkit-animation-delay: 0.316s;\n          -moz-animation-delay: 0.316s;\n        }\n\n        #frotateG_03 {\n          left: 21px;\n          top: 0;\n          animation-delay: 0.3925s;\n          -o-animation-delay: 0.3925s;\n          -ms-animation-delay: 0.3925s;\n          -webkit-animation-delay: 0.3925s;\n          -moz-animation-delay: 0.3925s;\n        }\n\n        #frotateG_04 {\n          right: 6px;\n          top: 6px;\n          animation-delay: 0.469s;\n          -o-animation-delay: 0.469s;\n          -ms-animation-delay: 0.469s;\n          -webkit-animation-delay: 0.469s;\n          -moz-animation-delay: 0.469s;\n        }\n\n        #frotateG_05 {\n          right: 0;\n          top: 21px;\n          animation-delay: 0.5455s;\n          -o-animation-delay: 0.5455s;\n          -ms-animation-delay: 0.5455s;\n          -webkit-animation-delay: 0.5455s;\n          -moz-animation-delay: 0.5455s;\n        }\n\n        #frotateG_06 {\n          right: 6px;\n          bottom: 6px;\n          animation-delay: 0.622s;\n          -o-animation-delay: 0.622s;\n          -ms-animation-delay: 0.622s;\n          -webkit-animation-delay: 0.622s;\n          -moz-animation-delay: 0.622s;\n        }\n\n        #frotateG_07 {\n          left: 21px;\n          bottom: 0;\n          animation-delay: 0.6985s;\n          -o-animation-delay: 0.6985s;\n          -ms-animation-delay: 0.6985s;\n          -webkit-animation-delay: 0.6985s;\n          -moz-animation-delay: 0.6985s;\n        }\n\n        #frotateG_08 {\n          left: 6px;\n          bottom: 6px;\n          animation-delay: 0.775s;\n          -o-animation-delay: 0.775s;\n          -ms-animation-delay: 0.775s;\n          -webkit-animation-delay: 0.775s;\n          -moz-animation-delay: 0.775s;\n        }\n\n        <a href=\'https://github.com/keyframes\' class=\'user-mention\'>@keyframes</a> f_fadeG {\n          0% {\n            /* background-color: rgb(0, 0, 0); */\n            background-color: #32465A;\n          }\n          100% {\n            background-color: rgb(255, 255, 255);\n          }\n        }\n\n        @-o-keyframes f_fadeG {\n          0% {\n            /* background-color: rgb(0, 0, 0); */\n            background-color: #32465A;\n          }\n          100% {\n            background-color: rgb(255, 255, 255);\n          }\n        }\n\n        @-ms-keyframes f_fadeG {\n          0% {\n            background-color: #32465A;\n            /* background-color: rgb(0, 0, 0); */\n          }\n          100% {\n            background-color: rgb(255, 255, 255);\n          }\n        }\n\n        @-webkit-keyframes f_fadeG {\n          0% {\n            background-color: #32465A;\n            /* background-color: rgb(0, 0, 0); */\n          }\n          100% {\n            background-color: rgb(255, 255, 255);\n          }\n        }\n\n        @-moz-keyframes f_fadeG {\n          0% {\n            background-color: #32465A;\n            /* background-color: rgb(0, 0, 0); */\n          }\n          100% {\n            background-color: rgb(255, 255, 255);\n          }\n        }</style></div>');
$templateCache.put('app/app-nav/app-nav.html','<nav class="navbar navbar-default" role="navigation" style="margin-bottom:0"><div class="container-fluid"><div class="navbar-header"><button class="navbar-toggle" ng-click="$ctrl.toggleNavbar()" type="button"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand" href="#/" ng-click="$ctrl.collapseNavbar()"><img alt="" src="../content/images/tyalls_logo_white_50.svg"><h1>Tyalls</h1></a></div><div class="navbar-collapse" id="navbar" ng-switch="$ctrl.isAuthenticated()" uib-collapse="$ctrl.isNavbarCollapsed"><!-- <ul class="nav navbar&#45;nav navbar&#45;right"> --><ul class="nav nav-pills pull-right"><li ui-sref-active="active"><a id="home-menu" ng-click="$ctrl.collapseNavbar()" ui-sref="app.home"><div class="nav-tab-label"><i data-feather="home"></i> <span>&nbsp;Home</span></div><!-- <span class="icon icon&#45;home">&#38;nbsp;Home</span> --></a></li><li is-admin ng-switch-when="true" ui-sref-active="active"><a id="app-admin-menu" ng-click="$ctrl.collapseNavbar()" ui-sref="app.app-admin"><div class="nav-tab-label"><i data-feather="sliders"></i> <span>&nbsp;AppAdmin</span></div></a></li><li has-authority="AUDITOR" ng-switch-when="true" ui-sref-active="active"><a id="audit-basket-menu" ng-click="$ctrl.collapseNavbar()" ui-sref="app.prop.audit-basket-viewer"><div class="nav-tab-label"><i data-feather="shopping-cart"></i> <span>&nbsp;Audit Basket</span></div></a></li><li has-authority="REPORTER" ng-switch-when="true" ui-sref-active="active"><a id="audit-menu" ng-click="$ctrl.collapseNavbar()" ui-sref="app.audit"><div class="nav-tab-label"><i data-feather="bar-chart"></i> <span>&nbsp;Audit</span></div></a></li><li has-authority="REPORTER" ng-switch-when="true" ui-sref-active="active"><a id="portfolio-menu" ng-click="$ctrl.collapseNavbar()" ui-sref="app.portfolio"><div class="nav-tab-label"><i data-feather="globe"></i> <span>&nbsp;Portfolio</span></div></a></li><li is-admin ng-switch-when="true" ui-sref-active="active"><a id="prop-admin-menu-admin" ng-click="$ctrl.collapseNavbar()" ui-sref="app.prop.prop-admin"><div class="nav-tab-label"><i data-feather="sliders"></i> <span>&nbsp;PropAdmin</span></div></a></li><li has-authority="PROP_ADMIN" ng-switch-when="true" ui-sref-active="active"><a id="prop-admin-menu" ng-click="$ctrl.collapseNavbar()" ui-sref="app.prop.prop-admin"><div class="nav-tab-label"><i data-feather="sliders"></i> <span>&nbsp;PropAdmin</span></div></a></li><li has-authority="REPORTER" ng-switch-when="true" ui-sref-active="active"><a id="reports-menu" ng-click="$ctrl.collapseNavbar()" ui-sref="app.prop.reporter-month"><div class="nav-tab-label"><i data-feather="layers"></i> <span>&nbsp;Reports</span></div></a></li><li has-authority="INITIATOR" ng-switch-when="true" ui-sref-active="active"><!-- <a id="launch&#45;menu" ui&#45;sref="app.prop.launcher" ng&#45;click="$ctrl.collapseNavbar()"> --> <a id="launch-menu" ng-click="$ctrl.collapseNavbar()" ui-sref="app.prop.launch-console"><div class="nav-tab-label"><i data-feather="navigation"></i> <span>&nbsp;Launch</span></div></a></li><li has-authority="INITIATOR" ng-switch-when="true" ui-sref-active="active"><a id="file-menu" ng-click="$ctrl.collapseNavbar()" ui-sref="app.file"><div class="nav-tab-label"><i data-feather="upload-cloud"></i> <span>&nbsp;File</span></div></a></li><li has-authority="USER" ng-switch-when="true" ui-sref-active="active"><a id="mention-menu" ng-click="$ctrl.collapseNavbar()" ui-sref="app.mentions"><div class="nav-tab-label"><i data-feather="at-sign"></i> <span>&nbsp;My Mentions</span></div></a></li><li has-authority="REVIEWER" ng-switch-when="true" ui-sref-active="active"><a id="reviewer-menu" ng-click="$ctrl.collapseNavbar()" ui-sref="app.prop.reviewer-month"><div class="nav-tab-label"><i data-feather="inbox"></i> <span>&nbsp;My Tasks</span></div></a></li><li class="dropdown pointer" ng-class="{active: $ctrl.$state.includes(\'account\')}" uib-dropdown><a class="dropdown-toggle" href="" id="account-menu" uib-dropdown-toggle><div class="nav-tab-label"><i data-feather="user"></i> <span>&nbspAccount</span> <b class="caret"></b></div></a><ul class="dropdown-menu" uib-dropdown-menu><li ng-switch-when="true" ui-sref-active="active"><a id="invite-menu" ng-click="$ctrl.collapseNavbar()" ui-sref="app.invites"><div class="nav-tab-label"><i data-feather="flag"></i> <span>&nbsp;My Invites</span></div></a></li><li ng-switch-when="true" ui-sref-active="active"><a href="" id="logout" ng-click="$ctrl.logout()"><div class="nav-tab-label"><i data-feather="log-out"></i> <span>&nbsp;Sign out</span></div><!-- <span class="glyphicon glyphicon&#45;log&#45;out"></span>&#38;nbsp;Sign out</span> --></a></li><li ng-switch-when="false" ui-sref-active="active"><a href="" id="login" ng-click="$ctrl.login()"><!-- <span class="glyphicon glyphicon&#45;log&#45;in"></span>&#38;nbsp;Sign in</span> --><div class="nav-tab-label"><i data-feather="log-in"></i> <span>&nbsp;Sign in</span></div></a></li></ul></li></ul></div><!--/.nav-collapse --></div><!--/.container-fluid --></nav>');
$templateCache.put('app/home/home.html','<div class="panel panel-default panel-fixed-width"><div class="panel-body"><h2>Welcome to Tyalls!</h2><div ng-switch="$ctrl.isAuthenticated();"><div class="alert alert-success" ng-switch-when="true">You are logged in as user "{{$ctrl.account.username}}".</div><div class="alert alert-warning" ng-switch-when="false">Please sign in <a class="alert-link" href="" ng-click="$ctrl.login()">Sign in</a></div></div></div></div>');
$templateCache.put('app/components/login/login-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="$ctrl.cancel()">&times;</button><h4 class="modal-title" ng-show="!$ctrl.isResetingPassword&&!$ctrl.hasBeenReset">Sign in</h4><h4 class="modal-title" ng-show="$ctrl.isResetingPassword">Reset Password</h4><h4 class="modal-title" ng-show="$ctrl.hasBeenReset">Password Reset</h4></div><div class="modal-body"><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="$ctrl.authenticationError"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div><div class="alert alert-info" ng-show="$ctrl.isResetingPassword&&!$ctrl.isLoading">Enter the email address you used to register.</div><div class="alert alert-success" ng-show="$ctrl.hasBeenReset"><p>Check your emails for details on how to reset your password.</p></div></div><div class="col-md-8 col-md-offset-2" ng-show="!$ctrl.isResetingPassword&&!$ctrl.hasBeenReset"><form class="form" role="form" ng-submit="$ctrl.login($event)"><div class="form-group"><label for="username">Login</label> <input type="text" class="form-control" id="username" placeholder="username" ng-model="$ctrl.username"></div><div class="form-group"><label for="password">Password</label> <input type="password" class="form-control" id="password" placeholder="password" ng-model="$ctrl.password"></div><button type="submit" class="btn btn-primary">Sign in</button></form><p></p><div class="alert alert-warning"><a id="password-reset-menu" class="alert-link" href="" ng-click="$ctrl.requestResetPassword()">Did you forget your password?</a></div></div><div class="col-md-8 col-md-offset-2" ng-show="$ctrl.isResetingPassword||$ctrl.hasBeenReset||$ctrl.isLoading"><form ng-show="$ctrl.isResetingPassword&&!$ctrl.hasBeenReset&&!$ctrl.isLoading" ng-submit="$ctrl.requestReset($event)"><div class="form-group"><label for="username">Email</label> <input class="form-control" id="resetUsername" ng-model="$ctrl.resetUsername" placeholder="username" type="text"></div><button class="btn btn-primary" type="submit">Reset</button></form><div ng-show="($ctrl.isLoading)"><div class="row"><div class="col-md-8 col-md-offset-2 center-text"><p>Resetting Password ...</p></div></div><div class="row"><div class="col-md-8 col-md-offset-2"><div class="progress"><div aria-valuemax="100" aria-valuemin="0" aria-valuenow="90" class="progress-bar progress-bar-striped active" role="progressbar" style="width: 45%"><span class="sr-only">90% Complete</span></div></div></div></div></div><div ng-show="$ctrl.hasBeenReset"><div class="row"><div class="col-md-8"><button class="btn btn-primary" ng-click="$ctrl.close()" type="button">Close</button></div></div></div></div></div></div>');
$templateCache.put('app/components/util/confirm-modal.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="$ctrl.clear()">&times;</button><h4 class="modal-title">{{$ctrl.titleText}}</h4></div><div class="modal-body">{{$ctrl.bodyText}}<div class="modal-footer"><button id="cancelButton" type="button" class="btn btn-default" data-dismiss="modal" ng-click="$ctrl.clear()">Cancel</button> <button id="confirmButton" type="button" class="btn btn-primary" ng-click="$ctrl.confirm()">Confirm</button></div></div>');
$templateCache.put('app/components/util/property-selector.html','<section class="nav-property"><h2 class="sr-only">Property Navigation</h2><form name="propertyForm"><div class="form-horizontal"><div class="form-group"><div class="input-group col-sm-4 col-md-4"><div class="input-group-addon"><i class="fa fa-building fa-lg"></i></div><select name="selectedPropertyId" class="form-control" ng-options="p.id as p.name for p in $ctrl.idToPropertyLookup | orderBy:\'name\'" ng-model="$ctrl.defaultPropertyId" ng-change="$ctrl.selectProperty($ctrl.defaultPropertyId)" ng-disabled="::$ctrl.disabled"><option value="" disabled="disabled">{{$ctrl.defaultOptionText}}</option></select></div></div></div></form></section>');
$templateCache.put('app/entities/app-admin/app-admin.html','<uib-tabset active="active"><uib-tab heading="Users" id="user-admin-console-tab" index="0" ui-sref="app.app-admin.user-admin-console"><ui-view name="user-admin-console"></ui-view></uib-tab><uib-tab heading="Workflow Definition" id="wfd-admin-console-tab" index="1" ui-sref="app.app-admin.wfd-admin-console"><ui-view name="wfd-admin-console"></ui-view></uib-tab><uib-tab heading="Schedule" id="schedule-admin-console-tab" index="2" ui-sref="app.app-admin.schedule-admin-console"><ui-view name="schedule-admin-console"></ui-view></uib-tab></uib-tabset>');
$templateCache.put('app/entities/audit/audit.html','<div class="panel panel-default panel-fixed-width"><div class="panel-body"><form class="audit-form" name="$ctrl.queryForm" ng-submit="$ctrl.doSearch();" novalidate role="form"><div class="input-field"><label for="selectedPropertyId">Property<span class="input-field--required">*</span></label><ui-select close-on-select="false" close-on-select="false" multiple="multiple" ng-model="$ctrl.selectedProperties" sortable="true" theme="bootstrap"><ui-select-match placeholder="Select property...">{{$item.name}} &lt;{{$item.propertyCode}}&gt;</ui-select-match><ui-select-choices repeat="property in $ctrl.properties | filter: {name: $select.search}"><span ng-bind-html="property.name | highlight: $select.search"></span> &lt;<span ng-bind-html="property.propertyCode | highlight: $select.search"></span>&gt;</ui-select-choices></ui-select></div><div class="aduit-checkbox" id="selectWorkflowDiv"><p>Check to Select Workflows Individually</p><input id="selectWorkflow" name="selectWorkflow" ng-model="$ctrl.hasSelectedWorkflow" required type="checkbox"></div><div class="input-field" ng-if="$ctrl.hasSelectedWorkflow"><label for="selectedWorkflowDefinitions">Workflow Definitions<span class="input-field--required">*</span></label><ui-select close-on-select="false" close-on-select="false" multiple="multiple" ng-disabled="$ctrl.selectedProperties.length<1" ng-model="$ctrl.selectedWorkflowDefinitions" sortable="true" theme="bootstrap"><ui-select-match placeholder="Select workflow definition...">{{$item.name}} &lt;{{$item.propertyCode}}&gt;</ui-select-match><ui-select-choices repeat="wd in $ctrl.workflowDefinitions | filter: {name: $select.search}"><span ng-bind-html="wd.name | highlight: $select.search"></span> &lt;<span ng-bind-html="wd.propertyCode | highlight: $select.search"></span>&gt;</ui-select-choices></ui-select></div><div class="input-field input-field--narrow" ng-class="{\'input-field--error\': $ctrl.queryForm.startDate.$invalid && !$ctrl.queryForm.startDate.$pristine}"><label class="clearfix" for="startDate">Start Date<span class="input-field--required">*</span> <span class="error-messages" ng-if="$ctrl.queryForm.startDate.$dirty" ng-messages="$ctrl.queryForm.startDate.$error"><span class="error-messages__item" ng-message="required">Input is required</span> <span class="error-messages__item" ng-message="date">Valid date is required</span></span></label> <input name="startDate" ng-change="$ctrl.checkStartDate()" ng-disabled="$ctrl.selectedWorkflowDefinitions.length<1 && $ctrl.hasSelectedWorkflow" ng-model="$ctrl.startDate" required type="date"></div><div class="input-field input-field--narrow" ng-class="{\'input-field--error\': $ctrl.queryForm.endDate.$invalid && !$ctrl.queryForm.endDate.$pristine}"><label for="endDate">End Date<span class="input-field--required">*</span> <span class="error-messages" ng-if="$ctrl.queryForm.endDate.$dirty" ng-messages="$ctrl.queryForm.endDate.$error"><span class="error-messages__item" ng-message="required">Valid date is required</span> <span class="error-messages__item" ng-message="date">Valid date is required</span> <span class="error-messages__item" ng-message="end-date-after-start-date">End date must be later than start date</span></span></label> <input name="endDate" ng-change="$ctrl.checkStartDate()" ng-disabled="!$ctrl.startDate" ng-model="$ctrl.endDate" required type="date"></div><div class="button-container"><button class="btn btn-primary" type="submit">Search</button> <button class="btn" ng-click="$ctrl.downloadPdf();" type="button">Download PDF</button> <button class="btn" ng-click="$ctrl.downloadCsv();" type="button">Download csv</button></div></form></div></div><div bs-loading-overlay class="panel panel-default bs-loading-container"><div class="panel-body"><p>{{ $ctrl.searchResults.length }} records returned.</p><table class="table table-striped" ng-if="!!$ctrl.searchResults.length" st-safe-src="$ctrl.searchResults" st-table="displayedCollection" style="display:block;overflow:auto;"><thead><tr><th st-sort="propertyCode">Property</th><th st-sort="workflowName">Workflow Name</th><th st-sort="dueDate">Due Date</th><th st-sort="dailyState">Daily State</th><th st-sort="status">Status</th><th st-sort="auditedReviewList[0].username">1st Reviewer</th><th st-sort="auditedReviewList[0].timestamp">Timestamp</th><th st-sort="auditedReviewList[1].username">2nd Reviewer</th><th st-sort="auditedReviewList[1].timestamp">Timestamp</th><th st-sort="auditedReviewList[2].username">3rd Reviewer</th><th st-sort="auditedReviewList[2].timestamp">Timestamp</th><th st-sort="auditedReviewList[3].username">4th Reviewer</th><th st-sort="auditedReviewList[3].timestamp">Timestamp</th></tr></thead><tbody><tr ng-click="$ctrl.changeState(result);" ng-repeat="result in displayedCollection" style="cursor: pointer"><td>{{result.propertyCode}}</td><td>{{result.workflowName}}</td><td>{{result.dueDate}}</td><td>{{result.dailyState}}</td><td>{{result.status}}</td><td>{{result.auditedReviewList[0].username}}</td><td>{{result.auditedReviewList[0].timestamp}}</td><td>{{result.auditedReviewList[1].username}}</td><td>{{result.auditedReviewList[1].timestamp}}</td><td>{{result.auditedReviewList[2].username}}</td><td>{{result.auditedReviewList[2].timestamp}}</td><td>{{result.auditedReviewList[3].username}}</td><td>{{result.auditedReviewList[3].timestamp}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/audit-basket-viewer/audit-basket-viewer.html','<ui-view name="audit-basket-viewer-content" class="audit-basket-viewer"></ui-view>');
$templateCache.put('app/entities/audit-basket-viewer/list-audit-basket.html','<div class="panel panel-default" ng-if="$ctrl.propertyId" 0><div class="panel-body"><audit-basket-container class="audit-basket-console" audit-baskets="$ctrl.auditBaskets" property="$ctrl.propertyId"></audit-basket-container></div></div>');
$templateCache.put('app/entities/audit-basket-viewer/read-audit-basket.html','<div class="read-audit-basket"><div class="panel panel-default"><div class="panel-body"><div class="row" ng-if="($ctrl.auditBasket.wfis.length == null)"><div class="col-md-4 col-xs-offset-4 center-text"><p>Loading Audit Baskets ...</p></div></div><div class="row" ng-if="($ctrl.auditBasket.wfis.length == null)"><div class="col-md-4 col-xs-offset-4"><div class="progress"><div aria-valuemax="100" aria-valuemin="0" aria-valuenow="90" class="progress-bar progress-bar-striped active" role="progressbar" style="width: 45%"><span class="sr-only">90% Complete</span></div></div></div></div><div class="row" ng-if="($ctrl.auditBasket.wfis.length > 0)"><div class="col-md-5 col-xs-offset-4"><div class="table-scroll-div-large"><table><thead><th></th><th>Workflow Definition Id</th><th>Due Date</th><th></th></thead><tbody><tr ng-repeat="wfi in $ctrl.auditBasket.wfis track by $index"><td>{{ $index }}</td><td>{{ wfi.processDefinitionId }}</td><td>{{ wfi.dueDate }}</td><td><button class="btn btn-primary" id="go-view-task-{{$index}}" ng-click="$ctrl.goToTask($index);" type="button">View</button></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/entities/file/file.html','<div class="panel panel-default panel-fixed-width"><div class="panel-body"><div bs-loading-overlay class="row bs-loading-container"><div class="col-sm-8 col-sm-offset-2"><form class="form-horizontal" name="uploadForm" novalidate><div class="form-group"><label class="control-label col-sm-2" for="property">Property</label><div class="col-sm-10"><select class="form-control" name="property" ng-model="$ctrl.selectedProperty" ng-options="prop.name for prop in $ctrl.properties | orderBy:\'name\'"></select></div></div><div class="form-group"><label class="control-label col-sm-2" for="dueDate">Due Date</label><div class="col-sm-10"><input class="form-control" name="dueDate" name="dueDate" ng-disabled="!$ctrl.selectedProperty" ng-model="$ctrl.selectedDueDate" required type="date"></div></div><div class="form-group"><label class="control-label col-sm-2" for="workflow">Workflow</label><div class="col-sm-10"><select class="form-control" name="workflow" ng-disabled="!$ctrl.selectedProperty || !$ctrl.selectedDueDate" ng-model="$ctrl.selectedWorkflow" ng-options="pd.name for pd in $ctrl.processDefinitions | orderBy:\'name\'"><option disabled="disabled" value="">-- select a Workflow Definition --</option></select></div></div><div class="form-group"><label class="control-label col-sm-2" for="file">File</label><div class="col-sm-10"><input accept="application/pdf" class="form-control" name="file" ng-disabled="!$ctrl.selectedProperty || !$ctrl.selectedWorkflow" ng-model="$ctrl.selectedFile" ngf-max-size="7MB" ngf-pattern="\'.pdf\'" ngf-select required type="file"><div class="help-block alert alert-danger" ng-if="uploadForm.file.$touched && uploadForm.file.$invalid" ng-messages="uploadForm.file.$error"><p ng-message="maxSize">The file is too large (max 7MB)</p><p ng-message="required">A PDF file is required</p></div></div></div><a class="btn btn-primary" id="upload" ng-click="$ctrl.doUpload()" ng-disabled="uploadForm.$invalid || $ctrl.uploading">Upload</a> <a class="btn btn-default" id="reset" ng-click="$ctrl.reset()" ng-disabled="$ctrl.uploading">Reset</a></form></div></div></div></div>');
$templateCache.put('app/entities/invites/invites.html','<div class="panel panel-default" ng-if="$ctrl.invites"><div class="panel-body"><span ng-show="!$ctrl.invites.length">You have no pending invites.</span><ul><li ng-repeat="invite in $ctrl.invites track by $index">{{invite}} <button ng-click="$ctrl.accept(invite)">Accept</button></li></ul></div></div>');
$templateCache.put('app/entities/launch-console/launch-console.html','<uib-tabset active="active" ng-if="$ctrl.propertyId"><uib-tab id="daily-launcher-tab" index="0" heading="Daily Launcher" ui-sref="app.prop.launch-console.daily-launcher"><ui-view name="daily-launcher"></ui-view></uib-tab><uib-tab id="non-daily-launcher-tab" index="1" heading="Non Daily Launcher" ui-sref="app.prop.launch-console.non-daily-launcher"><ui-view name="non-daily-launcher"></ui-view></uib-tab></uib-tabset>');
$templateCache.put('app/entities/launcher/daily-launcher.html','<div class="panel panel-default"><div class="panel-body"><div ng-show="$ctrl.availableWfds.length == 0"><form class="form-horizontal" name="dateSearchForm" ng-submit="$ctrl.dateSearch();" novalidate><div class="row"><div class="col-xs-6 col-xs-offset-3"><div class="form-group input-space"><label class="control-label col-sm-2" for="dueDate">Due Date</label><div class="col-sm-4"><input class="form-control" id="dueDate" name="dueDate" ng-model="$ctrl.selectedDueDate" required type="date"></div></div></div></div><div class="row input-space"><div class="col-xs-6 col-xs-offset-3"><button class="btn btn-primary" ng-disabled="!$ctrl.selectedDueDate" type="submit">Search</button></div></div></form></div><div class="launcher table-standard" ng-show="$ctrl.availableWfds.length > 0"><form name="$ctrl.launcherForm" ng-submit="$ctrl.doUpload();" novalidate><div class="row"><div class="col-xs-10 col-xs-offset-1"><div class="table-scroll-launcher"><table class="table launch-list"><thead><tr><th>Index</th><th>Name</th><th>History</th><th>File</th><th>Confirm?</th><th>Progress</th></tr></thead><tbody><tr class="launch-list__launch-item" ng-repeat="request in $ctrl.launchRequests track by $index"><td>{{ $index + 1}}</td><td>{{ request.processDefinitionName }}</td><td>{{ request.isLaunched }}</td><td><input accept="application/pdf" name="file_{{$index}}" ng-model="request.file" ngf-max-size="7MB" ngf-pattern="\'.pdf\'" ngf-select required type="file"><div class="help-block alert alert-danger" ng-if="$ctrl.launcherForm[\'file_\' + $index].$touched && $ctrl.launcherForm[\'file_\' + $index].$invalid" ng-messages="$ctrl.launcherForm[\'file_\' + $index].$error"><p ng-message="maxSize">The file is too large (max 7MB)</p><p ng-message="required">A PDF file is required</p></div></td><td><input class="checkbox" ng-disabled="!request.file" ng-model="request.confirm" type="checkbox"></td><td>{{ request.status }}</td></tr></tbody></table></div></div><div class="row input-space"><div class="col-xs-1 col-xs-offset-1"><button class="btn btn-default" id="backButton" ng-click="$ctrl.back()" type="button"><i class="fas fa-back"></i>&nbsp;Back</button></div><div class="col-xs-3 col-xs-offset-7"><button class="btn btn-primary" ng-disabled="!$ctrl.launcherForm.$dirty || !$ctrl.hasConfirmedLaunchRequest()" type="submit">Launch Selected</button></div></div></div></form></div></div></div>');
$templateCache.put('app/entities/launcher/non-daily-launcher.html','<div class="panel panel-default"><div class="panel-body"><span ng-show="!$ctrl.availableWfds.length">You have no Non-Daily Workflows available.</span><div class="launcher" ng-hide="!$ctrl.availableWfds.length"><form name="$ctrl.launcherForm" ng-submit="$ctrl.doUpload();" novalidate><div class="row"><div class="col-xs-10 col-xs-offset-1"><div class="table-scroll-launcher"><table class="table launch-list" ng-show="$ctrl.availableWfds.length"><thead><tr><th>Due Date</th><th>Name</th><th>File</th><th>Confirm?</th><th>Progress</th></tr></thead><tbody><tr class="launch-list__launch-item" ng-repeat="request in $ctrl.launchRequests track by $index"><td><input name="dueDate_{{$index}}" ng-model="request.selectedDueDate" required type="date"></td><td>{{ request.processDefinitionName }}</td><td><input accept="application/pdf" name="file_{{$index}}" ng-model="request.file" ngf-max-size="7MB" ngf-pattern="\'.pdf\'" ngf-select required type="file"><div class="help-block alert alert-danger" ng-if="$ctrl.launcherForm[\'file_\' + $index].$touched && $ctrl.launcherForm[\'file_\' + $index].$invalid" ng-messages="$ctrl.launcherForm[\'file_\' + $index].$error"><p ng-message="maxSize">The file is too large (max 7MB)</p><p ng-message="required">A PDF file is required</p></div></td><td><input class="checkbox" ng-disabled="!request.file || !request.selectedDueDate" ng-model="request.confirm" type="checkbox"></td><td>{{ request.status }}</td></tr></tbody></table></div></div></div><div class="row"><div class="col-xs-10 col-xs-offset-1"><button class="btn btn-primary" ng-disabled="!$ctrl.launcherForm.$dirty || !$ctrl.hasConfirmedLaunchRequest()" type="submit">Launch Selected</button></div></div></form></div></div></div>');
$templateCache.put('app/entities/mentions/mentions.html','<div class="panel panel-default" ng-if="$ctrl.mentionsPage.content"><div class="panel-body"><h1 class="sr-only">My Mentions</h1><!-- <div ng&#45;hide="!$ctrl.mentionsPage.content.length"> --><div><label for="showUnreadOnly">showUnreadOnly</label> <input id="showUnreadOnly" name="showUnreadOnly" ng-click="$ctrl.getPage(0);" ng-model="$ctrl.showUnreadOnly" type="checkbox" value=""></div><span ng-show="!$ctrl.mentionsPage.content.length">You have no pending mentions.</span><table class="table table-hover table-bordered table-striped" ng-show="$ctrl.mentionsPage.content.length" style="width:70%; margin: 0 auto"><thead><th>Mention Date</th><th>Comment</th><th>Workflow Definition Name</th><th>Due Date</th><th>Property Name</th><th>Unread</th></thead><tbody><tr ng-repeat="mention in $ctrl.mentionsPage.content | filter: $ctrl.filterUnread | orderBy:\'-commentDate\' track by $index"><td>{{ mention.commentDate | date:\'dd-MM-yyyy\' }}</td><td><a ng-click="$ctrl.changeState(mention.propertyId, mention.wfiId, mention.id)" style="cursor: pointer">{{mention.commentText}}</a></td><td>{{ mention.workflowDefinitionName }}</td><td>{{ mention.dueDate | date:\'dd-MM-yyyy\' }}</td><td>{{ $ctrl.idToPropertyLookup[mention.propertyId].name }}</td><td>{{ mention.readDate ? \'no\' : \'yes\' }}</td></tr></tbody></table><!-- pager --><div class="mentions-pagination-wrapper"><ul class="pagination" ng-if="$ctrl.mentionsPage.totalPages"><li ng-class="{disabled:$ctrl.mentionsPage.number === 0}"><a ng-click="$ctrl.getPage(0)">First</a></li><li ng-class="{disabled:$ctrl.mentionsPage.number === 0}"><a ng-click="$ctrl.getPage($ctrl.mentionsPage.number - 1)">Previous</a></li><li ng-class="{active:($ctrl.mentionsPage.number + 1 )=== page}" ng-repeat="page in $ctrl.mentionsPage.totalPages"><a ng-click="$ctrl.getPage(page)">{{page}}</a></li><li ng-class="{disabled:($ctrl.mentionsPage.number + 1) === $ctrl.mentionsPage.totalPages}"><a ng-click="$ctrl.getPage($ctrl.mentionsPage.number + 1)">Next</a></li><li ng-class="{disabled:($ctrl.mentionsPage.number + 1) === $ctrl.mentionsPage.totalPages}"><a ng-click="$ctrl.getPage($ctrl.mentionsPage.totalPages - 1)">Last</a></li></ul></div></div></div>');
$templateCache.put('app/entities/portfolio/portfolio-snapshot.html','{{scope.snapshot.$index}}<table class="table table-bordered"><thead><th><!-- blank --></th><th>Workflows</th><th>Total Workflows Available</th><th>% Complete</th></thead><tbody><tr><td><i class="fa fa-2x fa-check text-success"></i></td><td>{{wiCompletedCount}}</td><td>{{wiCount}}</td><td>{{wiCompletedCount / wiCount | percentage:2}}</td></tr><tr><td><i class="fa fa-2x fa-cogs text-warning"></i></td><td>{{wiNonCompletedCount}}</td><td>{{wiCount}}</td><td>{{wiNonCompletedCount / wiCount | percentage:2}}</td></tr><tr><td><i class="fa fa-2x fa-exclamation-triangle text-danger"></i></td><td>{{wiOverdueCount}}</td><td>{{wiCount}}</td><td>{{wiOverdueCount / wiCount | percentage:2}}</td></tr></tbody></table>');
$templateCache.put('app/entities/portfolio/portfolio.html','<div class="panel panel-default"><div class="panel-body"><div class="col-sm-8"><form class="form-horizontal" name="dateForm" ng-submit="$ctrl.onSubmit()" novalidate><div class="form-group"><div class="form-group"><label for="startDate" class="control-label col-sm-4">Start Date</label><div class="col-sm-8"><input type="date" name="startDate" class="form-control" ng-model="$ctrl.startDate" required></div></div></div><div class="form-group"><div class="form-group"><label for="endDate" class="control-label col-sm-4">End Date</label><div class="col-sm-8"><input type="date" name="endDate" class="form-control" ng-model="$ctrl.endDate" required></div></div></div><button type="submit" class="btn btn-primary">Submit</button></form></div></div></div><div class="panel panel-default" ng-if="$ctrl.portfolio"><div class="panel-body"><div ng-repeat="snapshot in $ctrl.portfolio track by $index">{{$ctrl.property[$index].name}}<portfolio-snapshot snapshot="snapshot"></portfolio-snapshot></div></div></div>');
$templateCache.put('app/entities/prop-admin/prop-admin.html','<uib-tabset active="active" ng-if="$ctrl.propertyId"><uib-tab heading="Users" id="user-console-tab" index="0" ui-sref="app.prop.prop-admin.user-console.list-user"><ui-view name="user-console"></ui-view></uib-tab><uib-tab heading="Auditors" id="auditor-console-tab" index="1" ui-sref="app.prop.prop-admin.auditor-console.list-auditor"><ui-view name="auditor-console"></ui-view></uib-tab><uib-tab heading="Audit Basket" id="audit-basket-tab" index="2" ui-sref="app.prop.prop-admin.audit-basket-console.list-audit-basket"><ui-view name="audit-basket-console"></ui-view></uib-tab></uib-tabset>');
$templateCache.put('app/entities/shared/prop.html','<div><property-selector default-property-id="$ctrl.propertyId" disabled="$ctrl.disabled" id-to-property-lookup="$ctrl.properties" on-select-property="$ctrl.selectProperty($event)"></property-selector></div><p ng-if="!$ctrl.propertyId">Please select a property...</p><ui-view name="prop" on-resolve-disabled="$ctrl.setDisabled($event)" on-resolve-properties="$ctrl.setProperties($event)"></ui-view>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Error Page!</h1><div class="alert alert-danger">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Reset password</h1><div class="alert alert-danger" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p>Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p>Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form name="form" ng-show="!vm.success" ng-submit="vm.finishReset()" novalidate role="form" show-validation><div class="form-group"><label class="control-label" for="password">New password</label> <input class="form-control" id="password" name="password" ng-maxlength="50" ng-minlength="4" ng-model="vm.resetAccount.password" placeholder="new password" required type="password"><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label> <input class="form-control" id="confirmPassword" name="confirmPassword" ng-maxlength="50" ng-minlength="4" ng-model="vm.confirmPassword" placeholder="confirm new password" required type="password"><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button class="btn btn-primary" ng-disabled="form.$invalid" type="submit">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Reset your password</h1><div class="alert alert-danger" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p>Enter the email address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p>Check your emails for details on how to reset your password.</p></div><form name="form" ng-show="!vm.success" ng-submit="vm.requestReset()" novalidate role="form" show-validation><div class="form-group"><label class="control-label" for="email">Email</label> <input class="form-control" id="email" name="email" ng-maxlength="100" ng-minlength="5" ng-model="vm.resetAccount.email" placeholder="email" required type="email"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" data-translate="global.messages.validate.email.required" ng-show="form.email.$error.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button class="btn btn-primary" ng-disabled="form.$invalid" type="submit">Reset</button></form></div></div></div>');
$templateCache.put('app/entities/app-admin/create-schedule-dialog/app-admin-create-schedule-dialog.html','<form name="createScheduleForm" class="create-schedule-form" role="form" ng-submit="$ctrl.save()" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="$ctrl.clear()">&times;</button><h4 class="modal-title">Create Schedule</h4></div><div class="modal-body"><div class="alert alert-danger" ng-if="$ctrl.serverMessage">{{$ctrl.serverMessage}}</div><div class="input-field"><label for="propertyId">Property<span class="input-field--required">*</span> <span class="error-messages" ng-messages="createScheduleForm.propertyId.$error" ng-if="createScheduleForm.propertyId.$touched"><span class="error-messages__item" ng-message="required">Property is required</span></span></label> <select name="propertyId" class="form-control" ng-options="p.id as p.name for p in $ctrl.properties | orderBy:\'name\'" ng-model="$ctrl.selectedSchedule.propertyId" ng-select required><option value="" disabled="disabled">-- select a Property --</option></select></div><div class="input-field"><label for="wfdKey">Workflow Definition Key<span class="input-field--required">*</span> <span class="error-messages" ng-messages="createScheduleForm.wfdKey.$error" ng-if="createScheduleForm.wfdKey.$touched"><span class="error-messages__item" ng-message="required">Workflow Definition Key is required</span></span></label> <select name="wfdKey" class="form-control" ng-options="item for item in $ctrl.workflowDefinitions" ng-model="$ctrl.selectedSchedule.wfdKey" ng-select required><option value="" disabled="disabled">-- select a Workflow Definition Key --</option></select></div><div class="input-field"><label for="startDate">Start Date <span ng-show="$ctrl.timezoneId">in timezone {{ $ctrl.timezoneId }}</span><span class="input-field--required">*</span> <span class="error-messages" ng-messages="createScheduleForm.startDate.$error" ng-if="createScheduleForm.startDate.$touched"><span class="error-messages__item" ng-message="required">Start Date is required</span></span></label> <input name="startDate" type="date" class="form-control" id="startDate" placeholder="Start Date" ng-model="$ctrl.selectedSchedule.startDate" required></div><div class="input-field"><label for="startHour">Start Hour <span ng-show="$ctrl.timezoneId">in timezone {{ $ctrl.timezoneId }}</span><span class="input-field--required">*</span> <span class="error-messages" ng-messages="createScheduleForm.startHour.$error" ng-if="createScheduleForm.startHour.$touched"><span class="error-messages__item" ng-message="required">Start Hour is required</span></span></label> <input name="startHour" type="number" class="form-control" id="startHour" min="0" max="23" placeholder="Enter Start Hour" ng-model="$ctrl.selectedSchedule.startHour" required></div><div class="input-field"><label for="startMinute">Start Minute <span ng-show="$ctrl.timezoneId">in timezone {{ $ctrl.timezoneId }}</span><span class="input-field--required">*</span> <span class="error-messages" ng-messages="createScheduleForm.startMinute.$error" ng-if="createScheduleForm.startMinute.$touched"><span class="error-messages__item" ng-message="required">Start Minute is required</span></span></label> <input name="startMinute" type="number" class="form-control" id="startMinute" min="0" max="59" placeholder="Enter Start Minute" ng-model="$ctrl.selectedSchedule.startMinute" required></div><div class="input-field"><label for="periodCount">Period Count<span class="input-field--required">*</span> <span class="error-messages" ng-messages="createScheduleForm.periodCount.$error" ng-if="createScheduleForm.periodCount.$touched"><span class="error-messages__item" ng-message="required">Period Count is required</span></span></label> <input name="periodCount" type="number" class="form-control" id="periodCount" min="0" max="99" placeholder="Enter Period Count" ng-model="$ctrl.selectedSchedule.periodCount" required></div><div class="input-field"><label for="periodUnit">Period Unit<span class="input-field--required">*</span> <span class="error-messages" ng-messages="createScheduleForm.periodUnit.$error" ng-if="createScheduleForm.periodUnit.$touched"><span class="error-messages__item" ng-message="required">Period Unit is required</span></span></label> <select name="periodUnit" class="form-control" ng-model="$ctrl.selectedSchedule.periodUnit" ng-select required><option value="" disabled="disabled">-- select a Period Unit --</option><option value="WEEK">Week</option><option value="MONTH">Month</option><option value="YEAR">Year</option></select></div><div class="input-field"><label for="repeatCount">Period Count<span class="input-field--required">*</span> <span class="error-messages" ng-messages="createScheduleForm.repeatCount.$error" ng-if="createScheduleForm.repeatCount.$touched"><span class="error-messages__item" ng-message="required">Repeat Count is required</span></span></label> <input name="repeatCount" type="number" class="form-control" id="repeatCount" min="0" max="99" placeholder="Enter Repeat Count" ng-model="$ctrl.selectedSchedule.repeatCount" required></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="$ctrl.clear()"><i class="fas fa-ban"></i>&nbsp;Cancel</button> <button type="submit" ng-disabled="createScheduleForm.$invalid || $ctrl.isSaving" class="btn btn-primary"><i class="fas fa-download"></i> &nbsp;Save</button></div></form>');
$templateCache.put('app/entities/app-admin/create-user-dialog/app-admin-create-user-dialog.html','<form class="create-user-form" name="createUserForm" ng-submit="$ctrl.save()" novalidate role="form"><div class="modal-header"><button aria-hidden="true" class="close" data-dismiss="modal" ng-click="$ctrl.clear()" type="button">&times;</button><h4 class="modal-title">Create User</h4></div><div class="modal-body"><div class="alert alert-danger" ng-if="$ctrl.serverMessage">{{$ctrl.serverMessage}}</div><div class="input-field"><label for="propertyId">Property<span class="input-field--required">*</span> <span class="error-messages" ng-if="createUserForm.propertyId.$touched" ng-messages="createUserForm.propertyId.$error"><span class="error-messages__item" ng-message="required">Property is required</span></span></label> <select class="form-control" name="propertyId" ng-model="$ctrl.selectedUser.propertyId" ng-options="p.id as p.name for p in $ctrl.properties | orderBy:\'name\'" required><option disabled="disabled" value="">-- select a Property --</option></select></div><div class="input-field"><label for="username">Username<span class="input-field--required">*</span> <span class="error-messages" ng-if="createUserForm.username.$touched" ng-messages="createUserForm.username.$error"><span class="error-messages__item" ng-message="required">Username is required</span></span></label> <input class="form-control" id="username" name="username" ng-model="$ctrl.selectedUser.username" placeholder="Enter Username" required type="text"></div><div class="input-field"><label for="password">Password<span class="input-field--required">*</span> <span class="error-messages" ng-if="createUserForm.password.$touched" ng-messages="createUserForm.password.$error"><span class="error-messages__item" ng-message="required">Password is required</span></span></label> <input class="form-control" id="password" name="password" ng-model="$ctrl.selectedUser.password" placeholder="Password" required type="password"></div><div class="input-field"><label for="firstName">First Name<span class="input-field--required">*</span> <span class="error-messages" ng-if="createUserForm.firstName.$touched" ng-messages="createUserForm.firstName.$error"><span class="error-messages__item" ng-message="required">First Name is required</span></span></label> <input class="form-control" id="firstName" name="firstName" ng-model="$ctrl.selectedUser.firstName" placeholder="Enter First Name" required type="text"></div><div class="input-field"><label for="lastName">Last Name<span class="input-field--required">*</span> <span class="error-messages" ng-if="createUserForm.lastName.$touched" ng-messages="createUserForm.lastName.$error"><span class="error-messages__item" ng-message="required">Last Name is required</span></span></label> <input class="form-control" id="lastName" name="lastName" ng-model="$ctrl.selectedUser.lastName" placeholder="Enter Last Name" required type="text"></div><div class="input-field"><label for="email">Email<span class="input-field--required">*</span> <span class="error-messages" ng-if="createUserForm.email.$touched" ng-messages="createUserForm.email.$error"><span class="error-messages__item" ng-message="required">An email is required</span></span></label> <input class="form-control" id="email" name="email" ng-model="$ctrl.selectedUser.email" placeholder="Enter email" required type="email"></div></div><div class="modal-footer"><button class="btn btn-default" data-dismiss="modal" ng-click="$ctrl.clear()" type="button"><i class="fas fa-ban"></i>&nbsp;Cancel</button> <button class="btn btn-primary" ng-disabled="createUserForm.$invalid || $ctrl.isSaving" type="submit"><i class="fas fa-download"></i> &nbsp;Save</button></div></form>');
$templateCache.put('app/entities/app-admin/create-user-group-dialog/app-admin-create-user-group-dialog.html','<form name="createUserGroupForm" role="form" novalidate ng-submit="$ctrl.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="$ctrl.clear()">&times;</button><h4 class="modal-title">Create User Group</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" for="name">Name</label> <input name="username" type="text" class="form-control" id="name" placeholder="Enter Name" ng-model="$ctrl.newUserGroup.name" required><div class="help-block alert alert-danger" ng-messages="createUserGroupForm.name.$error" ng-if="createUserGroupForm.name.$touched && createUserGroupForm.name.$invalid"><p ng-message="required">A name is required</p></div></div><div class="form-group"><label class="control-label" for="property">Property</label> <input name="property" type="text" class="form-control" id="property" placeholder="Enter Property" ng-model="$ctrl.newUserGroup.property" required><div class="help-block alert alert-danger" ng-messages="createUserGroupForm.property.$error" ng-if="createUserGroupForm.property.$touched && createUserGroupForm.property.$invalid"><p ng-message="required">A property is required</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="$ctrl.clear()"><i class="fas fa-ban"></i>&nbsp;Cancel</button> <button type="submit" ng-disabled="editForm.$invalid || $ctrl.isSaving" class="btn btn-primary"><i class="fas fa-download"></i> &nbsp;Save</button></div></form>');
$templateCache.put('app/entities/app-admin/create-user-invite-dialog/app-admin-create-user-invite-dialog.html','<form name="createUserInviteForm" role="form" novalidate ng-submit="$ctrl.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="$ctrl.clear()">&times;</button><h4 class="modal-title">Create User Invite</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" for="email">Email</label> <input name="email" type="email" class="form-control" id="email" placeholder="Enter email" ng-model="$ctrl.selectedUser.email" required><div class="help-block alert alert-danger" ng-messages="createUserInviteForm.email.$error" ng-if="!createUserInviteForm.email.$pristine && createUserInviteForm.email.$invalid"><div ng-message="required">Please specify an email address</div><div ng-message="email">Please specify a valid email</div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="$ctrl.clear()"><i class="fas fa-ban"></i>&nbsp;Cancel</button> <button type="submit" ng-disabled="!createUserInviteForm.$valid || $ctrl.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-envelope"></span>&nbsp;Invite</button></div></form>');
$templateCache.put('app/entities/app-admin/create-wfd-dialog/app-admin-create-wfd-dialog.html','<form class="create-wfd-form" name="createWfdForm" ng-submit="$ctrl.save()" novalidate role="form"><div class="modal-header"><button aria-hidden="true" class="close" data-dismiss="modal" ng-click="$ctrl.clear()" type="button">&times;</button><h4 class="modal-title">Create Workflow Definition</h4></div><div class="modal-body"><div class="alert alert-danger" ng-if="$ctrl.serverMessage">{{$ctrl.serverMessage}}</div><div class="input-field"><label for="propertyId">Property<span class="input-field--required">*</span> <span class="error-messages" ng-if="createWfdForm.propertyId.$touched" ng-messages="createWfdForm.propertyId.$error"><span class="error-messages__item" ng-message="required">Property is required</span></span></label> <select class="form-control" name="propertyId" ng-model="$ctrl.selectedWfd.propertyId" ng-options="p.id as p.name for p in $ctrl.properties | orderBy:\'name\'" ng-select required><option disabled="disabled" value="">-- select a Property --</option></select></div><div class="input-field"><label for="dailyState">Daily State<span class="input-field--required">*</span> <span class="error-messages" ng-if="createWfdForm.dailyState.$touched" ng-messages="createWfdForm.dailyState.$error"><span class="error-messages__item" ng-message="required">Daily State is required</span></span></label> <select class="form-control" name="dailyState" ng-model="$ctrl.selectedWfd.dailyState" ng-options="d.id as d.desc for d in $ctrl.dailyStates" ng-select required><option disabled="disabled" value="">-- select a Daily State --</option></select></div><div class="input-field"><label for="wfdFile">Workflow Definition File<span class="input-field--required">*</span> <span class="error-messages" ng-if="createWfdForm.wfdFile.$touched" ng-messages="createWfdForm.wfdFile.$error"><span class="error-messages__item" ng-message="required">Workflow Definition File is required</span></span></label> <input name="wfdFile" ng-model="$ctrl.selectedWfd.wfdFile" ngf-pattern="\'.bpmn\'" ngf-select required type="file"></div></div><div class="modal-footer"><button class="btn btn-default" data-dismiss="modal" ng-click="$ctrl.clear()" type="button"><i class="fas fa-ban"></i>&nbsp;Cancel</button> <button class="btn btn-primary" ng-disabled="createWfdForm.$invalid || $ctrl.isSaving" type="submit"><i class="fas fa-download"></i> &nbsp;Save</button></div></form>');
$templateCache.put('app/entities/app-admin/detail-user-dialog/app-admin-detail-user-dialog.html','<form class="create-user-form" name="detailUserForm" ng-submit="$ctrl.save()" novalidate role="form"><div class="modal-header"><button aria-hidden="true" class="close" data-dismiss="modal" ng-click="$ctrl.clear()" type="button">&times;</button><h4 class="modal-title">User Membership</h4></div><div class="modal-body"><div class="alert alert-danger" ng-if="$ctrl.serverMessage">{{$ctrl.serverMessage}}</div><div><ul><li ng-repeat="pp in $ctrl.user.propertyProfiles | filter:{profileName:\'USER\'}">{{ $ctrl.propertyLookup[pp.propertyId].propertyCode }} - {{ $ctrl.propertyLookup[pp.propertyId].name }} <button class="btn btn-small" ng-click="$ctrl.removeUserFromProperty(pp.propertyId);" type="button">x</button></li><!-- <li ng&#45;repeat="pp in $ctrl.user.propertyProfiles | filter:{profileName:\'USER\'}">{{ pp.propertyId }}</li>  --></ul></div><div class="input-field"><label for="propertyId">Property<span class="input-field--required">*</span> <span class="error-messages" ng-if="detailUserForm.propertyId.$touched" ng-messages="detailUserForm.propertyId.$error"><span class="error-messages__item" ng-message="required">Property is required</span></span></label> <select class="form-control" name="propertyId" ng-model="$ctrl.selectedProperty.propertyId" ng-options="p.id as p.name for p in $ctrl.properties | orderBy:\'name\'" required><option disabled="disabled" value="">-- select a Property --</option></select></div></div><div class="modal-footer"><button class="btn btn-default" data-dismiss="modal" ng-click="$ctrl.clear()" type="button"><i class="fas fa-ban"></i>&nbsp;Cancel</button> <button class="btn btn-primary" ng-disabled="detailUserForm.$invalid || $ctrl.isSaving" type="submit"><i class="fas fa-download"></i> &nbsp;Save</button></div></form>');
$templateCache.put('app/entities/app-admin/invite-console/invite-console.html','<div style="padding: 5px"><button class="btn btn-primary" ng-click="$ctrl.goToCreateUserInvite();" type="button">Create User Invite</button><ul><li ng-repeat="invite in $ctrl.invites | orderBy:\'id\' track by invite.id">{{invite}} {{$ctrl.idToUserLookup[invite.inviteeId].username}}</li></ul></div>');
$templateCache.put('app/entities/app-admin/schedule-admin-console/schedule-admin-console.html','<div style="padding: 5px"><button ng-click="$ctrl.goToCreateSchedule();" class="btn btn-primary" type="button">Create Schedule</button></div>');
$templateCache.put('app/entities/app-admin/user-admin-console/user-admin-console.html','<div style="padding: 5px"><button ng-click="$ctrl.goToCreateUser();" class="btn btn-primary" type="button">Create User</button></div><div class="panel panel-default"><div class="panel-body"><table style="font-size:0.8em" class="table table-striped table-responsive"><thead><th>Id</th><th>Admin</th><th>Username</th><th>EN</th><th>ULK</th></thead><tbody><tr ng-repeat="user in $ctrl.users | orderBy:\'id\'"><td><a href="" ng-click="$ctrl.selectUser(user)">{{user.id}}</a></td><td>{{user.admin?\'Y\':\'N\'}}</td><td ng-click="$ctrl.goToUserDetail(user)">{{user.username}}</td><!-- <td><button class="btn btn&#45;primary btn&#45;xs" ng&#45;click="$ctrl.toggleEnable(user)">{{user.enabled?\'Y\':\'N\'}}</button></td> --><td><button class="btn btn-primary btn-xs" ng-click="$ctrl.requestToggleEnable(user)">{{user.enabled?\'Y\':\'N\'}}</button></td><td>{{user.nonLocked?\'Y\':\'N\'}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/app-admin/user-group-console/user-group-console.html','<div style="padding: 5px"><button ui-sref="app.prop.app-admin.create-user-group-dialog" class="btn btn-primary" type="button">Create UserGroup</button></div><div class="panel panel-default"><div class="panel-body"><table style="font-size:0.8em" class="table table-striped table-responsive"><thead><th>Id</th><th>GroupName</th></thead><tbody><tr ng-repeat="userGroup in $ctrl.userGroups track by userGroup.id"><td>{{userGroup.id}}</td><td>{{userGroup.name}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/app-admin/wfd-admin-console/wfd-admin-console.html','<div style="padding: 5px"><button class="btn btn-primary" ng-click="$ctrl.goToCreateWfd();" type="button">Create Wfd</button><table class="table table-hover table-bordered table-striped"><thead><th>id</th><th>activitiProcessDefinitionId</th><th>activitiProcessDefinitionKey</th><th>name</th><th>active</th><th>action</th></thead><tbody><tr ng-repeat="wfd in $ctrl.workflowDefinitions track by $index"><td>{{ wfd.id }}</td><td>{{ wfd.activitiProcessDefinitionId }}</td><td>{{ wfd.activitiProcessDefinitionKey }}</td><td>{{ wfd.name }}</td><td>{{ wfd.active }}</td><td><button class="btn btn-primary" ng-click="$ctrl.getBpmn(wfd.id);">Download BPMN</button></td></tr></tbody></table></div>');
$templateCache.put('app/entities/prop-admin/audit-basket-console/audit-basket-console.html','<ui-view audit-baskets="$ctrl.auditBaskets" auditbasketsloaded="$ctrl.auditBasketsLoaded" haserror="$ctrl.hasError" class="audit-basket-console" name="audit-basket-console-content" on-create-audit-basket="$ctrl.createAuditBasket($event);" property="$ctrl.propertyId"></ui-view>');
$templateCache.put('app/entities/prop-admin/audit-basket-console/create-audit-basket.html','<div class="panel panel-default"><div class="panel-body"><div class="create-audit-basket"><form name="createAuditBasketForm" ng-submit="$ctrl.saveAuditBasket();" novalidate><div class="create-audit-basket__selector"><div class="selector__header"><h2>Workflows</h2><button id="go-add-workflow-instance" ng-click="$ctrl.goToAddWorkflowInstance();" type="button">&#x002B;</button></div><div class="selector__content"><p ng-if="!$ctrl.selectedWorkflowInstances.length">No workflows have been selected</p><table ng-if="$ctrl.selectedWorkflowInstances.length"><thead><th>Workflow Name</th><th>Due Date</th><th></th></thead><tbody><tr ng-repeat="wfi in $ctrl.selectedWorkflowInstances track by $index"><td>{{ wfi.workflowName }}</td><td>{{ wfi.dueDate }}</td><td><button class="btn btn-danger" ng-click="$ctrl.removeWorkflowInstance(wfi);">x</button></td></tr></tbody></table></div></div><div class="create-audit-basket__selector"><div class="selector__header"><h2>Auditors</h2><button id="go-add-auditor" ng-click="$ctrl.goToAddAuditor();" type="button">&#x002B;</button></div><div class="selector__content"><p ng-if="!$ctrl.selectedAuditors.length">No auditors have been selected</p><table ng-if="$ctrl.selectedAuditors.length"><thead><th>Username</th><th></th></thead><tbody><tr ng-repeat="auditor in $ctrl.selectedAuditors track by $index"><td>{{ auditor.username }}</td><td><button class="btn btn-danger" ng-click="$ctrl.removeAuditor(auditor);" type="button">x</button></td></tr></tbody></table></div></div><div class="create-audit-basket__buttons"><button class="btn btn-primary" id="save-audit-basket" type="submit">Save Audit Basket</button> <button class="btn btn-secondary" id="cancel-audit-basket" type="button" ui-sref="^.list-audit-basket">Cancel</button></div></form></div></div></div>');
$templateCache.put('app/entities/prop-admin/audit-basket-console/list-audit-basket-admin.html','<div class="audit-basket-console"><div class="panel panel-default"><div class="panel-body"><audit-basket-container audit-baskets="$ctrl.auditBaskets" auditbasketsloaded="$ctrl.auditBasketsLoaded" haserror="$ctrl.hasError" on-create-audit-basket="$ctrl.createAuditBasket($event);" property="$ctrl.propertyId"></audit-basket-container></div></div></div>');
$templateCache.put('app/entities/prop-admin/auditor-console/auditor-console.html','<ui-view name="auditor-console-content" class="auditor-console" property-id="$ctrl.propertyId"></ui-view>');
$templateCache.put('app/entities/prop-admin/auditor-console/list-auditor.html','<div class="panel panel-default"><div class="panel-body"><div has-authority="PROP_ADMIN"><div class="row" ng-if="(!$ctrl.auditors.length)"><div class="col-md-4 col-xs-offset-4 center-text"><p>Loading Auditors ...</p></div></div><div class="row" ng-if="(!$ctrl.auditors.length)"><div class="col-md-4 col-xs-offset-4"><div class="progress"><div aria-valuemax="100" aria-valuemin="0" aria-valuenow="90" class="progress-bar progress-bar-striped active" role="progressbar" style="width: 45%"><span class="sr-only">90% Complete</span></div></div></div></div><div class="row" ng-if="($ctrl.auditors.length)"><div class="col-md-8 col-xs-offset-1"><div class="table-scroll-div"><table class="table-standard"><thead><th>Username</th></thead><tbody><tr ng-repeat="a in $ctrl.auditors track by $index"><td>{{a.username}}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/entities/prop-admin/user-console/list-user.html','<user-container class="user-console" users="$ctrl.users" property-id="$ctrl.propertyId" on-remove-property-profile="$ctrl.removePropertyProfile($event);" on-remove-user-group="$ctrl.removeUserGroup($event);" on-add-property-profile="$ctrl.addPropertyProfile($event);" on-add-user-group="$ctrl.addUserGroup($event);"></user-container>');
$templateCache.put('app/entities/prop-admin/user-console/membership-card-list.html','<membership-card ng-repeat="membership in $ctrl.memberships | orderBy:\'propertyId\' track by membership.id" membership="membership"></membership-card>');
$templateCache.put('app/entities/prop-admin/user-console/membership-card.html','<div><span class="card-wrapper"><span>{{$ctrl.membership.profileName}}</span> <span class="property-id">{{$ctrl.membership.propertyId}}</span></span></div>');
$templateCache.put('app/entities/prop-admin/user-console/property-profile-card-list.html','<property-profile-card class="property-profile-card" ng-repeat="propertyProfile in $ctrl.propertyProfiles | removeUnassignableProfiles | orderBy:\'profileName\' track by propertyProfile.id" property-profile="propertyProfile" user="$ctrl.user" on-remove-property-profile="$ctrl.removePropertyProfile($event);"></property-profile-card><div><button class="btn btn-primary btn-xs add-property-profile-button" id="add-property-profile-btn-{{$ctrl.user.id}}" ng-click="$ctrl.goToAddPropertyProfile();">&hellip;</button></div>');
$templateCache.put('app/entities/prop-admin/user-console/property-profile-card.html','<div class="property-profile-card__btn" ng-click="$ctrl.requestRemovePropertyProfile($ctrl.propertyProfile);"></div><div class="property-profile-card__name"><span>{{$ctrl.propertyProfile.profileName}}</span></div>');
$templateCache.put('app/entities/prop-admin/user-console/user-console.html','<ui-view name="user-console-content" class="user-console" users="$ctrl.users"></ui-view>');
$templateCache.put('app/entities/prop-admin/user-console/user-container.html','<div class="panel panel-default"><div class="panel-body"><div class="row" ng-if="(!$ctrl.users.length)"><div class="col-md-4 col-xs-offset-4 center-text"><p>Loading Users ...</p></div></div><div class="row" ng-if="(!$ctrl.users.length)"><div class="col-md-4 col-xs-offset-4"><div class="progress"><div aria-valuemax="100" aria-valuemin="0" aria-valuenow="90" class="progress-bar progress-bar-striped active" role="progressbar" style="width: 45%"><span class="sr-only">90% Complete</span></div></div></div></div><div class="row" ng-if="($ctrl.users.length)"><div class="col-xs-3 col-xs-offset-1 row-top-space"><div class="form-group"><div class="input-group"><div class="input-group-addon"><i class="fa fa-search"></i></div><input class="form-control" ng-model="$ctrl.searchFilter" placeholder="filter" type="search"></div></div></div></div><div class="row" ng-if="($ctrl.users.length)"><div class="col-md-9 col-xs-offset-1"><div class="table-scroll-div-large"><table class="users table-standard"><thead><th class="header-row__selector"><input class="custom-checkbox" id="row-filter" name="row-filter" ng-model="$ctrl.doRowFilter" type="checkbox"><label for="row-filter"></th><th class="header-row__username sortable"><div ng-click="$ctrl.sortType = \'username\'; $ctrl.sortReverse = !$ctrl.sortReverse">Username <span class="fa fa-caret-down" ng-show="$ctrl.sortType == \'username\' && !$ctrl.sortReverse"></span> <span class="fa fa-caret-up" ng-show="$ctrl.sortType == \'username\' && $ctrl.sortReverse"></span></div></th><th class="header-row__enabled"></th><th class="header-row__usergroups">UserGroups</th><th class="header-row__propertyprofiles">PropertyProfiles</th></thead><tbody><tr ng-repeat="user in $ctrl.users | orderBy:$ctrl.sortType:$ctrl.sortReverse | filter:$ctrl.searchFilter | filterUserRows:$ctrl.doRowFilter:$ctrl.filtered track by user.id"><td class="header-row__selector"><input class="custom-checkbox" id="filter_{{user.id}}" name="filter_{{user.id}}" ng-model="$ctrl.filtered[user.id]" type="checkbox"> <label for="filter_{{user.id}}"></td><td>{{user.username}}</td><td></td><td class="data-row__usergroups"><user-group-card-list class="user-group-card-list" on-add-user-group="$ctrl.addUserToUserGroup($event);" on-remove-user-group="$ctrl.removeUserFromUserGroup($event);" property-id="$ctrl.propertyId" user="user" user-groups="user.userGroups"></user-group-card-list></td><td class="data-row__propertyprofiles"><property-profile-card-list class="property-profile-card-list" on-add-property-profile="$ctrl.addUserToPropertyProfile($event);" on-remove-property-profile="$ctrl.removeUserFromPropertyProfile($event);" property-id="$ctrl.propertyId" property-profiles="user.propertyProfiles" user="user"></property-profile-card-list></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/prop-admin/user-console/user-group-card-list.html','<user-group-card class="user-group-card" ng-repeat="userGroup in $ctrl.userGroups | orderBy:\'name\' track by userGroup.id" user-group="userGroup" user="$ctrl.user" on-remove-user-group="$ctrl.removeUserGroup($event);"></user-group-card><div><button class="btn btn-primary btn-xs add-user-group-button" ng-click="$ctrl.goToAddUserGroup();">&hellip;</button></div>');
$templateCache.put('app/entities/prop-admin/user-console/user-group-card.html','<div class="user-group-card__btn" ng-click="$ctrl.requestRemoveUserGroup($ctrl.userGroup);"></div><div class="user-group-card__name"><span>{{$ctrl.userGroup.name}}</span></div>');
$templateCache.put('app/entities/shared/calendar-rep/calendar-rep.html','<div class="calendar"><div class="calendar-nav"><i class="fa fa-angle-left" ng-click="$ctrl.previous()"></i> <span>{{$ctrl.navMonth.format("MMMM, YYYY")}}</span> <i class="fa fa-angle-right" ng-click="$ctrl.next()"></i></div><div class="week names"><span class="day">Sun</span> <span class="day">Mon</span> <span class="day">Tue</span> <span class="day">Wed</span> <span class="day">Thu</span> <span class="day">Fri</span> <span class="day">Sat</span></div><div class="week" ng-repeat="week in $ctrl.weeks"><div class="day" ng-class="{active: day.isToday}" ng-repeat="day in week.days" style="position: relative"><span style="position: absolute;top:-27px;left:2px">{{day.date.format(\'DD\')}}</span><summary-card-rep daily-task-count="$ctrl.processedData[day.date.format(\'YYYY-MM-DD\')].data.dailyTaskCount" day="day.name" ng-if="$ctrl.processedData[day.date.format(\'YYYY-MM-DD\')]" non-daily-task-count="$ctrl.processedData[day.date.format(\'YYYY-MM-DD\')].data.nonDailyTaskCount" on-select-detail-date="$ctrl.selectDetailDate(date)" summary="$ctrl.processedData[day.date.format(\'YYYY-MM-DD\')].summary"></summary-card-rep></div></div></div>');
$templateCache.put('app/entities/shared/calendar-rep/summary-card-rep.html','<div class="summary-card-container"><i class="fa fa-2x summary-card" ng-class="$ctrl.summary" ng-click="$ctrl.selectDetailDate($ctrl.day)"></i><div class="daily-task-count" ng-if="$ctrl.dailyTaskCount">{{$ctrl.dailyTaskCount}}</div><div class="non-daily-task-count" ng-if="$ctrl.nonDailyTaskCount">{{$ctrl.nonDailyTaskCount}}</div></div>\'');
$templateCache.put('app/entities/shared/create-comment-dialog/mention-detail.html','<div><span class="card-wrapper"><span>{{ $ctrl.getUsernameFromId($ctrl.mention.userId) }}</span> <span><a href="" ng-click="$ctrl.delete()"><i class="fa fa-times fa-lg"></i></a></span></span></div>');
$templateCache.put('app/entities/shared/create-comment-dialog/mention-input.html','<select id="newMentionUserId" ng-model="$ctrl.userId" ng-options="candidate.id as candidate.username for candidate in $ctrl.candidates | orderBy:\'username\' track by candidate.id"><option value="">-- choose a user to mention --</option></select> <button ng-click="$ctrl.addMention();$ctrl.userId=\'\'" ng-disabled="$ctrl.userId === \'\'" type="button">Add Mention</button>');
$templateCache.put('app/entities/shared/create-comment-dialog/mention-list.html','<mention-detail id-to-user-lookup="$ctrl.candidates" mention="mention" ng-repeat="mention in $ctrl.mentions track by mention.userId" on-delete-mention-user-id="$ctrl.deleteMention(userId)"></mention-detail><mention-input candidates="$ctrl.filteredCandidates" on-add-mention-user-id="$ctrl.addMention(userId)"></mention-input>');
$templateCache.put('app/entities/shared/create-comment-dialog/shared-date-create-comment-dialog.html','<form name="commentForm" ng-submit="$ctrl.save()" novalidate role="form" show-validation><div class="modal-header"><button aria-hidden="true" class="close" data-dismiss="modal" ng-click="$ctrl.clear()" type="button">&times;</button><h4 class="modal-title">Add Comment to Document Record</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" for="comment">Comment ({{ 256 - $ctrl.newComment.text.length }})</label> <textarea class="form-control" id="comment" maxlength="256" name="comment" ng-model="$ctrl.newComment.text" required>\n      </textarea></div><mention-list candidates="$ctrl.candidates" mentions="$ctrl.newComment.mentions" on-add-mention="$ctrl.addMention(mention)" on-delete-mention="$ctrl.deleteMention(mention)"></mention-list><div class="modal-footer"><button class="btn btn-default" data-dismiss="modal" id="clearCommentButton" ng-click="$ctrl.clear()" type="button"><i class="fas fa-ban"></i> &nbsp;Cancel</button> <button class="btn btn-primary" id="saveCommentButton" ng-disabled="commentForm.$invalid || $ctrl.isSaving" type="submit"><i class="fas fa-download"></i> &nbsp;Save</button></div></div></form>');
$templateCache.put('app/entities/shared/create-supporting-document-dialog/shared-date-create-supporting-document-dialog.html','<form name="supportingDocumentForm" ng-submit="$ctrl.save()" novalidate role="form" show-validation><div class="modal-header"><button aria-hidden="true" class="close" data-dismiss="modal" ng-click="$ctrl.clear()" type="button">&times;</button><h4 class="modal-title">Add Supporting Document to Document Record</h4></div><div class="modal-body"><div class="form-group"><input accept="application/pdf" class="form-control" name="file" ng-model="$ctrl.newSupportingDoc.selectedFile" ngf-max-size="4MB" ngf-select required type="file"><div class="help-block alert alert-danger" ng-if="supportingDocumentForm.file.$touched && supportingDocumentForm.file.$invalid" ng-messages="supportingDocumentForm.file.$error"><p ng-message="maxSize">The file is too large (max 4MB)</p><p ng-message="required">A file is required</p></div></div><div class="modal-footer"><button class="btn btn-default" data-dismiss="modal" id="clearSupportingDocumentButton" ng-click="$ctrl.clear()" type="button"><i class="fas fa-ban"></i>&nbsp;Cancel</button> <button class="btn btn-primary" id="saveSupportingDocumentButton" ng-disabled="supportingDocumentForm.$invalid || $ctrl.isSaving" type="submit"><i class="fas fa-download"></i> &nbsp;Save</button></div></div></form>');
$templateCache.put('app/entities/shared/primary-document-viewer/primary-document-viewer.html','<div class="panel-body-j"><div class="toolbar-container"><div class="toolbar-default"><button class="btn btn-default cursor" data-tooltype="cursor"><i class="fa fa-mouse-pointer" style="pointer-events: none"></i></button> <button class="btn btn-default" id="rotateButtonRight"><i class="fa fa-rotate-right"></i></button> <button class="btn btn-default" id="rotateButtonLeft"><i class="fa fa-rotate-left"></i></button> <select class="btn btn-default" id="scale"><option value=".5">50%</option><option selected="selected" value="1">100%</option><option value="1.33">133%</option><option value="1.5">150%</option><option value="2">200%</option></select></div><div class="toolbar-edit" has-authority="REVIEWER"><span class="divider">&nbsp;</span> <button class="rectangle btn btn-default" data-tooltype="area" ng-click="$ctrl.editClick()"><i class="fa fa-pencil-square-o" style="pointer-events:none"></i></button> <button class="comment btn btn-default" data-tooltype="point" ng-click="$ctrl.commentClick()"><i class="fa fa-commenting" style="pointer-events:none"></i></button> <span class="divider">&nbsp;</span> <button class="btn btn-default" id="saveAnnotationsButton" ng-class="$ctrl.appliedSaveButtonClass()" ng-click="$ctrl.saveAnnotations()">Save</button> <button class="toolbar-btn" id="clearUnsavedAnnotationsButton" ng-click="$ctrl.clearUnsavedAnnotations()">Clear</button> <span class="pull-right saving-text" ng-if="$ctrl.isSaving">Saving...</span></div></div><div id="content-wrapper"><div ng-if="!$ctrl.data" style="padding: 5px">No Primary Document associated with this Workflow</div><div annotations-to-render="$ctrl.annotationsToRender" class="pdfViewer" data="$ctrl.data" document-id="$ctrl.documentId" id="viewer" issaving="$ctrl.isSaving" my-canvas ng-if="$ctrl.data" update-ui="$ctrl.update"></div></div></div>');
$templateCache.put('app/entities/shared/reporter-month/reporter-month.html','<div class="panel panel-default panel-fixed-width" ng-if="$ctrl.propertyId"><div class="panel-body"><calendar-rep get-summary-data-cb="$ctrl.fetchReporterSummaryData(start, end)" on-select-detail-date="$ctrl.selectReporterDetailDate($event);" on-update-pivot-date="$ctrl.updatePivotDate(timestamp)" pivot-date="$ctrl.pivotDate" selected-property-id-refresh="$ctrl.propertyId"></calendar-rep></div></div>');
$templateCache.put('app/entities/shared/reviewer-month/inbox.html','<section class="inbox-header"><div class="unclaimed-summary"><span class="unclaimed-summary-title"><strong>Unclaimed</strong></span> <span class="unclaimed-summary-count">{{$ctrl.inboxTasks.length}}</span></div></section><section class="inbox-detail"><button class="btn btn-primary" ng-click="$ctrl.requestClaimAll()" ng-disabled="!$ctrl.inboxTasks.length" type="button">claim all</button><table class="table-striped" style="width: 100%;"><thead><th class="sortable"><div ng-click="$ctrl.sortType = \'processDefinitionName\'; $ctrl.sortReverse = !$ctrl.sortReverse">workflow name <span class="fa fa-caret-down" ng-show="$ctrl.sortType == \'processDefinitionName\' && !$ctrl.sortReverse"></span> <span class="fa fa-caret-up" ng-show="$ctrl.sortType == \'processDefinitionName\' && $ctrl.sortReverse"></span></div></th><th class="sortable"><div ng-click="$ctrl.sortType = \'groupName\'; $ctrl.sortReverse = !$ctrl.sortReverse">group name <span class="fa fa-caret-down" ng-show="$ctrl.sortType == \'groupName\' && !$ctrl.sortReverse"></span> <span class="fa fa-caret-up" ng-show="$ctrl.sortType == \'groupName\' && $ctrl.sortReverse"></span></div></th><th class="sortable"><div ng-click="$ctrl.sortType = \'dueDate\'; $ctrl.sortReverse = !$ctrl.sortReverse">due date <span class="fa fa-caret-down" ng-show="$ctrl.sortType == \'dueDate\' && !$ctrl.sortReverse"></span> <span class="fa fa-caret-up" ng-show="$ctrl.sortType == \'dueDate\' && $ctrl.sortReverse"></span></div></th><th>Daily State</th><th>action</th></thead><tbody><tr ng-repeat="it in $ctrl.inboxTasks | orderBy:$ctrl.sortType:$ctrl.sortReverse"><td>{{it.processDefinitionName}}</td><td>{{it.group.name}}</td><td>{{it.dueDateString}}</td><td><span class="task" ng-class="it.dailyState === \'DAILY\' ? \'task--daily\' : \'task--non-daily\'"></span></td><td><button class="btn" ng-click="$ctrl.claim(it)">claim</button></td></tr></tbody></table></section>');
$templateCache.put('app/entities/shared/reviewer-month/reviewer-month.html','<main class="col-sm-7 tyall-panel calendar-panel" ng-if="$ctrl.propertyId"><div class=""><calendar-rep force-refresh="$ctrl.forceRefresh" get-summary-data-cb="$ctrl.fetchReviewerSummaryData(start, end)" on-select-detail-date="$ctrl.selectReviewerDetailDate($event);" on-update-pivot-date="$ctrl.updatePivotDate(timestamp)" pivot-date="$ctrl.pivotDate" selected-property-id-refresh="$ctrl.propertyId"></calendar-rep></div></main><aside class="group-inbox col-sm-5" ng-if="$ctrl.propertyId"><inbox account="$ctrl.account" on-claim="$ctrl.onClaim($event)" selected-property-id-refresh="$ctrl.propertyId"></inbox></aside>');
$templateCache.put('app/entities/shared/task/task-list.html','<div class="container-fluid"><div class="row panel-top-padding"><div class="col-md-1"><a class="task-list__nav-item" ng-click="$ctrl.doReturn()"><i class="fa fa-arrow-circle-left fa-2x"></i></a></div><div class="col-md-6 col-md-offset-2"><div class="panel panel-default panel-fixed-width panel-top-padding"><div class="panel-heading"><div class="task-list__nav"><button class="btn btn-iteration task-list__nav-item" ng-click="$ctrl.doPrevious();">Previous</button> <span class="due-date" datetime="{{ $ctrl.taskDate }}"><h3>{{ $ctrl.formatedDate }}</h3></span><button class="btn btn-iteration task-list__nav-item" ng-click="$ctrl.doNext();">Next</button></div></div><div class="panel-body"><div class="container-fluid"><div class="task-list"><ul class=""><li class="task-card" ng-repeat="task in $ctrl.tasks | orderBy:[\'completed\', \'id\'] track by $index"><div class="container-fluid"><div class="row"><div class="col-md-1 task-card__header icon-padding" ng-if="!task.primaryDocument"><a ng-click="$ctrl.goToUploadPrimaryDocument(task)" ng-if="!task.primaryDocument"><div class="nav-tab-label"><i class="fas fa-upload"></i></div></a></div><div class="col-md-8" ng-class="task.primaryDocument ? \'col-md-offset-2\' : \'col-md-offset-1\'" ng-click="$ctrl.goToTaskDetail(task)"><h5>{{ task.processDefinitionName }}</h5></div><div class="col-md-1 icon-padding"><i class="fa fa-1x" ng-class="task.completed ? \'fa-check text-success\' : \'fa-close text-danger\'"></i></div></div><div ng-if="task.lastReviewedBy"><div class="task-card__history"><div class="row"><div class="col-md-2">Date:</div><div class="col-md-9">{{ task.lastReviewTimestamp }}</div></div><div class="row"><div class="col-md-2">User:</div><div class="col-md-9">{{ task.lastReviewedBy }}</div></div></div></div></div></li></ul></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/shared/task/task.html','<div class="nav-back"><a ng-click="$ctrl.doReturn()"><i class="fa fa-arrow-circle-left fa-2x"></i></a></div><main bs-loading-overlay class="bs-loading-container" id="document-viewer" ng-class="{\'side-nav-open\': $ctrl.toggle}"><div class="panel-header"><h2>Selected Workflow: {{$ctrl.currentTaskDTO.processDefinitionName}}</h2></div><primary-document-viewer account="$ctrl.account" data="$ctrl.currentFileData" document-id="$ctrl.currentTaskDTO.documentRecord.id" on-save-annotations="$ctrl.saveAnnotations(annotations)" saved-annotations="$ctrl.currentTaskDTO.documentRecord.uploadFile.annotations"></primary-document-viewer><div class="panel-footer"><div class="action-container" style="display: flex"><form ng-submit="$ctrl.doPositiveReview()"><button class="btn btn-primary" id="positiveReviewButton" is-assignee="{{$ctrl.currentTaskDTO.assignee}}" ng-disabled="$ctrl.currentTaskDTO.completed || !$ctrl.currentTaskDTO.id || !$ctrl.currentTaskDTO.documentRecord.uploadFile" style="margin: 5px;" type="submit">Review</button></form><button class="btn btn-primary" id="uploadPrimaryDocumentButton" is-assignee="{{$ctrl.currentTaskDTO.assignee}}" ng-click="$ctrl.goToUploadPrimaryDocument();" ng-hide="!!$ctrl.currentTaskDTO.documentRecord.uploadFile" style="margin: 5px;" type="button">Upload PD</button></div></div></main><aside class="side-nav" id="side-nav" ng-class="{\'side-nav-open\': $ctrl.toggle}"><div class="side-nav-toggle"><a href="javascript:void(0)" ng-click="$ctrl.toggleNav()"><img src="content/images/expand.svg"></a></div><section class="side-nav-wrapper"><article id="wfi-summary-list"><div class=""><div>Due Date</div><h2 class="due-date" style="margin-top: 0"><p class="">{{ $ctrl.formatedDueDate }}</p></h2></div><hr><div class="panel-body"><wfi-selector current-task-dto="$ctrl.currentTaskDTO" on-select-task="$ctrl.selectTask(task)" tasks="$ctrl.tasks"></wfi-selector></div></article><article><wfi-detail-tabs current-task-dto="$ctrl.currentTaskDTO" on-create-comment="$ctrl.createComment($event);" on-create-supporting-document="$ctrl.createSupportingDocument($event);"></wfi-detail-tabs></article></section></aside>');
$templateCache.put('app/entities/shared/tasklist-primary-document-dialog/tasklist-primary-document-dialog.html','<form name="primaryDocumentForm" ng-submit="$ctrl.save()" novalidate role="form" show-validation><div class="modal-header"><button aria-hidden="true" class="close" data-dismiss="modal" ng-click="$ctrl.clear()" type="button">&times;</button><h4 class="modal-title">Upload Supporting Document to Document Record</h4></div><div class="modal-body"><div class="form-group"><input accept="application/pdf" class="form-control" name="file" ng-model="$ctrl.newPrimaryDocument" ngf-max-size="7MB" ngf-select required type="file"><div class="help-block alert alert-danger" ng-if="primaryDocumentForm.file.$touched && primaryDocumentForm.file.$invalid" ng-messages="primaryDocumentForm.file.$error"><p ng-message="maxSize">The file is too large (max 7MB)</p><p ng-message="required">A file is required</p></div></div><div class="modal-footer"><button class="btn btn-default" data-dismiss="modal" id="clearPrimaryDocumentButton" ng-click="$ctrl.clear()" type="button"><i class="fas fa-ban"></i>&nbsp;Cancel</button> <button class="btn btn-primary" id="savePrimaryDocumentButton" ng-disabled="primaryDocumentForm.$invalid || $ctrl.isSaving" type="submit"><i class="fas fa-download"></i> &nbsp;Save</button></div></div></form>');
$templateCache.put('app/entities/shared/upload-primary-document-dialog/upload-primary-document-dialog.html','<form name="primaryDocumentForm" ng-submit="$ctrl.save()" novalidate role="form" show-validation><div class="modal-header"><button aria-hidden="true" class="close" data-dismiss="modal" ng-click="$ctrl.clear()" type="button">&times;</button><h4 class="modal-title">Upload Supporting Document to Document Record</h4></div><div class="modal-body"><div class="form-group"><input accept="application/pdf" class="form-control" name="file" ng-model="$ctrl.newPrimaryDocument" ngf-max-size="7MB" ngf-select required type="file"><div class="help-block alert alert-danger" ng-if="primaryDocumentForm.file.$touched && primaryDocumentForm.file.$invalid" ng-messages="primaryDocumentForm.file.$error"><p ng-message="maxSize">The file is too large (max 7MB)</p><p ng-message="required">A file is required</p></div></div><div class="modal-footer"><button class="btn btn-default" data-dismiss="modal" id="clearPrimaryDocumentButton" ng-click="$ctrl.clear()" type="button"><i class="fas fa-ban"></i>&nbsp;Cancel</button> <button class="btn btn-primary" id="savePrimaryDocumentButton" ng-disabled="primaryDocumentForm.$invalid || $ctrl.isSaving" type="submit"><i class="fas fa-download"></i> &nbsp;Save</button></div></div></form>');
$templateCache.put('app/entities/shared/wfi-selector/comment-console.html','<table class="table table-striped table-fixed"><thead><th class="col-sm-2" data-toggle="tooltip" title="Timestamp"><i class="fa fa-clock-o fa-lg"></i></th><th class="col-sm-2" data-toggle="tooltip" title="Author"><i class="fa fa-user fa-lg"></i></th><th class="col-sm-6" data-toggle="tooltip" title="Text"><i class="fa fa-quote-left fa-lg"></i></th><th class="col-sm-2" data-toggle="tooltip" title="Mentions"><i class="fa fa-at fa-lg"></i></th></thead><tbody><tr ng-repeat="comment in $ctrl.commentData | orderBy:\'createdDate\'"><td>{{comment.createdDate | date:\'MMM-dd HH:mm\'}}</td><td>{{comment.createdBy}}</td><td>{{comment.text}}</td><td><ul class="mention-list"><li ng-repeat="mention in comment.mentions">{{$ctrl.idToUserLookup[mention.userId].email}}</li></ul></td></tr></tbody></table>');
$templateCache.put('app/entities/shared/wfi-selector/wfi-detail-tabs.html','<article id="wfi-detail" ng-if="$ctrl.currentTaskDto.id"><uib-tabset active="active"><uib-tab id="commentTab" index="0"><uib-tab-heading>Comments&nbsp;<span class="tabdata__counter">{{ $ctrl.currentTaskDto.documentRecord.comments.length }}</span></uib-tab-heading><div class="panel panel-default" id="selected-instance-comments"><div class="panel-body"><comment-console comment-data="$ctrl.currentTaskDto.documentRecord.comments" property-id="$ctrl.currentTaskDto.propertyId"></comment-console></div><div class="panel-footer"><button class="btn btn-primary" id="addCommentButton" ng-click="$ctrl.goToCreateComment();" ng-disabled="!$ctrl.currentTaskDto.documentRecord" type="button">Create Comment</button></div></div></uib-tab><uib-tab id="supportingFilesTab" index="1"><uib-tab-heading>Supporting Documents&nbsp;<span class="tabdata__counter">{{ $ctrl.currentTaskDto.documentRecord.supportingFiles.length }}</span></uib-tab-heading><div class="panel panel-default" id="selected-instance-supporting-docs"><div class="panel-body"><table class="table table-striped"><thead><th class="col-sm-2" data-toggle="tooltip" title="Timestamp"><i class="fa fa-clock-o fa-lg"></i></th><th class="col-sm-2" data-toggle="tooltip" title="Author"><i class="fa fa-user fa-lg"></i></th><th class="col-sm-7" data-toggle="tooltip" title="Filename"><i class="fa fa-file-text-o fa-lg"></i></th><th class="col-sm-1">Actions</th></thead><tbody><tr ng-repeat="file in $ctrl.currentTaskDto.documentRecord.supportingFiles | orderBy:\'createdDate\'"><td>{{file.createdDate | date:\'MMM-dd HH:mm\'}}</td><td>{{file.createdBy}}</td><td>{{file.filename}}</td><td><a class="btn btn-primary btn-xs" ng-click="$ctrl.downloadFile(file)">Download</a></td><td></td></tr></tbody></table></div><div class="panel-footer"><button class="btn btn-primary" id="addDocumentButton" ng-click="$ctrl.goToCreateSupportingDocument()" ng-disabled="!$ctrl.currentTaskDto.documentRecord">Create Supporting Document</button></div></div></uib-tab></uib-tabset></article>');
$templateCache.put('app/entities/shared/wfi-selector/wfi-selector.html','<table class="table"><thead><tr><th>Workflow Name</th><th data-toggle="tooltip" title="Assignee"><i class="fa fa-user fa-lg"></i></th><th data-toggle="tooltip" title="status"><i class="fa fa-asterisk fa-lg"></i></th></tr></thead><tbody><tr ng-class="{\'selected-row\' : task.id == $ctrl.currentTaskDto.id}" ng-click="$ctrl.selectTask(task)" ng-repeat="task in $ctrl.tasks | orderBy:[\'completed\',\'id\']" style="cursor:pointer"><td>{{task.processDefinitionName}}<br>{{task.lastReviewedBy}}<br>{{ task.lastReviewTimestamp != \'Invalid date\' ? (task.lastReviewTimestamp | date:\'yyyy-MMM-dd HH:mm\') : \'\' }}</td><td>{{task.assignee}}</td><td><i class="fa fa-2x" ng-class="task.completed ? \'fa-check text-success\' : \'fa-close text-danger\'"></i></td></tr></tbody></table>');
$templateCache.put('app/entities/prop-admin/audit-basket-console/audit-basket-viewer/audit-basket-container.html','<div class="audit-basket-container" ng-if="$ctrl.property != null"><div class="row" ng-if="$ctrl.auditBaskets.length == null"><div class="col-md-4 col-xs-offset-4 center-text"><p>Loading Audit Baskets ...</p></div></div><div class="row" ng-if="($ctrl.auditBaskets == null)"><div class="col-md-4 col-xs-offset-4"><div class="progress"><div aria-valuemax="100" aria-valuemin="0" aria-valuenow="90" class="progress-bar progress-bar-striped active" role="progressbar" style="width: 45%"><span class="sr-only">90% Complete</span></div></div></div></div><div class="row" ng-if="($ctrl.auditBaskets.length > 0)"><div class="col-md-4 col-xs-offset-4"><div class="table-scroll-div-large"><table class="table-standard"><thead><th>ID</th><th>Description</th><th>Created By</th><th></th></thead><tbody><tr ng-repeat="ab in $ctrl.auditBaskets track by $index"><td>{{ ab.id }}</td><td>{{ }}</td><td>{{ ab.createdBy }}</td><td><button class="btn btn-primary" id="details-{{$index}}" ng-click="$ctrl.goToReadAuditBasket(ab);" type="button">Details</button></td></tr></tbody></table></div></div></div><div class="row" ng-if="$ctrl.auditBaskets.length == 0"><div class="col-md-8 col-xs-offset-2"><div class="alert alert-info center-text" role="alert">You currently have no audit baskets! <span has-authority="PROP_ADMIN">Please create one below</span></div></div></div><div class="row" ng-if="$ctrl.hasError"><div class="col-md-8 col-xs-offset-2"><div class="alert alert-danger center-text" role="alert">Unable to load audit baskets, please try again ...</div></div></div><div class="row row-top-space" has-authority="PROP_ADMIN" ng-if="($ctrl.auditBaskets!=null)"><div class="col-md-4 col-xs-offset-4"><button class="btn btn-primary" id="go-create-audit-basket" ng-click="$ctrl.goToCreateAuditBasket();" type="button">Create Audit Basket</button></div></div></div>');
$templateCache.put('app/entities/prop-admin/audit-basket-console/dialogs/add-auditor/add-auditor-dialog.html','<div class="add-auditor-dialog"><div class="modal-header"><button aria-hidden="true" class="close" data-dismiss="modal" ng-click="$ctrl.clear()" type="button">&times;</button><h4 class="modal-title">Add Auditors to Audit Basket</h4></div><div class="modal-body"><div class="row"><div class="col-xs-5 col-xs-offset-4 workflow-def-container"><div class="tableScroll"><table><thead><th></th><th>Username</th></thead><tbody><tr ng-repeat="auditor in $ctrl.availableAuditors track by $index"><td><input name="checkbox-{{$index}}" ng-model="auditor.selected" type="checkbox"></td><td>{{ auditor.username }}</td></tr></tbody></table></div></div></div></div><div class="modal-footer"><button class="btn btn-default" data-dismiss="modal" id="clearButton" ng-click="$ctrl.clear()" type="button"><i class="fas fa-ban"></i>&nbsp;Cancel</button> <button class="btn btn-primary" id="addButton" ng-click="$ctrl.save();" ng-disabled="editForm.$invalid || $ctrl.isSaving" type="button"><i class="fas fa-download"></i> &nbsp;Add</button></div></div>');
$templateCache.put('app/entities/prop-admin/audit-basket-console/dialogs/add-workflow-instance/add-workflow-instance-dialog.html','<div class="add-workflow-instance-dialog"><div class="modal-header"><button aria-hidden="true" class="close" data-dismiss="modal" ng-click="$ctrl.clear()" type="button">&times;</button><h4 class="modal-title">Add Workflow Instances to Audit Basket</h4></div><div class="modal-body"><div class="container"><form name="workflowInstanceForm" ng-submit="$ctrl.doSearch();" validate><div class="row"><div class="col-md-2 col-xs-offset-1"><label>Start Date</label> <input id="startDate" name="startDate" ng-model="$ctrl.startDate" placeholder="search start date" type="date" required="required"></div><div class="col-md-2 col-xs-offset-1"><label>End Date</label> <input id="endDate" name="endDate" ng-model="$ctrl.endDate" placeholder="search end date" type="date" required="required"></div></div><div class="row"><div class="col-md-5 col-xs-offset-1 workflow-def-container" ng-if="$ctrl.workflowInstances.length == 0"><div class="table-scroll-div"><table class="workflow-table"><thead><th class="tableFixedHeading"></th><th class="tableFixedHeading">Name</th></thead><tbody><tr ng-repeat="wfd in $ctrl.availableWorkflowDefinitions track by $index"><td class="input-cell"><input ng-model="wfd.selected" type="checkbox"></td><td>{{wfd.name}}</td></tr></tbody></table></div></div><div class="col-md-6 col-xs-offset-1 workflow-def-container" ng-if="$ctrl.workflowInstances.length > 0"><div class="tableScroll"><table class="workflow-table"><thead><th class="tableFixedHeading"></th><th class="tableFixedHeading">Workflow Definition Name</th><th class="tableFixedHeading">Due Date</th><th class="tableFixedHeading">Status</th></thead><tbody><tr ng-repeat="wfi in $ctrl.workflowInstances track by $index"><td><input ng-model="wfi.selected" type="checkbox"></td><td>{{wfi.workflowName}}</td><td>{{wfi.dueDate}}</td><td>{{wfi.status}}</td></tr></tbody></table></div></div></div><div class="row" ng-if="$ctrl.workflowInstances.length == 0"><div class="col-md-4 col-sm-offset-1"><div class="form-button-container" style="padding-top: 20px; padding-bottom: 20px"><button class="btn btn-primary" id="searchButton" type="submit">Search</button> <button class="btn btn-secondary" ng-click="$ctrl.startDate = $ctrl.endDate = $ctrl.workflowInstances = null;" type="button">Clear</button></div></div></div></form></div><div class="modal-footer"><div class="row"><div class="col-xs-2"><button class="btn btn-default" data-dismiss="modal" id="backButton" ng-click="$ctrl.back()" type="button"><i class="fas fa-back"></i>&nbsp;Back</button></div><div class="col-xs-9 col-xs-offset-1"><button class="btn btn-default" data-dismiss="modal" id="clearButton" ng-click="$ctrl.clear()" type="button"><i class="fas fa-ban"></i>&nbsp;Cancel</button> <button class="btn btn-primary" id="addButton" ng-click="$ctrl.save();" ng-disabled="editForm.$invalid || $ctrl.isSaving" type="button"><i class="fas fa-download"></i> &nbsp;Add</button></div></div></div></div></div>');
$templateCache.put('app/entities/prop-admin/user-console/dialogs/add-user-group/add-user-group-dialog.html','<form name="editForm" role="form" novalidate ng-submit="$ctrl.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="$ctrl.clear()">&times;</button><h4 class="modal-title">Add User to UserGroup</h4></div><div class="modal-body"><div>Add user <b>{{ $ctrl.user.username }}</b> to following UserGroup:</div><div class="form-group"><select class="form-control" id="userGroup" name="userGroup" ng-model="$ctrl.userGroup" ng-options="userGroup as userGroup.name for userGroup in $ctrl.availableGroups | orderBy:name" required><option value="" disabled="disabled">-- select a user group --</option></select><div ng-show="editForm.userGroup.$invalid"><p class="help-block" ng-show="editForm.userGroup.$error.required">This field is required.</p></div></div><div class="modal-footer"><button id="clearButton" type="button" class="btn btn-default" data-dismiss="modal" ng-click="$ctrl.clear()"><i class="fas fa-ban"></i>&nbsp;Cancel</button> <button type="submit" ng-disabled="editForm.$invalid || $ctrl.isSaving" class="btn btn-primary"><i class="fas fa-download"></i> &nbsp;Add</button></div></div></form>');
$templateCache.put('app/entities/prop-admin/user-console/dialogs/add-property-profile/add-property-profile-dialog.html','<form name="editForm" role="form" novalidate ng-submit="$ctrl.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="$ctrl.clear()">&times;</button><h4 class="modal-title">Add User to Property Profile</h4></div><div class="modal-body"><div>Add user <b>{{ $ctrl.user.username }}</b> to following property-profile:</div><div class="form-group"><select class="form-control" id="propertyProfile" name="propertyProfile" ng-model="$ctrl.propertyProfile" ng-options="propertyProfile as propertyProfile.profileName for propertyProfile in $ctrl.availablePropertyProfiles | orderBy:profileName" required><option value="" disabled="disabled">-- select a property profile --</option></select><div ng-show="editForm.propertyProfile.$invalid"><p class="help-block" ng-show="editForm.propertyProfile.$error.required">This field is required.</p></div></div><div class="modal-footer"><button id="clearButton" type="button" class="btn btn-default" data-dismiss="modal" ng-click="$ctrl.clear()"><i class="fas fa-ban"></i>&nbsp;Cancel</button> <button type="submit" ng-disabled="editForm.$invalid || $ctrl.isSaving" class="btn btn-primary"><i class="fas fa-download"></i> &nbsp;Add</button></div></div></form>');}]);})();